var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return n(r, t, e, u, a, i, o, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    function A8(n, r, t, e, u, a, i, o, c) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, o, c) : n(r)(t)(e)(u)(a)(i)(o)(c);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, l(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = o(n, r, 0, e); u && (t = e.pop()); u = o(t.a, t.b, 0, e));
        return u;
    }
    function o(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return e.push(l(n, r)), !0;
        for(var u in 0 > n.$ && (n = at(n), r = at(r)), n)if (!o(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var c = F2(i), f = F2(function(n, r) {
        return !i(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var d = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? ct : t ? ot : it;
    });
    function l(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function b(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function p(n) {
        return n;
    }
    function v(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var m = F2(h);
    function h(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = _(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = _(n.a, r);
        return t;
    }
    var g = {
        $: 0
    };
    function _(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var w = F2(_);
    function $(n) {
        for(var r = g, t = n.length; t--;)r = _(n[t], r);
        return r;
    }
    function x(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var C = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return $(e);
    }), y = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), I = Math.ceil, N = Math.floor, E = Math.round, z = Math.log, K = F2(function(n, r) {
        return n + r;
    }), k = F2(function(n, r) {
        return n + r;
    }), A = F2(function(n, r) {
        return r.split(n);
    }), H = F2(function(n, r) {
        return r.join(n);
    }), S = F3(function(n, r, t) {
        return t.slice(n, r);
    }), M = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(p(e))) return !1;
        }
        return !0;
    }), F = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), P = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), D = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return g;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return $(u);
    });
    function L(n) {
        return {
            $: 2,
            b: n
        };
    }
    var B = L(function(n) {
        return "number" != typeof n ? nn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? bt(n) : !isFinite(n) || n % 1 ? nn("an INT", n) : bt(n);
    }), R = L(function(n) {
        return "boolean" == typeof n ? bt(n) : nn("a BOOL", n);
    }), U = (L(function(n) {
        return "number" == typeof n ? bt(n) : nn("a FLOAT", n);
    }), L(function(n) {
        return bt(n);
    }), L(function(n) {
        return "string" == typeof n ? bt(n) : n instanceof String ? bt(n + "") : nn("a STRING", n);
    })), V = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function T(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var j = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), O = F2(function(n, r) {
        return T(n, [
            r
        ]);
    }), G = F3(function(n, r, t) {
        return T(n, [
            r,
            t
        ]);
    }), q = F8(function(n, r, t, e, u, a, i, o) {
        return T(n, [
            r,
            t,
            e,
            u,
            a,
            i,
            o
        ]);
    }), W = F2(function(n, r) {
        try {
            return Y(n, JSON.parse(r));
        } catch (n) {
            return ft(A2(st, "This is not valid JSON! " + n.message, r));
        }
    }), J = F2(function(n, r) {
        return Y(n, r);
    });
    function Y(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? bt(n.c) : nn("null", r);
            case 3:
                return Q(r) ? Z(n.b, r, $) : nn("a LIST", r);
            case 4:
                return Q(r) ? Z(n.b, r, X) : nn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return nn("an OBJECT with a field named `" + t + "`", r);
                var e = Y(n.b, r[t]);
                return oe(e) ? e : ft(A2(dt, t, e.a));
            case 7:
                var u = n.e;
                return Q(r) ? r.length > u ? (e = Y(n.b, r[u]), oe(e) ? e : ft(A2(lt, u, e.a))) : nn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : nn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || Q(r)) return nn("an OBJECT", r);
                var a = g;
                for(var i in r)if (Object.prototype.hasOwnProperty.call(r, i)) {
                    if (e = Y(n.b, r[i]), !oe(e)) return ft(A2(dt, i, e.a));
                    a = _(l(i, e.a), a);
                }
                return bt(Ft(a));
            case 9:
                for(var o = n.f, c = n.g, f = 0; c.length > f; f++){
                    if (e = Y(c[f], r), !oe(e)) return e;
                    o = o(e.a);
                }
                return bt(o);
            case 10:
                return e = Y(n.b, r), oe(e) ? Y(n.h(e.a), r) : e;
            case 11:
                for(var s = g, d = n.g; d.b; d = d.b){
                    if (e = Y(d.a, r), oe(e)) return e;
                    s = _(e.a, s);
                }
                return ft(pt(Ft(s)));
            case 1:
                return ft(A2(st, n.a, r));
            case 0:
                return bt(n.a);
        }
    }
    function Z(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = Y(n, r[a]);
            if (!oe(i)) return ft(A2(lt, a, i.a));
            u[a] = i.a;
        }
        return bt(t(u));
    }
    function Q(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function X(n) {
        return A2(ie, n.length, function(r) {
            return n[r];
        });
    }
    function nn(n, r) {
        return ft(A2(st, "Expecting " + n, r));
    }
    function rn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return rn(n.b, r.b);
            case 6:
                return n.d === r.d && rn(n.b, r.b);
            case 7:
                return n.e === r.e && rn(n.b, r.b);
            case 9:
                return n.f === r.f && tn(n.g, r.g);
            case 10:
                return n.h === r.h && rn(n.b, r.b);
            case 11:
                return tn(n.g, r.g);
        }
    }
    function tn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!rn(n[e], r[e])) return !1;
        return !0;
    }
    var en = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function un(n) {
        return n;
    }
    function an(n) {
        return n;
    }
    var on = F3(function(n, r, t) {
        return "toJSON" === n && "function" == typeof r || (t[n] = r), t;
    });
    function cn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function fn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var sn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), dn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), ln = 0;
    function bn(n) {
        var r = {
            $: 0,
            e: ln++,
            f: n,
            g: null,
            h: []
        };
        return _n(r), r;
    }
    function pn(n) {
        return fn(function(r) {
            r(cn(bn(n)));
        });
    }
    function vn(n, r) {
        n.h.push(r), _n(n);
    }
    var mn = F2(function(n, r) {
        return fn(function(t) {
            vn(n, r), t(cn(0));
        });
    }), hn = !1, gn = [];
    function _n(n) {
        if (gn.push(n), !hn) {
            for(hn = !0; n = gn.shift();)wn(n);
            hn = !1;
        }
    }
    function wn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, _n(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var $n = {};
    function xn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Cn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(sn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = bn(A2(sn, o, n.b));
    }
    var yn = F2(function(n, r) {
        return fn(function(t) {
            n.g(r), t(cn(0));
        });
    }), In = F2(function(n, r) {
        return A2(mn, n.h, {
            $: 0,
            a: r
        });
    });
    function Nn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function En(n) {
        return {
            $: 2,
            m: n
        };
    }
    var zn, Kn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), kn = [], An = !1;
    function Hn(n, r, t) {
        if (kn.push({
            p: n,
            q: r,
            r: t
        }), !An) {
            An = !0;
            for(var e; e = kn.shift();)Sn(e.p, e.q, e.r);
            An = !1;
        }
    }
    function Sn(n, r, t) {
        var e = {};
        for(var u in Mn(!0, r, e, null), Mn(!1, t, e, null), n)vn(n[u], {
            $: "fx",
            a: e[u] || {
                i: g,
                j: g
            }
        });
    }
    function Mn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? $n[r].e : $n[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, n ? t.i = _(r, t.i) : t.j = _(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Mn(n, i.a, t, e);
                return;
            case 3:
                return void Mn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var Fn = "undefined" != typeof document ? document : {};
    function Pn(n, r) {
        n.appendChild(r);
    }
    function Dn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Ln = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: tr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), Bn = Ln(void 0), Rn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: tr(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), Un = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    });
    var Vn, Tn = F4(function(n, r, t, e) {
        return {
            $: 5,
            l: [
                n,
                r,
                t,
                e
            ],
            m: function() {
                return A3(n, r, t, e);
            },
            k: void 0
        };
    }), jn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), On = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Gn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), qn = F3(function(n, r, t) {
        return {
            $: "a4",
            n: r,
            o: {
                f: n,
                o: t
            }
        };
    }), Wn = /^script$/i, Jn = /^(on|formAction$)/i, Yn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, Zn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Qn(n) {
        return Wn.test(n) ? "p" : n;
    }
    function Xn(n) {
        return Jn.test(n) ? "data-" + n : n;
    }
    function nr(n) {
        return Yn.test(n) ? "" : n;
    }
    function rr(n) {
        return Zn.test(n) ? "" : n;
    }
    function tr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? er(i, u, a) : i[u] = a;
            } else "className" === u ? er(r, u, an(a)) : r[u] = an(a);
        }
        return r;
    }
    function er(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function ur(n, r) {
        var t = n.$;
        if (5 === t) return ur(n.k || (n.k = n.m()), r);
        if (0 === t) return Fn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = ur(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return ar(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Fn.createElementNS(n.f, n.c) : Fn.createElement(n.c);
        zn && "a" == n.c && i.addEventListener("click", zn(i)), ar(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)Pn(i, ur(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function ar(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? ir(n, u) : "a0" === e ? fr(n, r, u) : "a3" === e ? or(n, u) : "a4" === e ? cr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function ir(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function or(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function cr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function fr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = sr(r, a), n.addEventListener(u, i, Vn && {
                    passive: 2 > le(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Vn = !0;
            }
        }));
    } catch (n) {}
    function sr(n, r) {
        function t(r) {
            var e = t.q, u = Y(e.a, r);
            if (oe(u)) {
                for(var a, i = le(e), o = u.a, c = i ? 3 > i ? o.a : o.dR : o, f = 1 == i ? o.b : 3 == i && o.c0, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.d$) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var d = a.length; d--;)c = a[d](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function dr(n, r) {
        return n.$ == r.$ && rn(n.a, r.a);
    }
    function lr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function br(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void lr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return br(n.k, r.k, s, 0), void (s.length > 0 && lr(t, 1, e, s));
                case 4:
                    for(var d = n.j, l = r.j, b = !1, p = n.k; 4 === p.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    for(var v = r.k; 4 === v.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    return b && d.length !== l.length ? void lr(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(d, l) : d === l) || lr(t, 2, e, l), void br(p, v, t, e + 1));
                case 0:
                    return void (n.a !== r.a && lr(t, 3, e, r.a));
                case 1:
                    return void pr(n, r, t, e, mr);
                case 2:
                    return void pr(n, r, t, e, hr);
                case 3:
                    if (n.h !== r.h) return void lr(t, 0, e, r);
                    var m = vr(n.d, r.d);
                    m && lr(t, 4, e, m);
                    var h = r.i(n.g, r.g);
                    return void (h && lr(t, 5, e, h));
            }
        }
    }
    function pr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = vr(n.d, r.d);
            a && lr(t, 4, e, a), u(n, r, t, e);
        } else lr(t, 0, e, r);
    }
    function vr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && dr(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = vr(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function mr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? lr(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && lr(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            br(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function hr(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, d = 0, l = 0, b = e; f > d && s > l;){
            var p = (N = o[d]).a, v = (E = c[l]).a, m = N.b, h = E.b, g = void 0, _ = void 0;
            if (p !== v) {
                var w = o[d + 1], $ = c[l + 1];
                if (w) {
                    var x = w.a, C = w.b;
                    _ = v === x;
                }
                if ($) {
                    var y = $.a, I = $.b;
                    g = p === y;
                }
                if (g && _) br(m, I, u, ++b), _r(a, u, p, h, l, i), b += m.b || 0, wr(a, u, p, C, ++b), b += C.b || 0, d += 2, l += 2;
                else if (g) b++, _r(a, u, v, h, l, i), br(m, I, u, b), b += m.b || 0, d += 1, l += 2;
                else if (_) wr(a, u, p, m, ++b), b += m.b || 0, br(C, h, u, ++b), b += C.b || 0, d += 2, l += 1;
                else {
                    if (!w || x !== y) break;
                    wr(a, u, p, m, ++b), _r(a, u, v, h, l, i), b += m.b || 0, br(C, I, u, ++b), b += C.b || 0, d += 2, l += 2;
                }
            } else br(m, h, u, ++b), b += m.b || 0, d++, l++;
        }
        for(; f > d;){
            var N;
            b++, wr(a, u, (N = o[d]).a, m = N.b, b), b += m.b || 0, d++;
        }
        for(; s > l;){
            var E, z = z || [];
            _r(a, u, (E = c[l]).a, E.b, void 0, z), l++;
        }
        (u.length > 0 || i.length > 0 || z) && lr(t, 8, e, {
            w: u,
            x: i,
            y: z
        });
    }
    var gr = "_elmW6BL";
    function _r(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return br(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        _r(n, r, t + gr, e, u, a);
    }
    function wr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return br(e, a.z, i, u), void lr(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            wr(n, r, t + gr, e, u);
        } else {
            var o = lr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function $r(n, r, t, e) {
        xr(n, r, t, 0, 0, r.b, e);
    }
    function xr(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) $r(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && xr(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, d = o.s;
                d && (d.A.s = n, (s = d.w).length > 0 && xr(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var l = r.$;
        if (4 === l) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return xr(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var p = r.e, v = n.childNodes, m = 0; p.length > m; m++){
            u++;
            var h = 1 === l ? p[m] : p[m].b, g = u + (h.b || 0);
            if (!(u > c || c > g || (o = t[e = xr(v[m], h, t, e, u, g, i)]) && (c = o.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function Cr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = yr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function yr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = ur(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return ar(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Cr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(ur(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Cr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = Fn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                Pn(t, 2 === u.c ? u.s : ur(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Cr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : ur(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && Pn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Ir(n) {
        if (3 === n.nodeType) return Dn(n.textContent);
        if (1 !== n.nodeType) return Dn("");
        for(var r = g, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = _(A2(Gn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = g, o = n.childNodes;
        for(e = o.length; e--;)i = _(Ir(o[e]), i);
        return A3(Bn, a, r, i);
    }
    var Nr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var o = A2(J, n, r ? r.flags : void 0);
            oe(o) || a(2);
            var c = {}, f = t(o.a), s = f.a, d = i(b, s), l = function(n, r) {
                var t;
                for(var e in $n){
                    var u = $n[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Cn(u, r);
                }
                return t;
            }(c, b);
            function b(n, r) {
                var t = A2(e, n, s);
                d(s = t.a, r), Hn(c, t.b, u(s));
            }
            return Hn(c, f.b, u(s)), l ? {
                ports: l
            } : {};
        }(r, e, n.fk, n.fV, n.fS, function(r, t) {
            var e = n.cY && n.cY(r), u = n.fW, a = Fn.title, i = Fn.body, o = Ir(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Er(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Er(e), t = 2);
                };
            }(t, function(n) {
                zn = e;
                var t = u(n), c = Bn("body")(g)(t.eH), f = function(n, r) {
                    var t = [];
                    return br(n, r, t, 0), t;
                }(o, c);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : ($r(n, r, t, e), Cr(n, t));
                }(i, o, f, r), o = c, zn = 0, a !== t.fU && (Fn.title = a = t.fU);
            });
        });
    }), Er = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function zr() {
        return Ke(Fn.location.href).a || a(1);
    }
    var Kr = F2(function(n, r) {
        return A2(Oe, ke, fn(function() {
            history.pushState({}, "", r), n();
        }));
    }), kr = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    var Ar = F2(function(n, r) {
        return function(n, r) {
            return fn(function(t) {
                Er(function() {
                    var e = document.getElementById(n);
                    t(e ? cn(r(e)) : {
                        $: 1,
                        a: pe(n)
                    });
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), Hr = F2(function(n, r) {
        return fn(function() {
            var t = setInterval(function() {
                bn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), Sr = F2(function(n, r) {
        var t = "g";
        n.dU && (t += "m"), n.dk && (t += "i");
        try {
            return vt(RegExp(r, t));
        } catch (n) {
            return mt;
        }
    }), Mr = F2(function(n, r) {
        return null !== r.match(n);
    }), Fr = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, o = r.lastIndex, c = -1; a++ < n && (e = r.exec(i)) && c != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var d = e[f];
                s[--f] = d ? vt(d) : mt;
            }
            u.push(A4(Da, e[0], e.index, a, $(s))), c = r.lastIndex;
        }
        return r.lastIndex = o, $(u);
    }), Pr = F3(function(n, r, t) {
        return fn(function(e) {
            function u(n) {
                e(r(t.e9.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u($i);
            }), a.addEventListener("timeout", function() {
                u(yi);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? wi : gi, function(n) {
                        return {
                            ex: n.responseURL,
                            fJ: n.status,
                            fK: n.statusText,
                            dB: Dr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.e9.b, a));
            }), Ii(t.ev) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || bn(A2(oa, n, l(t, Ci({
                        fG: e.loaded,
                        fI: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || bn(A2(oa, n, l(t, xi({
                        fC: e.loaded,
                        fI: e.lengthComputable ? vt(e.total) : mt
                    }))));
                });
            }(n, a, t.ev.a);
            try {
                a.open(t.by, t.ex, !0);
            } catch (n) {
                return u(_i(t.ex));
            }
            return function(n, r) {
                for(var t = r.dB; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.fT.a || 0, n.responseType = r.e9.d, n.withCredentials = r.eE;
            }(a, t), t.eH.a && a.setRequestHeader("Content-Type", t.eH.a), a.send(t.eH.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function Dr(n) {
        if (!n) return Qe;
        for(var r = Qe, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), o = u.substring(a + 2);
                r = A3(Mu, i, function(n) {
                    return vt(Ii(n) ? o + ", " + n.a : o);
                }, r);
            }
        }
        return r;
    }
    var Lr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Br = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), Rr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    function Ur(n) {
        return n.byteLength;
    }
    var Vr = F3(function(n, r, t) {
        return n.setInt8(r, t), r + 1;
    }), Tr = F4(function(n, r, t, e) {
        return n.setInt16(r, t, e), r + 2;
    }), jr = F4(function(n, r, t, e) {
        return n.setInt32(r, t, e), r + 4;
    }), Or = F3(function(n, r, t) {
        return n.setUint8(r, t), r + 1;
    }), Gr = F4(function(n, r, t, e) {
        return n.setUint16(r, t, e), r + 2;
    }), qr = F4(function(n, r, t, e) {
        return n.setUint32(r, t, e), r + 4;
    }), Wr = F4(function(n, r, t, e) {
        return n.setFloat32(r, t, e), r + 4;
    }), Jr = F4(function(n, r, t, e) {
        return n.setFloat64(r, t, e), r + 8;
    }), Yr = F3(function(n, r, t) {
        for(var e = 0, u = t.byteLength, a = u - 4; a >= e; e += 4)n.setUint32(r + e, t.getUint32(e));
        for(; u > e; e++)n.setUint8(r + e, t.getUint8(e));
        return r + u;
    }), Zr = F3(function(n, r, t) {
        for(var e = 0; t.length > e; e++){
            var u = t.charCodeAt(e);
            r += 128 > u ? (n.setUint8(r, u), 1) : 2048 > u ? (n.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++e) - 56320 + 65536, n.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), Qr = F2(function(n, r) {
        try {
            return vt(A2(n, r, 0).b);
        } catch (n) {
            return mt;
        }
    }), Xr = F3(function(n, r, t) {
        return l(t + 4, r.getUint32(t, n));
    }), nt = F2(function(n, r) {
        return r >>> n;
    }), rt = L(function(n) {
        return "undefined" != typeof File && n instanceof File ? bt(n) : nn("a FILE", n);
    }), tt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, et = w, ut = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(ut, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), at = function(n) {
        return A3(ut, F3(function(n, r, t) {
            return A2(et, l(n, r), t);
        }), g, n);
    }, it = 1, ot = 2, ct = 0, ft = function(n) {
        return {
            $: 1,
            a: n
        };
    }, st = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), dt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), bt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mt = {
        $: 1
    }, ht = M, gt = m, _t = en, wt = function(n) {
        return n + "";
    }, $t = F2(function(n, r) {
        return A2(H, n, x(r));
    }), xt = F2(function(n, r) {
        return $(A2(A, n, r));
    }), Ct = function(n) {
        return A2($t, "\n    ", A2(xt, "\n", n));
    }, yt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), It = function(n) {
        return A3(yt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Nt = C, Et = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(et, r, t);
            n = e, r = u, t = a;
        }
    }), zt = F2(function(n, r) {
        return A3(Et, n, r, g);
    }), Kt = F2(function(n, r) {
        return A3(Nt, n, A2(zt, 0, It(r) - 1), r);
    }), kt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, At = function(n) {
        var r = kt(n);
        return r >= 97 && 122 >= r;
    }, Ht = function(n) {
        var r = kt(n);
        return 90 >= r && r >= 65;
    }, St = function(n) {
        var r = kt(n);
        return 57 >= r && r >= 48;
    }, Mt = function(n) {
        return At(n) || Ht(n) || St(n);
    }, Ft = function(n) {
        return A3(yt, et, g, n);
    }, Pt = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? mt : vt(55296 > r || r > 56319 ? l(n[0], n.slice(1)) : l(n[0] + n[1], n.slice(2)));
    }, Dt = F2(function(n, r) {
        return "\n\n(" + wt(n + 1) + ") " + Ct(Lt(r));
    }), Lt = function(n) {
        return A2(Bt, n, g);
    }, Bt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n = Pt(t);
                    if (1 === n.$) return !1;
                    var r, e = n.a, u = e.b;
                    return (At(r = e.a) || Ht(r)) && A2(ht, Mt, u);
                }();
                n = e, r = A2(et, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + wt(n.a) + "]";
                n = e, r = A2(et, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2($t, "", Ft(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + wt(It(i)) + " ways:";
                        return A2($t, "\n\n", A2(et, o, A2(Kt, Dt, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2($t, "", Ft(r)) : "!";
                }();
            default:
                var c = n.a, f = n.b;
                return (o = function() {
                    return r.b ? "Problem with the value at json" + A2($t, "", Ft(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Ct(A2(_t, 4, f)) + "\n\n") + c;
        }
    }), Rt = 32, Ut = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Vt = [], Tt = I, jt = F2(function(n, r) {
        return z(r) / z(n);
    }), Ot = Tt(A2(jt, 2, Rt)), Gt = A4(Ut, 0, Ot, Vt, Vt), qt = t, Wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jt = c, Yt = N, Zt = function(n) {
        return n.length;
    }, Qt = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), Xt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ne = e, re = F2(function(n, r) {
        for(;;){
            var t = A2(ne, Rt, n), e = t.b, u = A2(et, Xt(t.a), r);
            if (!e.b) return Ft(u);
            n = e, r = u;
        }
    }), te = function(n) {
        return n.a;
    }, ee = F2(function(n, r) {
        for(;;){
            var t = Tt(r / Rt);
            if (1 === t) return A2(ne, Rt, n).a;
            n = A2(re, n, g), r = t;
        }
    }), ue = F2(function(n, r) {
        if (r.f) {
            var t = r.f * Rt, e = Yt(A2(jt, Rt, t - 1)), u = n ? Ft(r.i) : r.i, a = A2(ee, u, r.f);
            return A4(Ut, Zt(r.h) + t, A2(Qt, 5, e * Ot), a, r.h);
        }
        return A4(Ut, Zt(r.h), Ot, Vt, r.h);
    }), ae = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(ue, !1, {
                i: e,
                f: t / Rt | 0,
                h: u
            });
            var a = Wt(A3(qt, Rt, r, n));
            r -= Rt, e = A2(et, a, e);
        }
    }), ie = F2(function(n, r) {
        if (n > 0) {
            var t = n % Rt;
            return A5(ae, r, n - t - Rt, n, g, A3(qt, t, n - t, r));
        }
        return Gt;
    }), oe = function(n) {
        return !n.$;
    }, ce = j, fe = O, se = G, de = function(n) {
        return {
            $: 0,
            a: n
        };
    }, le = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, be = function(n) {
        return n;
    }, pe = be, ve = F6(function(n, r, t, e, u, a) {
        return {
            dy: a,
            dD: r,
            dY: e,
            d_: t,
            d3: n,
            d4: u
        };
    }), me = F, he = function(n) {
        return n.length;
    }, ge = S, _e = F2(function(n, r) {
        return 1 > n ? r : A3(ge, n, he(r), r);
    }), we = D, $e = function(n) {
        return "" === n;
    }, xe = F2(function(n, r) {
        return 1 > n ? "" : A3(ge, 0, n, r);
    }), Ce = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return mt;
            r = 10 * r + a - 48;
        }
        return u == e ? mt : vt(45 == t ? -r : r);
    }, ye = F5(function(n, r, t, e, u) {
        if ($e(u) || A2(me, "@", u)) return mt;
        var a = A2(we, ":", u);
        if (a.b) {
            if (a.b.b) return mt;
            var i = a.a, o = Ce(A2(_e, i + 1, u));
            if (1 === o.$) return mt;
            var c = o;
            return vt(A6(ve, n, A2(xe, i, u), c, r, t, e));
        }
        return vt(A6(ve, n, u, mt, r, t, e));
    }), Ie = F4(function(n, r, t, e) {
        if ($e(e)) return mt;
        var u = A2(we, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(ye, n, A2(_e, a, e), r, t, A2(xe, a, e));
        }
        return A5(ye, n, "/", r, t, e);
    }), Ne = F3(function(n, r, t) {
        if ($e(t)) return mt;
        var e = A2(we, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Ie, n, vt(A2(_e, u + 1, t)), r, A2(xe, u, t));
        }
        return A4(Ie, n, mt, r, t);
    }), Ee = F2(function(n, r) {
        if ($e(r)) return mt;
        var t = A2(we, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(Ne, n, vt(A2(_e, e + 1, r)), A2(xe, e, r));
        }
        return A3(Ne, n, mt, r);
    }), ze = P, Ke = function(n) {
        return A2(ze, "http://", n) ? A2(Ee, 0, A2(_e, 7, n)) : A2(ze, "https://", n) ? A2(Ee, 1, A2(_e, 8, n)) : mt;
    }, ke = function() {
        for(;;);
    }, Ae = cn, He = Ae(0), Se = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(yt, n, r, Ft(s)) : A4(Se, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Me = F3(function(n, r, t) {
        return A4(Se, n, r, 0, t);
    }), Fe = F2(function(n, r) {
        return A3(Me, F2(function(r, t) {
            return A2(et, n(r), t);
        }), g, r);
    }), Pe = sn, De = F2(function(n, r) {
        return A2(Pe, function(r) {
            return Ae(n(r));
        }, r);
    }), Le = F3(function(n, r, t) {
        return A2(Pe, function(r) {
            return A2(Pe, function(t) {
                return Ae(A2(n, r, t));
            }, t);
        }, r);
    }), Be = function(n) {
        return A3(Me, Le(et), Ae(g), n);
    }, Re = yn, Ue = F2(function(n, r) {
        var t = r;
        return pn(A2(Pe, Re(n), t));
    });
    $n.Task = xn(He, F3(function(n, r) {
        return A2(De, function() {
            return 0;
        }, Be(A2(Fe, Ue(n), r)));
    }), F3(function() {
        return Ae(0);
    }), F2(function(n, r) {
        return A2(De, n, r);
    }));
    var Ve, Te, je = Nn("Task"), Oe = F2(function(n, r) {
        return je(A2(De, n, r));
    }), Ge = R, qe = F3(function(n, r, t) {
        return r(n(t));
    }), We = V, Je = F2(function(n, r) {
        return {
            bv: n.bv,
            dM: r,
            bG: n.bG
        };
    }), Ye = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ze = {
        $: -2
    }, Qe = Ze, Xe = A2(F2(function(n, r) {
        return {
            dJ: n,
            fm: r
        };
    }), !1, !1), nu = {
        F: g,
        bi: Xe,
        cC: mt,
        cG: mt,
        cI: mt
    }, ru = {
        y: {
            e5: "",
            fo: "",
            f_: ""
        },
        bi: Xe,
        cC: mt,
        cD: mt,
        cE: mt,
        cF: mt,
        cI: mt,
        cJ: mt,
        cK: mt,
        cL: mt,
        ad: mt,
        cN: mt,
        cO: mt,
        cP: mt,
        ey: {
            e5: "",
            fo: "",
            f_: ""
        }
    }, tu = {
        bi: Xe,
        cC: mt,
        cI: mt,
        ad: mt,
        cQ: mt,
        ey: ""
    }, eu = function(n) {
        return {
            b7: mt,
            cc: mt,
            bp: n,
            u: !1,
            bH: mt
        };
    }, uu = function(n) {
        return {
            bq: mt,
            R: eu(n)
        };
    }, au = F2(function(n, r) {
        return {
            bd: !1,
            bi: Xe,
            aq: uu(n + "file-preview-modal"),
            G: g,
            bp: n,
            cC: mt,
            bB: mt,
            cI: mt,
            er: r
        };
    }), iu = {
        bi: Xe,
        cC: mt,
        cG: mt,
        cI: mt,
        V: mt
    }, ou = {
        j: mt,
        bi: Xe,
        cj: !1,
        av: !1,
        u: !1,
        cC: mt,
        cI: mt,
        cM: mt,
        ad: mt,
        dX: mt,
        aD: mt,
        aE: g,
        V: mt
    }, cu = {
        bi: Xe,
        cC: mt,
        cI: mt,
        ad: mt,
        ey: ""
    }, fu = {
        a5: 0,
        eu: Qe
    }, su = F2(function(n, r) {
        return r.b ? A3(Me, et, r, n) : n;
    }), du = F3(function(n, r, t) {
        return A2(n, t, r);
    }), lu = function(n) {
        return n.toLowerCase();
    }, bu = F2(function(n, r) {
        return A2($t, "-", A3(du, su, $([
            wt(r)
        ]), A2(xt, " ", lu(n))));
    }), pu = function(n) {
        var r = n.dN, t = n.ey;
        return {
            bp: A2(bu, r, -1),
            br: -1,
            dN: r,
            ey: t
        };
    }, vu = $([
        pu({
            dN: "La persona interessata (me stesso/a)",
            ey: "MYSELF"
        }),
        pu({
            dN: "Un rappresentante della persona interessata (es. avvocato, delegato, tutore)",
            ey: "REPRESENTATIVE"
        })
    ]), mu = {
        dx: {
            eJ: nu,
            eK: cu,
            eL: !1,
            eN: cu,
            eO: !1,
            eP: cu,
            eQ: !1,
            eR: cu,
            eS: !1,
            eT: cu,
            eU: !1,
            eV: nu,
            eW: cu,
            eX: !1,
            eY: !1,
            eZ: tu,
            e_: tu,
            e$: tu,
            e0: !1,
            e1: nu,
            e2: cu,
            e3: nu,
            e4: !1,
            fv: ru,
            fw: tu,
            fx: tu,
            fy: iu,
            fz: tu,
            fA: tu,
            fB: {
                bi: Xe,
                at: false,
                cC: mt,
                cG: mt,
                cI: mt
            },
            fD: A2(F2(function(n, r) {
                return v(r, {
                    aE: A2(Kt, F2(function(n, r) {
                        var t = r.dN, e = r.ey;
                        return {
                            bp: A2(bu, t, n),
                            br: n,
                            dN: t,
                            ey: e
                        };
                    }), n)
                });
            }), vu, ou),
            fM: ru,
            fN: tu,
            fO: Qe,
            fP: tu,
            fQ: tu,
            fR: tu
        },
        dK: !1,
        ea: {
            $: 0
        },
        eo: A2(au, "subjectDocumentMultiuploadModel", Ye),
        eu: fu,
        c6: Qe
    }, hu = F5(function(n, r, t, e, u) {
        return {
            P: e,
            T: t,
            K: r,
            ey: u,
            X: n
        };
    }), gu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(et, n.a, gu(n.b)) : g;
    }, _u = F2(function(n, r) {
        return vt(1 === r.$ ? $([
            n
        ]) : A2(et, n, r.a));
    }), wu = function(n) {
        try {
            return vt(decodeURIComponent(n));
        } catch (n) {
            return mt;
        }
    }, $u = d, xu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return mt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2($u, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return vt(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Cu = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), yu = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Cu, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Cu, 0, e.b, e.c, A5(Cu, 1, a.b, a.c, a.d, a.e), A5(Cu, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Cu, n, o, c, A5(Cu, 0, r, t, e, f), s) : A5(Cu, 0, r, t, A5(Cu, 1, e.b, e.c, e.d, i = e.e), A5(Cu, 1, o, c, f, s));
    }), Iu = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Cu, 0, n, r, Ze, Ze);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2($u, n, u)){
            case 0:
                return A5(yu, e, u, a, A3(Iu, n, r, i), o);
            case 1:
                return A5(Cu, e, u, r, i, o);
            default:
                return A5(yu, e, u, a, i, A3(Iu, n, r, o));
        }
    }), Nu = F3(function(n, r, t) {
        var e = A3(Iu, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Cu, 1, e.b, e.c, e.d, e.e);
    }), Eu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(Cu, 1, n.b, n.c, A5(Cu, 0, r.b, r.c, r.d, r.e), A5(Cu, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5(Cu, 0, e.b, e.c, A5(Cu, 1, n.b, n.c, A5(Cu, 0, u.b, u.c, u.d, u.e), c), A5(Cu, 1, i, o, f, s));
        }
        return n;
    }, zu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, d = t.d, l = t.e, A5(Cu, 1, e = n.b, u = n.c, A5(Cu, 0, r.b, r.c, r.d, o = r.e), A5(Cu, 0, f, s, d, l));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, f = c.b, s = c.c, d = c.d, l = c.e;
            return A5(Cu, 0, a.b, a.c, A5(Cu, 1, i.b, i.c, i.d, i.e), A5(Cu, 1, e, u, o, A5(Cu, 0, f, s, d, l)));
        }
        return n;
    }, Ku = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return zu(r);
                        break n;
                    }
                    return zu(r);
                }
                break n;
            }
            return r;
        }
        return A5(Cu, t, a.b, a.c, a.d, A5(Cu, 0, e, u, a.e, i));
    }), ku = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Eu(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(yu, o.a, o.b, o.c, ku(o.d), c);
                    }
                    return Ze;
                }
                return A5(Cu, r, t, e, ku(u), i);
            }
            return A5(Cu, r, t, e, ku(u), i);
        }
        return Ze;
    }, Au = F2(function(n, r) {
        if (-2 === r.$) return Ze;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > s(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var c = Eu(r);
                    if (-1 === c.$) {
                        var f = c.e;
                        return A5(yu, c.a, c.b, c.c, A2(Au, n, c.d), f);
                    }
                    return Ze;
                }
                return A5(Cu, t, e, u, A2(Au, n, a), i);
            }
            return A5(Cu, t, e, u, A2(Au, n, a), i);
        }
        return A2(Hu, n, A7(Ku, n, r, t, e, u, a, i));
    }), Hu = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, o = r.e;
            if (i(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(yu, t, c.b, c.c, a, ku(o)) : Ze;
            }
            return A5(yu, t, e, u, a, A2(Au, n, o));
        }
        return Ze;
    }), Su = F2(function(n, r) {
        var t = A2(Au, n, r);
        return -1 !== t.$ || t.a ? t : A5(Cu, 1, t.b, t.c, t.d, t.e);
    }), Mu = F3(function(n, r, t) {
        var e = r(A2(xu, n, t));
        return e.$ ? A2(Su, n, t) : A3(Nu, n, e.a, t);
    }), Fu = F2(function(n, r) {
        var t = A2(xt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = wu(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = wu(e);
            return 1 === i.$ ? r : A3(Mu, a, _u(i.a), r);
        }
        return r;
    }), Pu = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.K;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return vt(r.ey);
                    }
                    return vt(r.ey);
                }
                return mt;
            }
        }(n(A5(hu, g, function(n) {
            var r = A2(xt, "/", n);
            return gu(r.b && "" === r.a ? r.b : r);
        }(r.dY), 1 === (t = r.d4).$ ? Qe : A3(Me, Fu, Qe, A2(xt, "&", t.a)), r.dy, be)));
    }), Du = F2(function(n, r) {
        return A5(hu, r.X, r.K, r.T, r.P, n(r.ey));
    }), Lu = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.P, u = r.T, a = r.K, i = r.X;
            return A2(Fe, Du(r.ey), t(A5(hu, i, a, u, e, n)));
        };
    }), Bu = F2(function(n, r) {
        return A3(Me, su, g, A2(Fe, n, r));
    }), Ru = (Ve = $([
        A2(Lu, 0, function(n) {
            var r = n.ey, t = n.P, e = n.T, u = n.K, a = n.X;
            if (u.b) {
                var o = u.a, c = u.b;
                return i(o, "privacy") ? $([
                    A5(hu, A2(et, o, a), c, e, t, r)
                ]) : g;
            }
            return g;
        })
    ]), function(n) {
        return A2(Bu, function(r) {
            return r(n);
        }, Ve);
    }), Uu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Vu = A2(qe, Pu(Ru), Uu(1)), Tu = function(n) {
        return A2(Oe, ke, fn(function() {
            try {
                kr.location = n;
            } catch (n) {
                Fn.location.reload(!1);
            }
        }));
    }, ju = En, Ou = ju(g), Gu = function(n) {
        return 1 === n ? Tu("https://help.prima.it/") : Ou;
    }, qu = F3(function(n, r, t) {
        var e = Vu(r);
        return l({
            ao: A2(Je, n, t),
            ae: mu,
            af: e
        }, Gu(e));
    }), Wu = U, Ju = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Yu = Kn, Zu = En(g), Qu = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Xu = F2(function(n) {
        return n;
    }), na = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ra = F2(function(n, r) {
        return {
            d2: r,
            es: n
        };
    }), ta = Ae(A2(ra, Qe, Qe)), ea = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(xu, t, r);
        return A3(Nu, t, 1 === u.$ ? $([
            e
        ]) : A2(et, e, u.a), r);
    }), ua = function(n) {
        return fn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(cn(0));
        });
    }, aa = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(aa, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), ia = F6(function(n, r, t, e, u, a) {
        var i = A3(aa, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var c = i.a, f = c.a, d = c.b, b = i.b;
                    if (0 > s(f, e)) {
                        a = l(b, A3(n, f, d, o));
                        continue n;
                    }
                    return s(f, e) > 0 ? l(i, A3(t, e, u, o)) : l(b, A4(r, f, d, u, o));
                }
                return l(i, A3(t, e, u, o));
            }
        }), l(at(e), a), u), o = i.a, c = i.b;
        return A3(yt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), c, o);
    }), oa = In, ca = Hr, fa = pn, sa = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = fa(A2(ca, e, A2(oa, n, e)));
            return A2(Pe, function(r) {
                return A3(sa, n, u, A3(Nu, e, r, t));
            }, a);
        }
        return Ae(t);
    }), da = F3(function(n, r, t) {
        var e = t.d2, u = F3(function(n, r, t) {
            var e = t.c;
            return b(t.a, t.b, A2(Pe, function() {
                return e;
            }, ua(r)));
        }), a = A3(yt, ea, Qe, r), i = A6(ia, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(et, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(Nu, n, t, e.b), u);
        }), u, a, e, b(g, Qe, Ae(0))), o = i.a, c = i.b;
        return A2(Pe, function(n) {
            return Ae(A2(ra, a, n));
        }, A2(Pe, function() {
            return A3(sa, n, o, c);
        }, i.c));
    }), la = (Te = be, fn(function(n) {
        n(cn(Te(Date.now())));
    })), ba = F3(function(n, r, t) {
        var e = A2(xu, r, t.es);
        if (1 === e.$) return Ae(t);
        var u = e.a;
        return A2(Pe, function() {
            return Ae(t);
        }, A2(Pe, function(r) {
            return Be(A2(Fe, function(t) {
                return A2(Re, n, t(r));
            }, u));
        }, la));
    }), pa = F3(function(n, r, t) {
        return n(r(t));
    });
    $n.Time = xn(ta, da, ba, 0, F2(function(n, r) {
        return A2(na, r.a, A2(pa, n, r.b));
    }));
    var va = Nn("Time"), ma = F2(function(n, r) {
        return va(A2(na, n, r));
    }), ha = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), ga = function(n) {
        return !n;
    }, _a = F2(function(n, r) {
        return !A2(ha, A2(pa, ga, n), r);
    }), wa = function(n) {
        switch(n.$){
            case 2:
            default:
                return !0;
            case 0:
            case 1:
                return !1;
        }
    }, $a = function(n) {
        return n.b;
    }, xa = Kn, Ca = Kr, ya = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + wt(n.a);
    }), Ia = F3(function(n, r, t) {
        return 1 === r.$ ? t : h(t, h(n, r.a));
    }), Na = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ea = function(n) {
        return {
            $: 3,
            a: n
        };
    }, za = {
        $: 1
    }, Ka = function(n) {
        return {
            $: 41,
            a: n
        };
    }, ka = B, Aa = A2(We, "ticketId", ka), Ha = un, Sa = function(n) {
        switch(n){
            case 0:
                return "Finalit\xe0 di marketing";
            case 1:
                return "Contatto per altre opportunit\xe0 lavorative";
            case 2:
                return "Pubblicazione di immagini sui canali aziendali";
            case 3:
                return "Dati particolari trattati nella gestione del sinistro (se applicabile)*";
            default:
                return "Altro (specificare)";
        }
    }, Ma = null, Fa = function(n) {
        return A3(yt, F2(function(n, r) {
            return A3(on, n.a, n.b, r);
        }), {}, n);
    }, Pa = F2(function(n, r) {
        return n ? Fa(r) : Ma;
    }), Da = F4(function(n, r, t, e) {
        return {
            br: r,
            aA: n,
            fq: t,
            ep: e
        };
    }), La = Mr, Ba = Sr, Ra = function(n) {
        return A2(Ba, {
            dk: !1,
            dU: !1
        }, n);
    }, Ua = /.^/, Va = A2(qe, Ra, Uu(Ua)), Ta = un, ja = function(n) {
        var r;
        return r = n, A2(La, Va("^\\s*$"), r) ? Ma : Ta(n);
    }, Oa = function(n) {
        return n.F;
    }, Ga = function(n) {
        return n.ey;
    }, qa = F2(function(n, r) {
        return A3(yt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), Wa = function(n) {
        return A2(Pa, n.eL, $([
            l("categories", A2(qa, A2(qe, Sa, Ta), Oa(n.eJ))),
            l("comments", ja(Ga(n.eK)))
        ]));
    }, Ja = function(n) {
        return A2(Pa, n.eO, $([
            l("comments", ja(Ga(n.eN)))
        ]));
    }, Ya = function(n) {
        return A2(Pa, n.eQ, $([
            l("comments", ja(Ga(n.eP)))
        ]));
    }, Za = function(n) {
        return A2(Pa, n.eS, $([
            l("comments", ja(Ga(n.eR)))
        ]));
    }, Qa = function(n) {
        return A2(Pa, n.eU, $([
            l("comments", Ta(Ga(n.eT)))
        ]));
    }, Xa = function(n) {
        switch(n){
            case 0:
                return "Dati identificativi (nome, cognome, C.F., contatti, ecc.)";
            case 1:
                return "Dati relativi a preventivi/polizze";
            case 2:
                return "Dati relativi a sinistri";
            default:
                return "Comunicazioni commerciali";
        }
    }, ni = function(n) {
        return n.ey;
    }, ri = function(n) {
        return A2(Pa, n.e0, $([
            l("fullName", Ta(ni(n.e_))),
            l("email", Ta(ni(n.eZ))),
            l("phone", ja(ni(n.e$)))
        ]));
    }, ti = function(n) {
        return A2(Pa, n.eY, $([
            l("categories", A2(qa, A2(qe, Xa, Ta), Oa(n.eV))),
            l("comments", ja(Ga(n.eW))),
            l("consentOrContractBasis", Ha(n.eX)),
            l("thirdPartyDataTransmission", ri(n))
        ]));
    }, ei = function(n) {
        switch(n){
            case 0:
                return "Dati identificativi (nome, cognome, C.F., contatti, ecc.)";
            case 1:
                return "Dati relativi a preventivi/polizze";
            case 2:
                return "Dati relativi a sinistri";
            default:
                return "Comunicazioni commerciali";
        }
    }, ui = function(n) {
        switch(n){
            case 0:
                return "Contesto l'esattezza dei dati";
            case 1:
                return "Il trattamento dei dati \xe8 illecito";
            case 2:
                return "Mi servono i dati per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziaria";
            default:
                return "Mi oppongo al trattamento dei dati (art. 21)";
        }
    }, ai = function(n) {
        return A2(Pa, n.e4, $([
            l("reasons", A2(qa, A2(qe, ui, Ta), Oa(n.e3))),
            l("categories", A2(qa, A2(qe, ei, Ta), Oa(n.e1))),
            l("comments", ja(Ga(n.e2)))
        ]));
    }, ii = function(n) {
        return n ? "Email PEC" : "Email personale";
    }, oi = F2(function(n, r) {
        return A3(Me, F2(function(r, t) {
            return n(r) ? A2(et, r, t) : t;
        }), g, r);
    }), ci = function(n) {
        var r = n.ey;
        return A2($t, "-", A2(oi, A2(qe, $e, ga), $([
            r.f_,
            r.fo,
            r.e5
        ])));
    }, fi = function(n) {
        return n.V;
    }, si = F2(function(n, r) {
        return r.$ ? mt : vt(n(r.a));
    }), di = function(n) {
        return Fa($([
            l("fullName", Ta(ni(n.fz))),
            l("birthPlace", Ta(ni(n.fw))),
            l("birthDate", Ta(ci(n.fv))),
            l("emailType", Ta(A2(Uu, "", A2(si, ii, fi(n.fy))))),
            l("emailAddress", Ta(ni(n.fx))),
            l("phoneNumber", ja(ni(n.fA)))
        ]));
    }, li = function(n) {
        var r = n.b;
        return Fa($([
            l("filename", Ta(n.a)),
            l("content", Ta(A2(Uu, "", r.ex)))
        ]));
    }, bi = function(n) {
        return n.V;
    }, pi = function(n) {
        return i(bi(n.fD), vt("REPRESENTATIVE")) ? Fa($([
            l("fullName", Ta(ni(n.fQ))),
            l("birthPlace", Ta(ni(n.fN))),
            l("birthDate", Ta(ci(n.fM))),
            l("emailAddress", Ta(ni(n.fP))),
            l("phoneNumber", Ta(ni(n.fR))),
            l("documents", A2(qa, li, at(n.fO)))
        ])) : Ma;
    }, vi = function(n) {
        return n.at;
    }, mi = function(n) {
        return Fa($([
            l("presenter", di(n)),
            l("subject", pi(n)),
            l("dataAccess", Ja(n)),
            l("dataChange", Ya(n)),
            l("dataDeletion", Za(n)),
            l("dataTreatmentLimits", ai(n)),
            l("dataOpposition", Qa(n)),
            l("dataPortability", ti(n)),
            l("consentRevocation", Wa(n)),
            l("privacyPolicyAcceptance", Ha(vi(n.fB)))
        ]));
    }, hi = W, gi = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), _i = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wi = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), $i = {
        $: 2
    }, xi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ci = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yi = {
        $: 1
    }, Ii = function(n) {
        return !n.$;
    }, Ni = F2(function(n, r) {
        return A3(Lr, "", be, A2(qe, r, n));
    }), Ei = F2(function(n, r) {
        return r.$ ? ft(n(r.a)) : bt(r.a);
    }), zi = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ki = {
        $: 2
    }, ki = {
        $: 1
    }, Ai = F2(function(n, r) {
        switch(r.$){
            case 0:
                return ft({
                    $: 0,
                    a: r.a
                });
            case 1:
                return ft(ki);
            case 2:
                return ft(Ki);
            case 3:
                return ft(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(r.a.fJ));
            default:
                return A2(Ei, zi, n(r.b));
        }
    }), Hi = F2(function(n, r) {
        return A2(Ni, n, Ai(function(n) {
            return A2(Ei, Lt, A2(hi, r, n));
        }));
    }), Si = function(n) {
        return 1 === n.$ ? Na(n.a) : Ea(n.a);
    }, Mi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fi = F2(function(n, r) {
        return {
            d6: n,
            eq: r
        };
    }), Pi = Ae(A2(Fi, Qe, g)), Di = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Pe, function(r) {
                        var e = a.ev;
                        return A3(Di, n, u, 1 === e.$ ? t : A3(Nu, e.a, r, t));
                    }, fa(A3(Pr, n, Re(n), a)));
                }
                var i = e.a, o = A2(xu, i, t);
                if (1 === o.$) {
                    r = u;
                    continue n;
                }
                return A2(Pe, function() {
                    return A3(Di, n, u, A2(Su, i, t));
                }, ua(o.a));
            }
            return Ae(t);
        }
    }), Li = F4(function(n, r, t, e) {
        return A2(Pe, function(n) {
            return Ae(A2(Fi, n, t));
        }, A3(Di, n, r, e.d6));
    }), Bi = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(et, e.a, t);
    }), Ri = F2(function(n, r) {
        return A3(Me, Bi(n), g, r);
    }), Ui = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? vt(A2(Re, n, u(t))) : mt;
    }), Vi = F3(function(n, r, t) {
        return A2(Pe, function() {
            return Ae(t);
        }, Be(A2(Ri, A3(Ui, n, r.a, r.b), t.eq)));
    }), Ti = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Mi({
                eE: t.eE,
                eH: t.eH,
                e9: A2(Br, n, t.e9),
                dB: t.dB,
                by: t.by,
                fT: t.fT,
                ev: t.ev,
                ex: t.ex
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), ji = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    $n.Http = xn(Pi, Li, Vi, Ti, F2(function(n, r) {
        return A2(ji, r.a, A2(qe, r.b, n));
    }));
    var Oi, Gi, qi = Nn("Http"), Wi = (Nn("Http"), function(n) {
        return function(n) {
            return qi(Mi({
                eE: !1,
                eH: n.eH,
                e9: n.e9,
                dB: n.dB,
                by: n.by,
                fT: n.fT,
                ev: n.ev,
                ex: n.ex
            }));
        }({
            eH: n.eH,
            e9: n.e9,
            dB: g,
            by: "POST",
            fT: mt,
            ev: mt,
            ex: n.ex
        });
    }), Ji = F3(function(n, r, t) {
        var e;
        return Wi({
            eH: (e = mi(r), A2(Rr, "application/json", A2(_t, 0, e))),
            e9: A2(Hi, A2(qe, Si, t), Aa),
            ex: n.bG + "/api/request/privacy"
        });
    }), Yi = F2(function(n, r) {
        return r.$ ? ft(r.a) : n(r.a);
    }), Zi = F2(function(n, r) {
        return "" === r ? ft(n) : bt(r);
    }), Qi = Zi("Data di nascita obbligatoria"), Xi = Zi("Luogo di nascita obbligatorio"), no = function(n) {
        return !n.b;
    }, ro = F2(function(n, r) {
        return no(r) ? ft(n) : bt(r);
    }), to = function(n) {
        return n ? ro("Devi selezionare almeno una categoria per poter procedere") : bt;
    }, eo = function(n) {
        return n ? Zi("Inserire i dettagli della richiesta") : bt;
    }, uo = function(n) {
        return n ? ro("Devi selezionare almeno una categoria per poter procedere") : bt;
    }, ao = function(n) {
        return n ? Zi("Email obbligatoria") : bt;
    }, io = function(n) {
        return n ? Zi("Nome e cognome sono obbligatori") : bt;
    }, oo = function(n) {
        return n ? ro("Devi selezionare almeno una categoria per poter procedere") : bt;
    }, co = function(n) {
        return n ? ro("Devi selezionare almeno una motivazione per poter procedere") : bt;
    }, fo = Zi("Indirizzo email obbligatorio"), so = F2(function(n, r) {
        return r.$ ? ft(n) : bt(r.a);
    }), lo = so("Tipo email obbligatorio"), bo = Zi("Nome e cognome obbligatori"), po = function(n) {
        return !n.$;
    }, vo = function(n) {
        return n ? bt(n) : ft("\xc8 necessario accettare l'informativa sulla privacy per continuare");
    }, mo = so("Tipo richiedente obbligatorio"), ho = function(n) {
        return n ? Qi : bt;
    }, go = function(n) {
        return n ? Xi : bt;
    }, _o = F3(function(n, r, t) {
        var e;
        return n ? -2 === r.$ ? ft("\xc8 necessario allegare i file richiesti") : s(A3(yt, F2(function(n, r) {
            return r + n.fI;
        }), 0, (e = r, A3(ut, F3(function(n, r, t) {
            return A2(et, r, t);
        }), g, e))), 10485760) > 0 ? ft("Limite di 10MB degli allegati superato") : bt(t) : bt(t);
    }), wo = function(n) {
        return n ? fo : bt;
    }, $o = function(n) {
        return n ? bo : bt;
    }, xo = Bn("div"), Co = {
        dN: "check-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="M11 16c-.26 0-.51-.1-.71-.29L7 12.41A.996.996 0 1 1 8.41 11L11 13.59 16.59 8A.996.996 0 1 1 18 9.41l-6.29 6.29c-.2.2-.45.3-.71.3"/></svg>'
    }, yo = {
        dN: "exclamation-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="M12 14.37c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .56-.45 1-1 1m0 4.26a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/></svg>'
    }, Io = {
        dN: "exclamation-triangle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.01 2.98a1 1 0 0 1 .89.514l8.962 16.062a.94.94 0 0 1-.02.98.99.99 0 0 1-.87.485H3.047a1 1 0 0 1-.87-.485.97.97 0 0 1-.021-.98l8.961-16.062c.264-.465.71-.515.891-.515m0-1.98c-1.043 0-2.097.515-2.664 1.544L.375 18.606C-.73 20.586.739 23 3.038 23H20.96c2.309 0 3.767-2.415 2.663-4.394l-8.95-16.062C14.106 1.514 13.053 1 12.009 1"/><path d="M12 15c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1m0 4.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/></svg>'
    }, No = {
        dN: "info-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="M12 18.62c-.55 0-1-.45-1-1v-6c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1v7c0 .56-.45 1-1 1m0-10.74a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"/></svg>'
    }, Eo = {
        dN: "thumb-up",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m20.706 11.09-3.054-.79a1 1 0 0 1-.763-.97V4c0-1.66-1.383-3-3.096-3h-.03a2.08 2.08 0 0 0-1.785 1l-5.004 8.4c-.186.31-.526.5-.898.5h-1.98C2.382 10.9 1 12.24 1 13.9V20c0 1.66 1.383 3 3.095 3H18.24c1.403 0 2.631-.91 2.992-2.22l1.661-6.02c.444-1.6-.536-3.24-2.187-3.67M3.063 20v-6.1c0-.55.465-1 1.032-1h1.548V21H4.095c-.567 0-1.032-.45-1.032-1m17.839-5.76-1.661 6.02c-.124.44-.526.74-1 .74H7.705v-8.56c.423-.26.795-.6 1.053-1.04L13.762 3h.031c.568 0 1.032.45 1.032 1v5.33c0 1.36.939 2.55 2.29 2.9l3.055.79c.557.14.877.69.732 1.22"/></svg>'
    }, zo = {
        m: mt,
        a3: g,
        b2: "Close",
        a9: g,
        be: 2e4,
        dE: vt(function(n) {
            switch(n){
                case 0:
                default:
                    return No;
                case 1:
                    return Eo;
                case 2:
                    return Io;
                case 3:
                    return Co;
                case 4:
                    return yo;
            }
        }(4)),
        bp: "",
        bw: !1,
        cB: mt,
        bK: mt,
        et: {
            $: 0,
            a: ""
        },
        da: 4
    }, Ko = Dn, ko = Ko, Ao = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ho = F3(function(n, r, t) {
        return v(t, {
            et: A2(Ao, r, n)
        });
    }), So = A3(Ho, "Errore", A2(xo, g, $([
        ko("Uno o pi\xf9 campi non sono compilati correttamente, correggi gli errori e riprova.")
    ])), zo), Mo = F2(function(n, r) {
        return l(r, n);
    }), Fo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Po = function(n) {
        switch(n.$){
            case 0:
            default:
                return Fo(n.b);
            case 1:
            case 2:
                return Fo(n.a);
        }
    }, Do = F2(function(n, r) {
        var t = r;
        return v(t, {
            eu: A3(Mu, n, si(Po), t.eu)
        });
    }), Lo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bo = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ro = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(Bo, n.a, n.b);
            case 1:
                return A2(Bo, 500, n.a);
            case 2:
                return Lo(n.a);
        }
    }, Uo = F2(function(n, r) {
        var t = r;
        return v(t, {
            eu: A3(Mu, n, si(Ro), t.eu)
        });
    }), Vo = F2(function(n, r) {
        return v(r, {
            eu: A2(Su, n, r.eu)
        });
    }), To = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jo = function(n) {
        switch(n.$){
            case 3:
                var r = n.b;
                return i(t = n.a, 500) ? Fo(r) : A2(To, t, r);
            case 1:
                return Fo(r = n.a);
            case 2:
                return Lo(r = n.a);
            default:
                var t;
                return A2(To, t = n.a, r = n.b);
        }
    }, Oo = F2(function(n, r) {
        var t = r;
        return v(t, {
            eu: A3(Mu, n, si(jo), t.eu)
        });
    }), Go = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return Ur(n.a);
        }
    }, qo = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A3(Vr, r, t, n.a);
            case 1:
                return A4(Tr, r, t, n.b, !n.a);
            case 2:
                return A4(jr, r, t, n.b, !n.a);
            case 3:
                return A3(Or, r, t, n.a);
            case 4:
                return A4(Gr, r, t, n.b, !n.a);
            case 5:
                return A4(qr, r, t, n.b, !n.a);
            case 6:
                return A4(Wr, r, t, n.b, !n.a);
            case 7:
                return A4(Jr, r, t, n.b, !n.a);
            case 8:
                return A3(Wo, n.b, r, t);
            case 9:
                return A3(Zr, r, t, n.b);
            default:
                return A3(Yr, r, t, n.a);
        }
    }), Wo = F3(function(n, r, t) {
        for(;;){
            if (!n.b) return t;
            var e = n.b, u = r, a = A3(qo, n.a, r, t);
            n = e, r = u, t = a;
        }
    }), Jo = function(n) {
        var r = new DataView(new ArrayBuffer(Go(n)));
        return qo(n)(r)(0), r;
    }, Yo = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Zo = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Qo = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Xo = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.b;
            n += Go(r.a), r = t;
        }
    }), nc = function(n) {
        return A2(Qo, A2(Xo, 0, n), n);
    }, rc = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), tc = rc, ec = F2(function(n, r) {
        return A2(Qr, n, r);
    }), uc = F4(function(n, r, t, e) {
        for(;;){
            var u = A2(r(n), t, e), a = u.a, i = u.b;
            if (i.$) return l(a, i.a);
            n = i.a, e = a;
        }
    }), ac = F2(function(n, r) {
        return A2(uc, n, r);
    }), ic = F2(function(n, r) {
        var t = r;
        return F2(function(r, e) {
            var u = A2(t, r, e);
            return l(u.a, n(u.b));
        });
    }), oc = F2(function(n, r) {
        var t = r.a, e = r.b;
        return t > 0 ? A2(ic, function(n) {
            return function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(l(t - 1, n));
        }, n(e)) : function(n) {
            return F2(function(r, t) {
                return l(t, n);
            });
        }(function(n) {
            return {
                $: 1,
                a: n
            };
        }(e));
    }), cc = F3(function(n, r, t) {
        return A2(ac, l(n, t), oc(r));
    }), fc = y, sc = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(et, t, n), r -= 1;
        }
    }), dc = F2(function(n, r) {
        return A3(sc, g, n, r);
    }), lc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bc = Ur, pc = F5(function(n, r, t, e, u) {
        var a = r, i = t, o = e, c = u;
        return F2(function(r, t) {
            var e = A2(a, r, t), u = e.b, f = A2(i, r, e.a), s = f.b, d = A2(o, r, f.a), b = d.b, p = A2(c, r, d.a);
            return l(p.a, A4(n, u, s, b, p.b));
        });
    }), vc = F6(function(n, r, t, e, u, a) {
        var i = r, o = t, c = e, f = u, s = a;
        return F2(function(r, t) {
            var e = A2(i, r, t), u = e.b, a = A2(o, r, e.a), d = a.b, b = A2(c, r, a.a), p = b.b, v = A2(f, r, b.a), m = v.b, h = A2(s, r, v.a);
            return l(h.a, A5(n, u, d, p, m, h.b));
        });
    }), mc = nt, hc = F2(function(n, r) {
        return (r >>> 32 - n | r << n) >>> 0;
    }), gc = F3(function(n, r, t) {
        var e = t.k, u = t.a8, a = t.a2, i = t.aX, o = t.aS;
        return {
            aS: (o >>> 27 | o << 5) + function() {
                switch(n / 20 | 0){
                    case 0:
                        return 1518500249 + (i & a | ~i & u);
                    case 1:
                        return 1859775393 + (i ^ a ^ u);
                    case 2:
                        return 2400959708 + (i & (a | u) | a & u);
                    default:
                        return 3395469782 + (i ^ a ^ u);
                }
            }() + e + r >>> 0,
            aX: o,
            a2: A2(hc, 30, i),
            a8: a,
            k: u
        };
    }), _c = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(d) {
                                                    return function(l) {
                                                        return function(b) {
                                                            return function(p) {
                                                                for(;;){
                                                                    if (!n) return {
                                                                        aS: t,
                                                                        aX: e,
                                                                        a2: u,
                                                                        a8: a,
                                                                        k: i
                                                                    };
                                                                    var v = t >>> 27 | t << 5, m = o, h = function() {
                                                                        switch(r / 20 | 0){
                                                                            case 0:
                                                                                return 1518500249 + (e & u | ~e & a);
                                                                            case 1:
                                                                                return 1859775393 + (e ^ u ^ a);
                                                                            case 2:
                                                                                return 2400959708 + (e & (u | a) | u & a);
                                                                            default:
                                                                                return 3395469782 + (e ^ u ^ a);
                                                                        }
                                                                    }(), g = n - 1, _ = r + 1, w = v + h + i + m >>> 0, $ = t, x = A2(hc, 30, e), C = u, y = a;
                                                                    n = g, r = _, t = w, e = $, u = x, a = C, i = y, o = c, c = f, f = s, s = d, d = l, l = b, b = p, p = 0;
                                                                }
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, wc = f, $c = function(n) {
        return n >>> 31 | n << 1;
    }, xc = Xr(!1), Cc = function(n) {
        var r, t;
        return (r = n, t = function(n) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(d) {
                                                    return function(l) {
                                                        return function(b) {
                                                            return function(p) {
                                                                return function(v) {
                                                                    return function(m) {
                                                                        var h, g = r, _ = (h = 0, function(n) {
                                                                            return function(r) {
                                                                                return function(t) {
                                                                                    return function(e) {
                                                                                        return function(u) {
                                                                                            return function(a) {
                                                                                                return function(i) {
                                                                                                    return function(o) {
                                                                                                        return function(c) {
                                                                                                            return function(f) {
                                                                                                                return function(s) {
                                                                                                                    return function(d) {
                                                                                                                        return function(l) {
                                                                                                                            return function(b) {
                                                                                                                                return function(p) {
                                                                                                                                    return function(v) {
                                                                                                                                        return function(m) {
                                                                                                                                            for(;;){
                                                                                                                                                var g = n.k, _ = n.a8, w = n.a2, $ = n.aX, x = n.aS;
                                                                                                                                                if (64 === h) return n;
                                                                                                                                                var C = $c(e ^ a ^ d ^ m), y = $c(i ^ c ^ p ^ C), I = $c(t ^ u ^ s ^ v), N = $c(a ^ o ^ b ^ I), E = $c(c ^ s ^ m ^ N), z = $c(r ^ e ^ f ^ p), K = $c(u ^ i ^ l ^ z), k = $c(o ^ f ^ v ^ K), A = _c(8)(h + 16)(x)($)(w)(_)(g)(z)(I)(C)(K)(N)(y)(k)(E);
                                                                                                                                                h += 8, n = A, r = f, t = s, e = d, u = l, a = b, i = p, o = v, c = m, f = z, s = I, d = C, l = K, b = N, p = y, v = k, m = E;
                                                                                                                                            }
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        })(A3(gc, 15, m, A3(gc, 14, v, A3(gc, 13, p, A3(gc, 12, b, A3(gc, 11, l, A3(gc, 10, d, A3(gc, 9, s, A3(gc, 8, f, A3(gc, 7, c, A3(gc, 6, o, A3(gc, 5, i, A3(gc, 4, a, A3(gc, 3, u, A3(gc, 2, e, A3(gc, 1, t, A3(gc, 0, n, g)))))))))))))))))(n)(t)(e)(u)(a)(i)(o)(c)(f)(s)(d)(l)(b)(p)(v)(m);
                                                                        return {
                                                                            aS: g.aS + _.aS,
                                                                            aX: g.aX + _.aX,
                                                                            a2: g.a2 + _.a2,
                                                                            a8: g.a8 + _.a8,
                                                                            k: g.k + _.k
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }, function(n) {
            return function(r) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(f) {
                                            return function(s) {
                                                return function(d) {
                                                    return function(l) {
                                                        return function(b) {
                                                            return function(p) {
                                                                return function(v) {
                                                                    return function(m) {
                                                                        var h = A5(pc, F4(function(n, r, e, u) {
                                                                            return A4(t, n, r, e, u);
                                                                        }), n, r, e, u), g = A6(vc, F5(function(n, r, t, e, u) {
                                                                            return A4(n, r, t, e, u);
                                                                        }), h, a, i, o, c), _ = A6(vc, F5(function(n, r, t, e, u) {
                                                                            return A4(n, r, t, e, u);
                                                                        }), g, f, s, d, l), w = A6(vc, F5(function(n, r, t, e, u) {
                                                                            return A4(n, r, t, e, u);
                                                                        }), _, b, p, v, m);
                                                                        return w;
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc)(xc);
    }, yc = F2(function(n, r) {
        var t, e = function(n) {
            var r = bc(n), t = 4 + A2(fc, 64, 56 - A2(fc, 64, r + 1));
            return Jo(nc($([
                Zo(n),
                lc(128),
                nc(A2(dc, t, lc(0))),
                A2(tc, 1, r << 3)
            ])));
        }(r), u = bc(e) / 64 | 0;
        return {
            aS: (t = A2(Uu, n, A2(ec, A3(cc, u, Cc, n), e))).aS >>> 0,
            aX: t.aX >>> 0,
            a2: t.a2 >>> 0,
            a8: t.a8 >>> 0,
            k: t.k >>> 0
        };
    }), Ic = F5(function(n, r, t, e, u) {
        return {
            aS: n,
            aX: r,
            a2: t,
            a8: e,
            k: u
        };
    }), Nc = A5(Ic, 1732584193, 4023233417, 2562383102, 271733878, 3285377520), Ec = yc(Nc), zc = mc(0), Kc = F2(function(n, r) {
        var t = r.c, e = r.d;
        return A4(Yo, r.a, zc(n << 12 | 4294905855 & r.b), t, e);
    }), kc = F2(function(n, r) {
        var t, e, u, a;
        return function(n) {
            var r = n.d;
            return A4(Yo, n.a, n.b, zc(2147483648 | 1073741823 & n.c), r);
        }(A2(Kc, 5, function(n) {
            return A4(Yo, n.aS, n.aX, n.a2, n.a8);
        }(Ec(Jo(nc($([
            (t = r, e = t.b, u = t.c, a = t.d, nc($([
                A2(tc, 1, t.a),
                A2(tc, 1, e),
                A2(tc, 1, u),
                A2(tc, 1, a)
            ]))),
            Zo(n)
        ])))))));
    }), Ac = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), Hc = function(n) {
        return A2(Ac, function(n) {
            for(var r = 0, t = 0; n.length > t; t++){
                var e = n.charCodeAt(t);
                r += 128 > e ? 1 : 2048 > e ? 2 : 55296 > e || e > 56319 ? 3 : (t++, 4);
            }
            return r;
        }(n), n);
    }, Sc = A2(pa, A2(pa, kc, Jo), Hc), Mc = K, Fc = F3(function(n, r, t) {
        return n > 0 ? A3(Fc, n >> 1, h(r, r), 1 & n ? h(t, r) : t) : t;
    }), Pc = F2(function(n, r) {
        return A3(Fc, n, r, "");
    }), Dc = F3(function(n, r, t) {
        return h(A2(Pc, n - he(t), function(n) {
            return A2(Mc, n, "");
        }(r)), t);
    }), Lc = function(n) {
        return x(n).join("");
    }, Bc = F2(function(n, r) {
        for(;;){
            if (!r) return Lc(n);
            var t = function() {
                switch(15 & r){
                    case 0:
                        return "0";
                    case 1:
                        return "1";
                    case 2:
                        return "2";
                    case 3:
                        return "3";
                    case 4:
                        return "4";
                    case 5:
                        return "5";
                    case 6:
                        return "6";
                    case 7:
                        return "7";
                    case 8:
                        return "8";
                    case 9:
                        return "9";
                    case 10:
                        return "a";
                    case 11:
                        return "b";
                    case 12:
                        return "c";
                    case 13:
                        return "d";
                    case 14:
                        return "e";
                    default:
                        return "f";
                }
            }();
            n = A2(et, t, n), r >>>= 4;
        }
    }), Rc = F2(function(n, r) {
        var t = r.b, e = r.c, u = r.d;
        return h(A3(Dc, 8, "0", A2(Bc, g, r.a)), h(n, h(A3(Dc, 4, "0", A2(Bc, g, t >>> 16)), h(n, h(A3(Dc, 4, "0", A2(Bc, g, 65535 & t)), h(n, h(A3(Dc, 4, "0", A2(Bc, g, e >>> 16)), h(n, h(A3(Dc, 4, "0", A2(Bc, g, 65535 & e)), A3(Dc, 8, "0", A2(Bc, g, u)))))))))));
    }), Uc = Rc("-"), Vc = A4(Yo, 1806153745, 2645365201, 2159280320, 1339306184), Tc = Lo, jc = function(n) {
        return To(n);
    }, Oc = F2(function(n, r) {
        return v(r, {
            bp: n
        });
    }), Gc = F2(function(n, r) {
        var t = n.bw, e = n.be, u = r, a = Uc(A3(du, Sc, Vc, wt(u.a5))), i = A2(Oc, a, n), o = t ? Tc(i) : A2(jc, e, i);
        return v(u, {
            eu: A3(Nu, a, o, u.eu)
        });
    }), qc = F2(function(n, r) {
        return A3(aa, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(Nu, r, t, e) : e;
        }), Qe, r);
    }), Wc = F2(function(n, r) {
        if (-2 === r.$) return Ze;
        var t = r.b, e = r.d, u = r.e;
        return A5(Cu, r.a, t, A2(n, t, r.c), A2(Wc, n, e), A2(Wc, n, u));
    }), Jc = F3(function(n, r, t) {
        var e = 0 | n;
        switch(t.$){
            case 0:
                var u = t.b;
                return i((a = t.a) - e, 500) ? Fo(u) : A2(To, a - e, u);
            case 1:
                return Fo(u = t.a);
            case 2:
                return Lo(u = t.a);
            default:
                var a;
                return A2(Bo, a = t.a, u = t.b);
        }
    }), Yc = F2(function(n, r) {
        var t = r, e = F2(function(n, r) {
            return !function(n) {
                return 1 === n.$;
            }(r);
        });
        return v(t, {
            eu: A2(Wc, Jc(n), A2(qc, e, t.eu))
        });
    }), Zc = function(n) {
        return l(n, Ou);
    }, Qc = F2(function(n, r) {
        switch(n.$){
            case 1:
                return Zc(A2(Yc, n.a, r));
            case 0:
                return Zc(A2(Gc, n.a, v(t = r, {
                    a5: t.a5 + 1
                })));
            case 2:
                return Zc(A2(Do, n.a, r));
            case 3:
                return Zc(A2(Vo, n.a, r));
            case 4:
                return Zc(A2(Uo, n.a, r));
            default:
                return Zc(A2(Oo, n.a, r));
        }
        var t;
    }), Xc = function(n) {
        return Qc(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n));
    }, nf = F2(function(n, r) {
        var t = A2(Xc, n, r.eu);
        return A2(Mo, t.b, v(r, {
            eu: t.a
        }));
    }), rf = F2(function(n, r) {
        var t, e, u;
        return e = i(bi((t = r.dx).fD), vt("REPRESENTATIVE")), po(A2(u = A2(qe, Xu, Yi), vo(vi(t.fB)), A2(u, A2(to, t.eL, Oa(t.eJ)), A2(u, A2(ao, t.eY && t.e0, ni(t.eZ)), A2(u, A2(io, t.eY && t.e0, ni(t.e_)), A2(u, A2(uo, t.eY, Oa(t.eV)), A2(u, A2(eo, t.eU, Ga(t.eT)), A2(u, A2(oo, t.e4, Oa(t.e1)), A2(u, A2(co, t.e4, Oa(t.e3)), A2(u, fo(ni(t.fx)), A2(u, lo(fi(t.fy)), A2(u, Qi(ci(t.fv)), A2(u, Xi(ni(t.fw)), A2(u, bo(ni(t.fz)), A2(u, A3(_o, e, t.fO, g), A2(u, A2(wo, e, ni(t.fP)), A2(u, A2(ho, e, ci(t.fM)), A2(u, A2(go, e, ni(t.fN)), A2(u, A2($o, e, ni(t.fQ)), mo(bi(t.fD))))))))))))))))))))) ? A2(Mo, A3(Ji, n, r.dx, Ka), v(r, {
            dK: !0,
            ea: za
        })) : A2(nf, So, v(r, {
            dK: !0
        }));
    }), tf = F2(function(n, r) {
        return A3(aa, Nu, r, n);
    }), ef = F2(function(n, r) {
        var t;
        return A3(du, tf, r, (t = A2(Fe, function(n) {
            return l(n.fp, n);
        }, n), A3(yt, F2(function(n, r) {
            return A3(Nu, n.a, n.b, r);
        }), Qe, t)));
    }), uf = function(n) {
        return l(n, Ou);
    }, af = {
        a_: !1,
        a$: 0,
        a3: g,
        b4: 0,
        a9: g,
        bc: mt,
        bo: mt,
        bp: mt,
        cH: mt,
        bE: mt,
        bJ: mt,
        bK: mt,
        et: ko(""),
        bP: 0
    }, of = F2(function(n, r) {
        return A2(Gn, Xn(n), rr(r));
    }), cf = of, ff = A2(qe, Fe(function(n) {
        return A2(cf, "data-" + n.a, n.b);
    }), su), sf = F2(function(n, r) {
        return A2(On, n, Ta(r));
    }), df = sf("className"), lf = function(n) {
        return df(A2($t, " ", A2(Fe, te, A2(oi, $a, n))));
    }, bf = function(n) {
        return A2(sf, "download", n);
    }, pf = F2(function(n, r) {
        var t = l(n, r);
        return 1 !== t.a.$ || t.b.$ ? r : vt("");
    }), vf = function(n) {
        return A2(sf, "href", nr(n));
    }, mf = F2(function(n, r) {
        return n.$ ? r : n;
    }), hf = sf("id"), gf = F2(function(n, r) {
        return A2(On, function(n) {
            return "innerHTML" == n || "outerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && Zn.test(n) || Array.isArray(n) && Zn.test(n + "") ? "" : n;
        }(r));
    }), _f = gf, wf = A2(_f, "none@pyxis-elm", Ma), $f = function(n) {
        return A2(qe, si(n), Uu(wf));
    }, xf = jn, Cf = F2(function(n, r) {
        return A2(xf, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r));
    }), yf = function(n) {
        return A2(Cf, "click", de(n));
    }, If = Gn("rel"), Nf = F2(function(n, r) {
        return n ? r : wf;
    }), Ef = Bn("a"), zf = Bn("button"), Kf = function(n) {
        return n ? zf : Ef;
    }, kf = sf("target"), Af = cf("data-test-id"), Hf = sf("type"), Sf = function(n) {
        switch(n){
            case 1:
                return Hf("submit");
            case 2:
                return Hf("reset");
            default:
                return Hf("button");
        }
    }, Mf = function(n) {
        var r = n.bP, t = n.b4, e = n.bp, u = n.cH, a = n.a$, o = n.a_, c = n.bE, f = n.bc, s = n.bJ, d = n.et, b = n.bK, p = n.a3, v = n.bo;
        return A3(Kf, o, A2(ff, n.a9, $([
            A2($f, vf, A2(mf, v, f)),
            A2($f, kf, s),
            A2($f, If, c),
            A2($f, bf, A2(pf, v, f)),
            A2($f, hf, e),
            A2($f, yf, u),
            A2(Nf, o, Sf(a)),
            lf($([
                l("link", !0),
                l("link--current-color", 1 === t),
                l("link--book", i(r, 1))
            ])),
            lf(p),
            A2($f, Af, b)
        ])), $([
            d
        ]));
    }, Ff = F2(function(n, r) {
        return v(r, {
            bo: vt(n)
        });
    }), Pf = F2(function(n, r) {
        return v(r, {
            et: n
        });
    }), Df = A3(Ho, "Si \xe8 verificato un errore nella richiesta", A2(xo, g, $([
        ko("Ti invitiamo a riprovare pi\xf9 tardi o a inviare una email a "),
        Mf(A2(Ff, "mailto:privacy@prima.it", A2(Pf, ko("privacy@prima.it"), af))),
        ko(".")
    ])), zo), Lf = F2(function(n, r) {
        var t = n.c6;
        return A2(Uu, function(n) {
            return {
                bt: !1,
                cl: !1,
                ab: !1,
                aw: !1,
                R: eu(n),
                cU: mt
            };
        }(r), A2(xu, r, t));
    }), Bf = function(n) {
        return A2(Oe, Xu(n), Ae(Xu(n)));
    }, Rf = A2(qe, si(Bf), Uu(Ou)), Uf = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), Vf = F2(function(n, r) {
        return v(r, {
            dJ: n
        });
    }), Tf = F2(function(n, r) {
        return v(r, {
            fm: n
        });
    }), jf = F2(function(n, r) {
        return v(r, {
            at: n
        });
    }), Of = F2(function(n, r) {
        return l(r, ju(n));
    }), Gf = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 0:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(Uf, Vf(!0), r));
            case 1:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(Uf, Vf(!1), r));
            default:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.cG)
                ]), A2(Uf, Tf(!0), A2(jf, e, r)));
        }
    }), qf = F2(function(n, r) {
        return v(r, {
            F: n(r.F)
        });
    }), Wf = F4(function(n, r, t, e) {
        return n(e) ? r(e) : t(e);
    }), Jf = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), Yf = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(Jf, Vf(!0), r));
            case 1:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(Jf, Vf(!1), r));
            default:
                var e = n.a, u = n.b;
                return A2(Of, $([
                    Rf(t.cG)
                ]), A2(Jf, Tf(!0), A4(Wf, Xu(u), function(n) {
                    return qf(et(n));
                }(e), function(n) {
                    return qf(oi(wc(n)));
                }(e), r)));
        }
    }), Zf = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), Qf = F2(function(n, r) {
        return r(n);
    }), Xf = function(n) {
        return si(Qf(n));
    }, ns = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(Zf, Vf(!0), r));
            case 1:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(Zf, Vf(!1), r));
            case 0:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.ad)
                ]), A2(Zf, Tf(!0), v(t, {
                    ey: e
                })));
            default:
                return A2(Of, $([
                    Rf(A2(Xf, n.a, t.cQ))
                ]), r);
        }
    }), rs = F2(function(n, r) {
        return A2(Fe, function(r) {
            return A2(xa, n, Bf(function(n) {
                return {
                    $: 5,
                    a: n
                };
            }(r)));
        }, r);
    }), ts = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), es = F2(function(n, r) {
        return v(r, {
            bi: A2(Tf, n, r.bi)
        });
    }), us = F2(function(n, r) {
        return v(r, {
            u: n
        });
    }), as = F2(function(n, r) {
        return l(r, n);
    }), is = F2(function(n, r) {
        var t = r.bH, e = r.bp, u = r.cc;
        return n ? A2(as, A2(Uu, Ou, A2(Xf, 0, r.b7)), A2(us, !1, r)) : A2(as, A2(Uu, Ou, A2(Xf, {
            bH: t,
            fZ: e
        }, u)), A2(us, !0, r));
    }), os = is(1), cs = is(0), fs = F2(function(n, r) {
        var t = r;
        if (n.a) {
            var e = n.b, u = cs(t.R);
            return A2(as, u.b, v(t, {
                bq: e,
                R: u.a
            }));
        }
        var a = os(t.R);
        return A2(as, a.b, v(t, {
            R: a.a
        }));
    }), ss = F2(function(n, r) {
        return v(r, {
            bd: n
        });
    }), ds = F2(function(n, r) {
        return v(n, {
            bi: r
        });
    }), ls = F2(function(n, r) {
        return v(r, {
            aq: n
        });
    }), bs = F3(function(n, r, t) {
        return v(t, {
            G: A2(Fe, function(t) {
                return i(t.p, r) ? {
                    p: r,
                    fp: t.fp,
                    fI: t.fI,
                    ex: vt(n)
                } : t;
            }, t.G)
        });
    }), ps = function(n) {
        return n.name;
    }, vs = function(n) {
        return n.size;
    }, ms = F2(function(n, r) {
        return v(r, {
            G: A2(Fe, function(n) {
                return {
                    p: n,
                    fp: ps(n),
                    fI: vs(n),
                    ex: mt
                };
            }, n)
        });
    }), hs = F2(function(n, r) {
        var t, e, u = r.aq, a = r.er, i = r.cI, o = r.cC, c = r.bi, f = r.bB;
        switch(n.$){
            case 0:
                return l(A2(ds, r, A2(Vf, !0, c)), Rf(o));
            case 1:
                return l(A2(ds, r, A2(Vf, !1, c)), Rf(i));
            case 2:
                var s = n.a;
                return l(A2(es, !0, A2(ms, s, r)), ju(A2(rs, a, s)));
            case 3:
                return l(A2(ss, !0, r), Ou);
            case 4:
                return l(A2(ss, !1, r), Ou);
            case 5:
                return l(r, A2(xa, a, A2(Oe, function(n) {
                    return A2(ts, t, n);
                }, (e = t = n.a, fn(function(n) {
                    var r = new FileReader;
                    return r.addEventListener("loadend", function() {
                        n(cn(r.result));
                    }), r.readAsDataURL(e), function() {
                        r.abort();
                    };
                })))));
            case 6:
                return l(A3(bs, n.b, n.a, r), Rf(f));
            default:
                var d = A2(fs, n.a, u), b = d.b;
                return l(A2(ls, d.a, r), b);
        }
    }), gs = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), _s = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 0:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.cG)
                ]), A2(gs, Tf(!0), v(t, {
                    V: vt(e)
                })));
            case 2:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(gs, Vf(!0), r));
            default:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(gs, Vf(!1), r));
        }
    }), ws = F2(function(n, r) {
        return v(r, {
            av: n
        });
    }), $s = ws(!1), xs = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), Cs = F2(function(n, r) {
        return v(r, {
            j: n
        });
    }), ys = function(n) {
        return A2(xs, function(n) {
            return v(n, {
                dJ: !0
            });
        }, v(n, {
            j: mt,
            u: !1
        }));
    }, Is = F2(function(n, r) {
        return v(r, {
            cj: n
        });
    }), Ns = F2(function(n, r) {
        return v(r, {
            j: n ? r.j : mt,
            u: n
        });
    }), Es = F2(function(n, r) {
        return v(r, {
            V: vt(n)
        });
    }), zs = dn, Ks = F2(function(n, r) {
        return je(A2(zs, A2(pa, A2(pa, Ae, n), ft), A2(Pe, A2(pa, A2(pa, Ae, n), bt), r)));
    }), ks = Ar("focus"), As = F2(function(n, r) {
        for(;;){
            if (!r.b) return mt;
            var t = r.a, e = r.b;
            if (n(t)) return vt(t);
            r = e;
        }
    }), Hs = F2(function(n, r) {
        return 1 === n.$ ? r : n;
    }), Ss = function(n) {
        return n.bp;
    }, Ms = F2(function(n, r) {
        var t, e, u = n;
        return A2(Uu, Ou, A2(si, A2(qe, Ss, A2(qe, ks, Ks(Xu(r)))), A2(Hs, u.j, (e = (t = n).V, A2(As, function(n) {
            return i(vt(n.ey), e);
        }, t.aE)))));
    }), Fs = F2(function(n, r) {
        return r.$ ? Ou : n(r.a);
    }), Ps = function(n) {
        var r = n;
        return A2(Fs, Ms(n), r.cI);
    }, Ds = ws(!0), Ls = function(n) {
        return n;
    }, Bs = function(n) {
        return n.b ? vt(n.a) : mt;
    }, Rs = F2(function(n, r) {
        return i(r.dM, n);
    }), Us = Rs("ArrowDown"), Vs = Rs("ArrowUp"), Ts = Rs("Enter"), js = Rs("Escape"), Os = Rs(" "), Gs = function(n) {
        var r;
        return Os(n) && !((r = n).$7 || r.di || r.dS);
    }, qs = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? mt : vt(A2(n, r.a, t.a));
    }), Ws = F2(function(n, r) {
        var t = r;
        return i(n.j, t.j) ? Ou : A2(Uu, Ou, A3(qs, F2(function(n, r) {
            return Bf(r(n.bp));
        }), t.j, t.cM));
    }), Js = function(n) {
        return n.ey;
    }, Ys = F3(function(n, r, t) {
        for(;;){
            var e = A2(ne, Rt, n), u = e.a, a = e.b;
            if (0 > s(Zt(u), Rt)) return A2(ue, !0, {
                i: r,
                f: t,
                h: u
            });
            n = a, r = A2(et, Wt(u), r), t += 1;
        }
    }), Zs = function(n) {
        return n.b ? A3(Ys, n, g, 0) : Gt;
    }, Qs = 4294967295 >>> 32 - Ot, Xs = u, nd = F3(function(n, r, t) {
        for(;;){
            var e = A2(Xs, Qs & r >>> n, t);
            if (e.$) return A2(Xs, Qs & r, e.a);
            n -= Ot, t = e.a;
        }
    }), rd = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || s(n, t) > -1 ? mt : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? vt(A2(Xs, Qs & n, a)) : vt(A3(nd, e, n, u));
    }), td = F2(function(n, r) {
        var t = r.aE, e = n + A2(Uu, -1, A2(si, function(n) {
            return n.br;
        }, r.j));
        return 0 > e ? Bs(t) : s(e, It(t)) > -1 ? Bs(Ft(t)) : A2(rd, e, Zs(t));
    }), ed = F2(function(n, r) {
        return v(r, {
            j: A2(td, n, r)
        });
    }), ud = F2(function(n, r) {
        return l(r, ju(A2(Fe, function(n) {
            return n(r);
        }, n)));
    }), ad = F2(function(n, r) {
        var t = r.j, e = r.u, u = r.aD;
        return Gs(n) && !e || Us(n) && !e ? A2(ud, $([
            Ps,
            Ws(r)
        ]), A2(Ns, !0, function(n) {
            var r = n.aE, t = n.V;
            return A3(du, Cs, n, t.$ ? Bs(r) : A2(As, A2(qe, Ls, A2(qe, function(n) {
                return n.ey;
            }, Jt(t.a))), r));
        }($s(r)))) : Us(n) && e ? A2(ud, $([
            Ps,
            Ws(r)
        ]), A2(ed, 1, $s(r))) : (Ts(n) || Gs(n)) && e ? A2(Of, $([
            Rf(u)
        ]), A2(Uu, r, A2(si, A2(qe, Js, A2(qe, A2(du, Es, r), ys)), t))) : Vs(n) && e ? A2(ud, $([
            Ps,
            Ws(r)
        ]), A2(ed, -1, $s(r))) : js(n) ? Zc(A2(Ns, !1, $s(r))) : Zc(A2(Ns, !1, Ds(r)));
    }), id = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 3:
                return A2(Of, $([
                    Rf(t.cC)
                ]), ys(A2(Is, !1, $s(r))));
            case 4:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(xs, Vf(!1), $s(r)));
            case 6:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.aD)
                ]), A2(xs, Tf(!0), A2(Ns, !1, A2(Es, e, r))));
            case 0:
                return e = n.a.ey, A2(Of, $([
                    Rf(t.aD)
                ]), A2(xs, Tf(!0), A2(Ns, !1, A2(Es, e, r))));
            case 1:
                return Zc(t.av ? r : t.u ? A2(Ns, !1, r) : A2(Ns, !0, A2(Cs, mt, r)));
            case 2:
                var u = n.a;
                return t.av ? Zc(r) : !i(u, mt) || t.cj ? Zc(t.u ? A2(Ns, !1, A2(Is, !1, r)) : A2(Ns, !0, A2(Cs, mt, A2(Is, !1, r)))) : Zc(r);
            case 7:
                return Zc(t.av ? r : A2(Is, !0, $s(r)));
            default:
                return A2(ad, n.a, r);
        }
    }), od = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), cd = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(od, Vf(!0), r));
            case 1:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(od, Vf(!1), r));
            default:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.ad)
                ]), A2(od, Tf(!0), v(t, {
                    ey: e
                })));
        }
    }), fd = F2(function(n, r) {
        var t = r, e = t.cU, u = t.ab, a = t.bt, i = t.cl, o = t.R;
        switch(n.$){
            case 0:
                if (n.a) {
                    var c = cs(o), f = c.a;
                    return A2(Of, $([
                        c.b,
                        Rf(e)
                    ]), v(t, {
                        R: f
                    }));
                }
                var s = os(o);
                return A2(as, s.b, v(t, {
                    R: f = s.a
                }));
            case 1:
                var d = n.a;
                return A2(as, Ou, v(t, {
                    cl: d,
                    ab: !!d && u,
                    aw: d || a
                }));
            case 2:
                var l = n.a;
                return A2(as, Ou, v(t, l && u ? {
                    bt: !1,
                    ab: !1,
                    aw: i
                } : {
                    bt: l,
                    ab: !l && u,
                    aw: i || l
                }));
            default:
                return A2(as, Ou, v(t, {
                    ab: n.a
                }));
        }
    }), sd = F5(function(n, r, t, e, u) {
        var a = A2(n, r, t(u.dx)), i = a.b;
        return l(v(u, {
            dx: A2(e, u.dx, a.a)
        }), i);
    }), dd = A2(qe, xt("-"), A2(qe, Zs, A2(qe, rd(2), Uu("")))), ld = A2(qe, xt("-"), A2(qe, Zs, A2(qe, rd(1), Uu("")))), bd = A2(qe, xt("-"), A2(qe, Zs, A2(qe, rd(0), Uu("")))), pd = F2(function(n, r) {
        return v(r, {
            bi: n(r.bi)
        });
    }), vd = F3(function(n, r, t) {
        var e = t;
        return v(e, {
            y: r(e.y),
            ey: n(e.ey)
        });
    }), md = function(n) {
        return A2(Uu, 10, Ce(n)) > 0 && 10 > A2(Uu, 10, Ce(n)) ? A3(Dc, 2, "0", n) : A2(ze, "0", n) ? A2(_e, 1, n) : n;
    }, hd = function(n) {
        return A2(vd, function(r) {
            return v(r, {
                e5: md(n)
            });
        }, function(r) {
            return v(r, {
                e5: n
            });
        });
    }, gd = function(n) {
        return A2(vd, function(r) {
            return v(r, {
                fo: md(n)
            });
        }, function(r) {
            return v(r, {
                fo: n
            });
        });
    }, _d = function(n) {
        return A2(vd, function(r) {
            return v(r, {
                f_: n
            });
        }, function(r) {
            return v(r, {
                f_: n
            });
        });
    }, wd = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 6:
                return A2(Of, $([
                    Rf(t.cD)
                ]), r);
            case 7:
                return A2(Of, $([
                    Rf(t.cE)
                ]), r);
            case 8:
                return A2(Of, $([
                    Rf(t.cF)
                ]), r);
            case 3:
                return A2(Of, $([
                    Rf(t.cJ)
                ]), r);
            case 4:
                return A2(Of, $([
                    Rf(t.cK)
                ]), r);
            case 5:
                return A2(Of, $([
                    Rf(t.cL)
                ]), r);
            case 0:
                var e = n.a;
                return A2(Of, $([
                    Rf(t.cN),
                    Rf(t.ad)
                ]), A2(pd, Tf(!0), A2(hd, e, r)));
            case 1:
                return e = n.a, A2(Of, $([
                    Rf(t.cO),
                    Rf(t.ad)
                ]), A2(pd, Tf(!0), A2(gd, e, r)));
            case 2:
                return e = n.a, A2(Of, $([
                    Rf(t.cP),
                    Rf(t.ad)
                ]), A2(pd, Tf(!0), A2(_d, e, r)));
            case 9:
                return e = n.a, A2(Of, $([
                    Rf(t.ad)
                ]), A2(pd, Tf(!0), v(t, {
                    y: {
                        e5: dd(e),
                        fo: ld(e),
                        f_: bd(e)
                    },
                    ey: {
                        e5: dd(e),
                        fo: ld(e),
                        f_: bd(e)
                    }
                })));
            case 10:
                return A2(Of, $([
                    Rf(t.cC)
                ]), A2(pd, Vf(!0), r));
            default:
                return A2(Of, $([
                    Rf(t.cI)
                ]), A2(pd, Vf(!1), r));
        }
    }), $d = F4(function(n, r, t, e) {
        var u = A2(wd, n, r(e.dx)), a = u.a, i = u.b, o = function(n) {
            return n.ey;
        }(a), c = o.f_, f = o.fo, s = o.e5;
        return A2(_a, ht(St), $([
            s,
            f,
            c
        ])) ? l(v(e, {
            dx: A2(t, e.dx, a)
        }), i) : l(e, Ou);
    }), xd = F2(function(n, r) {
        return v(r, {
            dx: n(r.dx)
        });
    }), Cd = F2(function(n, r) {
        return v(r, {
            eo: n
        });
    }), yd = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A5(sd, id, n.a, function(n) {
                    return n.fD;
                }, F2(function(n, r) {
                    return v(n, {
                        fD: r
                    });
                }), t);
            case 1:
                return A5(sd, ns, n.a, function(n) {
                    return n.fQ;
                }, F2(function(n, r) {
                    return v(n, {
                        fQ: r
                    });
                }), t);
            case 2:
                return A5(sd, ns, n.a, function(n) {
                    return n.fN;
                }, F2(function(n, r) {
                    return v(n, {
                        fN: r
                    });
                }), t);
            case 3:
                return A4($d, n.a, function(n) {
                    return n.fM;
                }, F2(function(n, r) {
                    return v(n, {
                        fM: r
                    });
                }), t);
            case 4:
                return A5(sd, ns, n.a, function(n) {
                    return n.fP;
                }, F2(function(n, r) {
                    return v(n, {
                        fP: r
                    });
                }), t);
            case 5:
                return A5(sd, ns, n.a, function(n) {
                    return n.fR;
                }, F2(function(n, r) {
                    return v(n, {
                        fR: r
                    });
                }), t);
            case 6:
                var e = A2(hs, n.a, t.eo), u = e.a;
                return A2(Mo, e.b, A2(xd, function(n) {
                    var r;
                    return v(n, {
                        fO: A2(ef, (r = u, r.G), t.dx.fO)
                    });
                }, A2(Cd, u, t)));
            case 7:
                var a = n.a;
                return uf(A2(xd, function(n) {
                    return v(n, {
                        fO: A2(Su, a, t.dx.fO)
                    });
                }, A2(Cd, A2(au, "subjectDocumentMultiuploadModel", Ye), t)));
            case 8:
                return A5(sd, ns, n.a, function(n) {
                    return n.fz;
                }, F2(function(n, r) {
                    return v(n, {
                        fz: r
                    });
                }), t);
            case 9:
                return A5(sd, ns, n.a, function(n) {
                    return n.fw;
                }, F2(function(n, r) {
                    return v(n, {
                        fw: r
                    });
                }), t);
            case 10:
                return A4($d, n.a, function(n) {
                    return n.fv;
                }, F2(function(n, r) {
                    return v(n, {
                        fv: r
                    });
                }), t);
            case 11:
                return A5(sd, _s, n.a, function(n) {
                    return n.fy;
                }, F2(function(n, r) {
                    return v(n, {
                        fy: r
                    });
                }), t);
            case 12:
                return A5(sd, ns, n.a, function(n) {
                    return n.fx;
                }, F2(function(n, r) {
                    return v(n, {
                        fx: r
                    });
                }), t);
            case 13:
                return A5(sd, ns, n.a, function(n) {
                    return n.fA;
                }, F2(function(n, r) {
                    return v(n, {
                        fA: r
                    });
                }), t);
            case 14:
                var i = n.a;
                return uf(A2(xd, function(n) {
                    return v(n, {
                        eO: i
                    });
                }, t));
            case 15:
                return A5(sd, cd, n.a, function(n) {
                    return n.eN;
                }, F2(function(n, r) {
                    return v(n, {
                        eN: r
                    });
                }), t);
            case 16:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eQ: i
                    });
                }, t));
            case 17:
                return A5(sd, cd, n.a, function(n) {
                    return n.eP;
                }, F2(function(n, r) {
                    return v(n, {
                        eP: r
                    });
                }), t);
            case 18:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eS: i
                    });
                }, t));
            case 19:
                return A5(sd, cd, n.a, function(n) {
                    return n.eR;
                }, F2(function(n, r) {
                    return v(n, {
                        eR: r
                    });
                }), t);
            case 20:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        e4: i
                    });
                }, t));
            case 21:
                return A5(sd, Yf, n.a, function(n) {
                    return n.e3;
                }, F2(function(n, r) {
                    return v(n, {
                        e3: r
                    });
                }), t);
            case 22:
                return A5(sd, Yf, n.a, function(n) {
                    return n.e1;
                }, F2(function(n, r) {
                    return v(n, {
                        e1: r
                    });
                }), t);
            case 23:
                return A5(sd, cd, n.a, function(n) {
                    return n.e2;
                }, F2(function(n, r) {
                    return v(n, {
                        e2: r
                    });
                }), t);
            case 24:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eU: i
                    });
                }, t));
            case 25:
                return A5(sd, cd, n.a, function(n) {
                    return n.eT;
                }, F2(function(n, r) {
                    return v(n, {
                        eT: r
                    });
                }), t);
            case 26:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eY: i
                    });
                }, t));
            case 27:
                return A5(sd, Yf, n.a, function(n) {
                    return n.eV;
                }, F2(function(n, r) {
                    return v(n, {
                        eV: r
                    });
                }), t);
            case 28:
                return A5(sd, cd, n.a, function(n) {
                    return n.eW;
                }, F2(function(n, r) {
                    return v(n, {
                        eW: r
                    });
                }), t);
            case 29:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eX: i
                    });
                }, t));
            case 30:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        e0: i
                    });
                }, t));
            case 31:
                return A5(sd, ns, n.a, function(n) {
                    return n.e_;
                }, F2(function(n, r) {
                    return v(n, {
                        e_: r
                    });
                }), t);
            case 32:
                return A5(sd, ns, n.a, function(n) {
                    return n.eZ;
                }, F2(function(n, r) {
                    return v(n, {
                        eZ: r
                    });
                }), t);
            case 33:
                return A5(sd, ns, n.a, function(n) {
                    return n.e$;
                }, F2(function(n, r) {
                    return v(n, {
                        e$: r
                    });
                }), t);
            case 34:
                return i = n.a, uf(A2(xd, function(n) {
                    return v(n, {
                        eL: i
                    });
                }, t));
            case 35:
                return A5(sd, Yf, n.a, function(n) {
                    return n.eJ;
                }, F2(function(n, r) {
                    return v(n, {
                        eJ: r
                    });
                }), t);
            case 36:
                return A5(sd, cd, n.a, function(n) {
                    return n.eK;
                }, F2(function(n, r) {
                    return v(n, {
                        eK: r
                    });
                }), t);
            case 37:
                return A5(sd, Gf, n.a, function(n) {
                    return n.fB;
                }, F2(function(n, r) {
                    return v(n, {
                        fB: r
                    });
                }), t);
            case 38:
                var o = n.a, c = A2(fd, n.b, A2(Lf, t, o)), f = c.b;
                return l(v(t, {
                    c6: A3(Nu, o, c.a, t.c6)
                }), f);
            case 39:
                var s = A2(Qc, n.a, t.eu);
                return A2(Mo, s.b, v(t, {
                    eu: s.a
                }));
            case 40:
                return A2(rf, r, t);
            case 41:
                switch(n.a.$){
                    case 3:
                        return uf(v(t, {
                            ea: Ea(n.a.a)
                        }));
                    case 2:
                        return A2(nf, Df, v(t, {
                            ea: Na(n.a.a)
                        }));
                    default:
                        return uf(t);
                }
            case 42:
                return uf(v(t, {
                    dK: !1
                }));
            case 43:
                return A2(Mo, Tu("https://www.prima.it/"), t);
            default:
                return uf(t);
        }
    }), Id = F2(function(n, r) {
        switch(n.$){
            case 2:
                var t = A3(yd, n.a, r.ao, r.ae), e = t.b;
                return l(v(r, {
                    ae: t.a
                }), A2(xa, Ju, e));
            case 1:
                return l(r, n.a.$ ? Tu(n.a.a) : A2(Ca, r.ao.dM, A3(Ia, "#", (a = n.a.a).dy, A3(Ia, "?", a.d4, h(A2(ya, a.d_, h(a.d3 ? "https://" : "http://", a.dD)), a.dY)))));
            default:
                var u = n.a;
                return l(v(r, {
                    af: u
                }), Gu(u));
        }
        var a;
    }), Nd = Un, Ed = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zd = F6(function(n, r, t, e, u, a) {
        return {
            a3: g,
            b4: mt,
            O: a,
            a9: g,
            cg: t,
            bp: mt,
            cr: g,
            fI: u(e),
            el: u,
            c3: r,
            bK: mt,
            c7: n
        };
    }), Kd = A5(zd, 3, "p", 1, 1, Ed), kd = F2(function(n, r) {
        return A3(yt, F2(function(n, r) {
            return n(r);
        }), r, n);
    }), Ad = {
        w: 0,
        am: 0,
        x: g,
        a3: g,
        aI: 0
    }, Hd = F2(function(n, r) {
        var t = A2(kd, n, Ad);
        return {
            w: t.w,
            am: t.am,
            x: r,
            a3: t.a3,
            aI: t.aI
        };
    }), Sd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Md = "h2", Fd = A5(zd, 1, Md, 1, 0, Sd), Pd = {
        x: g,
        H: 1
    }, Dd = function(n) {
        switch(n){
            case 0:
                return "base";
            case 1:
                return "2xs";
            case 2:
                return "xs";
            case 3:
                return "s";
            case 4:
                return "m";
            case 5:
                return "l";
            default:
                return "xl";
        }
    }, Ld = Jt(1), Bd = Jt(0), Rd = A2(qe, function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            default:
                return 5;
        }
    }, wt), Ud = F2(function(n, r) {
        return "grid__row__column--span-" + Rd(n) + "-from-" + Dd(r);
    }), Vd = function(n) {
        var r, t = n;
        return A2(xo, $([
            lf(h($([
                l("grid__row__column", !0),
                l((r = t.aI, "grid__row__column--span-" + Rd(r)), !0),
                l(A2(Ud, t.am, t.w), !0)
            ]), t.a3))
        ]), t.x);
    }, Td = function(n) {
        var r, t = n;
        return A2(xo, $([
            lf(h($([
                l("grid__row", !0),
                l("grid__row--m", Ld(t.fI)),
                l("grid__row--s", Bd(t.fI)),
                l((r = t.w, "grid__row--from-" + Dd(r)), !0)
            ]), t.a3))
        ]), A2(Fe, Vd, t.x));
    }, jd = F2(function(n, r) {
        var t, e = A3(yt, F2(function(n, r) {
            return n(r);
        }), Pd, n);
        return A2(xo, $([
            lf($([
                l("grid", !0),
                l((t = e.H, "grid--gap-" + function(n) {
                    switch(n){
                        case 0:
                            return "s";
                        case 1:
                            return "m";
                        case 2:
                            return "l";
                        case 3:
                            return "xl";
                        default:
                            return "2xl";
                    }
                }(t)), !0)
            ]))
        ]), A2(Fe, Td, r));
    }), Od = function(n) {
        return n ? "book" : "bold";
    }, Gd = function(n) {
        switch(n){
            case 0:
                return "display";
            case 1:
                return "headline";
            case 2:
                return "title";
            default:
                return "body";
        }
    }, qd = F3(function(n, r, t) {
        return df(A2($t, "-", $([
            "pyx-typo",
            Gd(n),
            r,
            Od(t)
        ])));
    }), Wd = F2(function(n, r) {
        return l(n, r);
    }), Jd = function(n) {
        switch(n){
            case 0:
                return "0";
            case 1:
                return "5xl";
            case 2:
                return "4xl";
            case 3:
                return "3xl";
            case 4:
                return "2xl";
            case 5:
                return "xl";
            case 6:
                return "l";
            case 7:
                return "m";
            case 8:
                return "s";
            case 9:
                return "xs";
            case 10:
                return "2xs";
            case 11:
                return "3xs";
            default:
                return "4xs";
        }
    }, Yd = function(n) {
        switch(n.$){
            case 0:
                return "margin-t-" + Jd(n.a);
            case 1:
                return "margin-b-" + Jd(n.a);
            case 2:
                return "margin-l-" + Jd(n.a);
            default:
                return "margin-r-" + Jd(n.a);
        }
    }, Zd = function(n) {
        return lf(A2(Fe, A2(qe, Yd, A2(du, Wd, !0)), n));
    }, Qd = function(n) {
        return Bn(Qn(n));
    }, Xd = function(n) {
        switch(n){
            case 0:
                return "l";
            case 1:
                return "m";
            default:
                return "s";
        }
    }, nl = function(n) {
        return n ? "s" : "m";
    }, rl = function(n) {
        return n ? "s" : "m";
    }, tl = function(n) {
        return n ? "s" : "m";
    }, el = F2(function(n, r) {
        var t = l(r, n);
        n: for(;;)switch(t.a){
            case 0:
                if (t.b.$) break n;
                return nl(t.b.a);
            case 1:
                if (1 === t.b.$) return rl(t.b.a);
                break n;
            case 2:
                if (2 === t.b.$) return tl(t.b.a);
                break n;
            default:
                if (3 === t.b.$) return Xd(t.b.a);
                break n;
        }
        return "";
    }), ul = function(n) {
        switch(n){
            case 0:
                return "action";
            case 1:
                return "actionable";
            case 2:
                return "alert";
            case 3:
                return "brand";
            case 4:
                return "content";
            case 5:
                return "content-on-action";
            case 6:
                return "content-on-action-surface";
            case 7:
                return "content-on-alert";
            case 8:
                return "content-on-alert-surface";
            case 9:
                return "content-on-brand";
            case 10:
                return "content-on-brand-surface";
            case 11:
                return "content-on-error";
            case 12:
                return "content-on-error-surface";
            case 13:
                return "content-on-informative";
            case 14:
                return "content-on-informative-surface";
            case 15:
                return "content-on-inverse";
            case 16:
                return "content-on-success";
            case 17:
                return "content-on-success-surface";
            case 18:
                return "content-placeholder";
            case 19:
                return "content-weak";
            case 20:
                return "error";
            case 21:
                return "informative";
            default:
                return "success";
        }
    }, al = A2(qe, ul, A2(qe, gt("c-"), df)), il = function(n) {
        var r = n.cg, t = n.b4, e = n.bK, u = n.a3, a = n.bp, i = n.cr, o = n.O, c = n.c7;
        return A3(Qd, n.c3, A2(ff, n.a9, $([
            A3(qd, c, A2(el, n.fI, c), r),
            Zd(i),
            lf(u),
            A2($f, hf, a),
            A2($f, Af, e),
            A2($f, al, t)
        ])), $([
            o
        ]));
    }, ol = F2(function(n, r) {
        return A3(yt, F2(function(n, r) {
            return n(r);
        }), r, n);
    }), cl = {
        w: 0,
        x: g,
        a3: g,
        fI: 2
    }, fl = F2(function(n, r) {
        var t = A2(ol, n, cl);
        return {
            w: t.w,
            x: r,
            a3: t.a3,
            fI: t.fI
        };
    }), sl = F2(function(n, r) {
        return v(r, {
            b4: vt(n)
        });
    }), dl = F2(function(n, r) {
        return v(r, {
            cg: r.c7 ? n : 0
        });
    }), ll = F2(function(n, r) {
        return v(r, {
            fI: r.el(n)
        });
    }), bl = A2(jd, g, $([
        A2(fl, $([
            (Oi = $([
                l("margin-b-2xl", !0)
            ]), function(n) {
                return v(n, {
                    a3: Oi
                });
            })
        ]), $([
            A2(Hd, g, $([
                il(A2(ll, 1, A2(dl, 0, Fd(ko("Modulo per esercitare i diritti sui dati personali"))))),
                il(A2(sl, 19, A2(ll, 0, A2(dl, 1, Kd(ko("(artt. 15-22 del Regolamento (UE) 2016/679)"))))))
            ]))
        ]))
    ])), pl = function(n) {
        return $([
            n
        ]);
    }, vl = function(n) {
        return v(n, {
            fI: 0
        });
    }, ml = A2(qe, Hd(g), A2(qe, pl, fl($([
        vl
    ])))), hl = {
        ai: mt,
        a3: g,
        b4: 0,
        a9: g,
        bp: mt,
        bK: mt,
        da: 0,
        aR: mt
    }, gl = Bn("header"), _l = A2(qe, Hd(g), A2(qe, pl, fl(g))), wl = function(n) {
        return n ? "true" : "false";
    }, $l = A2(qe, wl, cf("aria-hidden")), xl = cf("aria-labelledby"), Cl = Gn("class"), yl = ko(""), Il = function(n) {
        return A2($t, " ", A2(Fe, te, A2(oi, $a, A2(oi, A2(qe, te, A2(qe, $e, ga)), n))));
    }, Nl = Ln("http://www.w3.org/2000/svg"), El = Nl("title"), zl = F2(function(n, r) {
        return A2(El, $([
            hf(r)
        ]), $([
            ko(n)
        ]));
    }), Kl = F2(function(n, r) {
        return A2(Uu, yl, A3(qs, zl, n, r));
    }), kl = Gn("viewBox"), Al = Gn("id"), Hl = function(n) {
        return 1 !== n.$;
    }, Sl = function(n) {
        return 1 === n.$;
    }, Ml = F2(function(n, r) {
        return A2(Ln, n, Qn(r));
    })("http://www.w3.org/2000/svg"), Fl = Ko, Pl = F3(function(n, r, t) {
        return A3(qn, n, Xn(r), rr(t));
    }), Dl = function(n) {
        var r = n.a, t = n.b;
        return A2(ze, "xlink:", r) ? A3(Pl, "http://www.w3.org/1999/xlink", r, t) : A2(ze, "xml:", r) ? A3(Pl, "http://www.w3.org/XML/1998/namespace", r, t) : A2(of, r, t);
    }, Ll = function(n) {
        switch(n.$){
            case 0:
                return A3(Ml, (r = n.a).fp, A2(Fe, Dl, r.eG), A2(Fe, Ll, r.x));
            case 1:
                return Fl(n.a);
            default:
                return Fl("");
        }
        var r;
    }, Bl = cf("role"), Rl = Nl("svg"), Ul = F3(function(n, r, t) {
        var e = n.a3, u = n.bK, a = n.bp, i = n.ai, o = n.a9, c = A2(si, gt("title-"), a), f = A2(Kl, i, c);
        if (t.b && !t.a.$) {
            var s = t.a.a;
            return A2(Rl, A2(ff, o, A2(su, function(n) {
                return n.b && !n.a.$ ? A2(Ri, function(n) {
                    return "viewBox" === n.a ? vt(kl(n.b)) : mt;
                }, n.a.a.eG) : g;
            }(t), A2(su, $([
                Cl(Il(e)),
                A2($f, Al, a),
                A2($f, Af, u),
                $l(Sl(i)),
                A2($f, xl, c),
                A2(Nf, Hl(i) && Hl(a), Bl("img"))
            ]), r))), A2(et, f, A2(Fe, Ll, s.x)));
        }
        return yl;
    }), Vl = function(n) {
        var r = n.da, t = n.a3;
        return h($([
            l("logo--pride", 1 === n.b4),
            l("logo-prima--monogram", 1 === r),
            l("logo-prima--logotype", !r)
        ]), t);
    }, Tl = function(n) {
        return A2(qe, si(n), A2(qe, Uu(wf), pl));
    }, jl = Gn("style"), Ol = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return mt;
        var r = +n;
        return r == r ? vt(r) : mt;
    }, Gl = function(n) {
        return i(Ol(n), mt) ? "--pyx-logo-size: " + n : "--pyx-logo-size: " + n + "px";
    }, ql = F2(function(n, r) {
        var t = n.ai, e = n.bK, u = n.a9, a = n.bp, i = A2(Tl, jl, A2(si, Gl, n.aR));
        return A3(Ul, {
            ai: t,
            a3: Vl(n),
            a9: u,
            bp: a,
            bK: e
        }, i, r);
    }), Wl = {
        dN: "prima",
        a: '<svg viewBox="0 0 120 46" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g class="logo__content" clip-path="url(#clip0_1777_801)">\n<path d="M65.9781 14.5636C65.061 14.8848 64.6853 15.4165 64.6964 16.4245C64.7627 21.5642 64.7295 26.7039 64.7295 31.8325C64.7295 32.2313 64.7406 32.619 64.7185 33.0178C64.6522 34.3581 63.9229 35.1778 62.8179 35.1888C61.6356 35.1999 60.7737 34.3359 60.7627 32.9845C60.7406 26.7925 60.7295 20.6005 60.7958 14.4085C60.8069 13.7993 61.2267 12.9685 61.735 12.6473C65.9892 9.92237 70.5748 9.32422 75.3814 11.1298C76.2875 11.4731 77.0389 12.2042 77.9781 12.8356C80.1881 11.0411 82.7295 10.1218 85.6798 10.1328C91.503 10.155 94.6964 12.8024 94.9505 18.363C95.1825 23.2701 95.0389 28.1993 95.0168 33.1174C95.0057 34.4134 94.1439 35.211 93.0057 35.1888C91.9671 35.1667 91.1052 34.3581 91.0831 33.1618C91.0278 29.5618 91.0499 25.9618 91.0389 22.3618C91.0389 21.3094 91.072 20.2571 91.0057 19.2048C90.7295 14.8184 87.8566 12.8356 83.3925 13.9876C82.5638 14.1981 81.7903 14.6411 81.0499 15.0731C80.1881 15.5827 79.8124 16.3138 79.8234 17.3771C79.8897 22.6054 79.8676 27.8227 79.8455 33.051C79.8455 34.3581 79.0389 35.1888 77.9339 35.1888C76.7847 35.1888 76.0002 34.3691 75.9339 33.1064C75.9118 32.7519 75.9229 32.4085 75.9229 32.0541C75.9229 28.0553 75.9229 24.0676 75.9229 20.0688C75.9229 19.5814 75.9339 19.1051 75.8897 18.6178C75.5582 15.3501 73.5803 13.6221 70.1218 13.7439C70.1328 13.7439 68.2875 13.755 65.9781 14.5636Z"/>\n<path d="M34.2544 15.7599C34.5858 12.5254 36.8842 10.5205 40.2654 10.2214C42.1218 10.0552 44.0334 10.2657 45.8897 10.4983C47.3041 10.6756 47.9892 11.6171 47.7792 12.6362C47.5693 13.6552 46.5748 14.1869 45.1936 14.054C43.956 13.9432 42.7184 13.7439 41.4919 13.7992C39.3151 13.8989 38.1881 14.9623 38.1107 17.0337C38.0113 20.0577 38.0444 23.0817 38.0334 26.1168C38.0223 28.2657 38.0444 30.4922 38.0223 32.6411C38.0113 34.2694 37.3151 35.1666 36.0886 35.1999C34.7737 35.2442 33.9892 34.3137 33.9892 32.6633C33.9781 30.1156 33.9892 27.5014 33.9892 24.9537C34.0665 24.9537 33.945 18.7949 34.2544 15.7599Z"/>\n<path d="M55.3925 22.7938C55.3925 26.1279 55.4035 29.4621 55.3925 32.7962C55.3814 34.3248 54.6743 35.1888 53.4809 35.1999C52.2102 35.211 51.4588 34.3027 51.4588 32.7408C51.4477 26.1611 51.4477 25.563 51.4588 18.9944C51.4588 17.3439 52.1218 16.491 53.3925 16.4799C54.7295 16.4578 55.3925 17.3107 55.4035 19.0498C55.3925 22.2842 55.3925 19.5482 55.3925 22.7938Z"/>\n<path d="M53.3483 14.4085C52.2323 14.3975 51.2157 13.3895 51.2047 12.2928C51.1936 11.0744 52.1439 10.1439 53.3925 10.1439C54.6411 10.1439 55.6466 11.1187 55.6024 12.2707C55.5803 13.4448 54.5417 14.4196 53.3483 14.4085Z"/>\n<path d="M29.0058 17.5655C28.3759 13.611 25.6135 11.1298 21.4035 10.3876C19.3483 10.0332 17.3704 10.0885 15.4588 10.4541C14.5969 10.5981 13.9781 11.2849 13.956 12.171C13.9339 13.1347 14.829 14.0209 15.8013 13.9987C15.945 13.9987 16.0776 13.9765 16.2102 13.9433C17.5251 13.6442 18.8732 13.5556 20.2875 13.8104C23.4477 14.3532 25.0389 16.0479 25.3704 19.7698C25.5803 22.1513 25.4809 24.5993 25.1936 26.9809C24.8511 29.9273 22.8732 31.5445 19.7682 31.8104C17.3814 32.0098 15.1052 31.5445 12.9284 30.603C12.2544 30.315 11.9781 29.9495 12.0002 29.2184C12.0555 27.0695 12.0223 24.9205 12.0223 22.7716C12.0223 21.0325 12.0002 19.2824 12.0334 17.5433V14.5082C12.0334 13.4781 11.1383 12.6141 10.0444 12.5919C9.71293 12.5809 9.40354 12.6473 9.1273 12.7581C6.85105 13.755 5.21569 14.6079 1.45879 16.5907C0.0444237 17.3661 -0.342317 18.4959 0.309617 19.5815C0.917352 20.6116 2.02232 20.7889 3.35934 20.0689C4.89525 19.2381 6.46431 18.4405 8.05547 17.6762C8.08862 25.8289 8.06652 36.219 8.07757 44.0947V44.1058C8.07757 44.1168 8.07757 44.1168 8.07757 44.1168C8.07757 44.139 8.07757 44.1501 8.07757 44.1722H8.08862C8.13282 45.1802 8.9947 45.9888 10.0555 45.9888C11.1162 45.9888 11.9892 45.1802 12.0223 44.1722H12.0334C12.0444 41.9015 12.0334 37.9581 12.0334 34.2584C14.2433 34.6682 16.2433 35.1999 18.2765 35.3772C23.9118 35.8645 28.398 32.8073 29.1715 27.5015C29.6356 24.2449 29.5251 20.8221 29.0058 17.5655Z"/>\n<path d="M119.801 17.5877C119.691 14.0321 117.569 11.5287 114.111 10.6425C110.188 9.63451 106.343 10.1219 102.619 11.573C101.392 12.0493 100.939 13.0462 101.315 13.9988C101.669 14.8961 102.718 15.2284 104.033 14.8407C104.033 14.8407 107.492 13.6997 110.906 13.7219C113.812 13.7441 115.459 15.1508 115.857 17.7207C115.923 18.1748 115.934 18.6401 115.923 19.1274H115.934L115.967 24.1453V24.2007C115.967 24.2228 115.967 24.2561 115.967 24.2782V24.4001C115.967 26.2056 116.022 27.8561 115.923 29.4954C115.901 29.9496 115.514 30.6031 115.105 30.8025C112.232 32.2093 109.194 32.4308 106.133 31.4893C104.177 30.8801 103.227 29.4179 103.227 27.4573C103.227 25.6739 104.287 24.3004 106.243 23.6468C108.155 23.0154 110.022 23.0487 111.89 23.3367C111.978 23.3477 112.078 23.3588 112.177 23.3588C113.061 23.3588 113.768 22.6388 113.768 21.7637C113.768 20.9884 113.216 20.3459 112.475 20.2019C110.011 19.8364 107.547 19.7699 105.061 20.4677C101.392 21.4979 99.282 24.0345 99.2709 27.4351C99.2599 31.1459 101.293 33.9484 105.028 34.8677C109.834 36.0641 114.453 35.2887 118.729 32.9293C119.26 32.6413 119.79 31.8437 119.801 31.2788C119.89 26.7262 119.956 22.1514 119.801 17.5877Z"/>\n</g>\n<defs>\n<clipPath id="clip0_1777_801">\n<rect width="120" height="36" fill="white" transform="translate(0 10)"/>\n <linearGradient\n          id="full-pride-gradient-default"\n          x1="0.000488281"\n          y1="20.3767"\n          x2="120.676"\n          y2="20.3767"\n          gradientUnits="userSpaceOnUse"\n        >\n          <stop stop-color="#DF1654" />\n          <stop offset="0.033" stop-color="#E43353" />\n          <stop offset="0.098" stop-color="#EE6552" />\n          <stop offset="0.16" stop-color="#F58E51" />\n          <stop offset="0.216" stop-color="#FBAA51" />\n          <stop offset="0.264" stop-color="#FEBC50" />\n          <stop offset="0.3" stop-color="#FFC250" />\n          <stop offset="0.515" stop-color="#A3CD50" />\n          <stop offset="0.557" stop-color="#9BC95A" />\n          <stop offset="0.627" stop-color="#84C073" />\n          <stop offset="0.716" stop-color="#5FB09D" />\n          <stop offset="0.78" stop-color="#41A3BF" />\n          <stop offset="0.823" stop-color="#4A93BF" />\n          <stop offset="0.906" stop-color="#636AC1" />\n          <stop offset="1" stop-color="#8334C2" />\n        </linearGradient>\n\n        <linearGradient\n          id="full-pride-gradient-negative"\n          x1="0"\n          y1="20.3767"\n          x2="120.675"\n          y2="20.3767"\n          gradientUnits="userSpaceOnUse"\n        >\n          <stop stop-color="#DF1654" />\n          <stop offset="0.257" stop-color="#FF9110" />\n          <stop offset="0.26" stop-color="#FF9211" />\n          <stop offset="0.325" stop-color="#FFB22C" />\n          <stop offset="0.389" stop-color="#FFC940" />\n          <stop offset="0.448" stop-color="#FFD74C" />\n          <stop offset="0.5" stop-color="#FFDC50" />\n          <stop offset="0.756" stop-color="#A3CD50" />\n          <stop offset="0.781" stop-color="#9ACC58" />\n          <stop offset="0.822" stop-color="#83CB6E" />\n          <stop offset="0.872" stop-color="#5DC892" />\n          <stop offset="0.93" stop-color="#29C5C3" />\n          <stop offset="0.971" stop-color="#00C2E9" />\n        </linearGradient>\n</clipPath>\n</defs>\n</svg>\n'
    }, Jl = {
        dN: "prima-monogram",
        a: '<svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1638_800)">\n<g>\n<path  class="logo__content" d="M20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0ZM28.67 20.75C28.16 24.26 25.19 26.28 21.44 25.94C20.09 25.82 18.77 25.47 17.3 25.2V31.76C17.25 32.39 16.75 32.89 16.12 32.94C15.4 33.01 14.76 32.47 14.7 31.76V14.25C13.65 14.76 12.6 15.29 11.59 15.84C10.69 16.31 9.98 16.23 9.55 15.51C9.12 14.8 9.37 14.05 10.28 13.55C12.78 12.22 13.84 11.66 15.37 11C15.56 10.92 15.77 10.89 15.98 10.89C16.69 10.89 17.27 11.45 17.3 12.16V17.65C17.3 19.07 17.34 20.49 17.3 21.91C17.25 22.33 17.51 22.71 17.91 22.83C19.33 23.46 20.89 23.74 22.45 23.63C24.52 23.45 25.81 22.38 26.04 20.43C26.25 18.84 26.29 17.23 26.16 15.64C25.94 13.18 24.88 12.06 22.79 11.7C21.89 11.55 20.97 11.57 20.09 11.79C19.99 11.81 19.9 11.82 19.8 11.82C19.13 11.82 18.59 11.28 18.57 10.62C18.58 10.04 19.02 9.55 19.59 9.48C20.89 9.23 22.23 9.21 23.53 9.44C26.32 9.93 28.16 11.57 28.57 14.18C28.93 16.35 28.96 18.57 28.67 20.75Z"/>\n</g>\n<path class="logo__text"  d="M28.5705 14.1823C28.1639 11.5686 26.3179 9.92642 23.5313 9.43828C22.2261 9.21457 20.8909 9.22865 19.5905 9.47902C19.0161 9.55457 18.5839 10.039 18.5735 10.6179C18.5898 11.2846 19.1324 11.8179 19.7991 11.8231C19.8968 11.8235 19.9942 11.8116 20.0891 11.7875C20.9739 11.5749 21.8928 11.5457 22.7891 11.7012C24.8839 12.0572 25.9416 13.1809 26.1602 15.6368C26.2857 17.2349 26.2465 18.8416 26.0431 20.432C25.8142 22.3794 24.5176 23.4472 22.4479 23.6253C20.8935 23.7375 19.335 23.4631 17.9124 22.8272C17.5113 22.7131 17.2513 22.3261 17.2972 21.912C17.3379 20.4883 17.2972 19.0694 17.2972 17.6509C17.2972 16.4964 17.2972 15.3423 17.2972 14.1931V12.159C17.2698 11.4516 16.6883 10.8923 15.9802 10.8927C15.7713 10.8868 15.5631 10.9246 15.3698 11.0046C13.8442 11.6605 12.7765 12.2249 10.285 13.5472C9.37461 14.0505 9.12054 14.7979 9.55276 15.5149C9.98498 16.232 10.6868 16.3131 11.5868 15.8353C12.6039 15.2861 13.6461 14.7623 14.6987 14.2538C14.6987 19.6438 14.6987 26.5135 14.6987 31.7153V31.7561C14.7624 32.4749 15.3968 33.0061 16.1157 32.9427C16.7465 32.8868 17.2465 32.3868 17.3024 31.7561C17.3024 30.2305 17.3024 27.6475 17.3024 25.2016C18.7668 25.4712 20.0891 25.822 21.4365 25.939C25.1942 26.2798 28.1639 24.2561 28.6724 20.7472C28.9639 18.5661 28.9294 16.3535 28.5705 14.1823Z"/>\n</g>\n\n<defs>\n<clipPath id="clip0_1638_800">\n<rect width="40" height="40" fill="white"/>\n</clipPath>\n\n  <linearGradient id="monogram-gradient-default" x1="20" y1="-0.365233" x2="20" y2="40.9458" gradientUnits="userSpaceOnUse">\n  <stop offset="0.00166442" stop-color="var(--pyx-color-monogram-gradient-0)"/>\n  <stop offset="1" stop-color="var(--pyx-color-monogram-gradient-100)"/>\n  </linearGradient>\n\n\n  <linearGradient id="monogram-gradient-negative" x1="20" y1="-0.365233" x2="20" y2="40.9458" gradientUnits="userSpaceOnUse">\n  <stop offset="0.00166442" stop-color="var(--pyx-color-monogram-gradient-0-vibrant)"/>\n  <stop offset="1" stop-color="var(--pyx-color-monogram-gradient-100-vibrant)"/>\n  </linearGradient>\n\n\n    <linearGradient id="monogram-pride-gradient-default" x1="19.9996" y1="6.33545" x2="19.9996" y2="33.6631" gradientUnits="userSpaceOnUse">\n      <stop stop-color="#DF1654"/>\n      <stop offset="0.033" stop-color="#E43353"/>\n      <stop offset="0.098" stop-color="#EE6552"/>\n      <stop offset="0.16" stop-color="#F58E51"/>\n      <stop offset="0.216" stop-color="#FBAA51"/>\n      <stop offset="0.264" stop-color="#FEBC50"/>\n      <stop offset="0.3" stop-color="#FFC250"/>\n      <stop offset="0.515" stop-color="#A3CD50"/>\n      <stop offset="0.557" stop-color="#9BC95A"/>\n      <stop offset="0.627" stop-color="#84C073"/>\n      <stop offset="0.716" stop-color="#5FB09D"/>\n      <stop offset="0.78" stop-color="#41A3BF"/>\n      <stop offset="0.823" stop-color="#4A93BF"/>\n      <stop offset="0.906" stop-color="#636AC1"/>\n      <stop offset="1" stop-color="#8334C2"/>\n    </linearGradient>\n\n    <linearGradient id="monogram-pride-gradient-negative" x1="19.1001" y1="7.15681" x2="19.1001" y2="34.9925" gradientUnits="userSpaceOnUse">\n      <stop stop-color="#DF1654"/>\n      <stop offset="0.257" stop-color="#FF9110"/>\n      <stop offset="0.26" stop-color="#FF9211"/>\n      <stop offset="0.325" stop-color="#FFB22C"/>\n      <stop offset="0.389" stop-color="#FFC940"/>\n      <stop offset="0.448" stop-color="#FFD74C"/>\n      <stop offset="0.5" stop-color="#FFDC50"/>\n      <stop offset="0.756" stop-color="#A3CD50"/>\n      <stop offset="0.781" stop-color="#9ACC58"/>\n      <stop offset="0.822" stop-color="#83CB6E"/>\n      <stop offset="0.872" stop-color="#5DC892"/>\n      <stop offset="0.93" stop-color="#29C5C3"/>\n      <stop offset="0.971" stop-color="#00C2E9"/>\n    </linearGradient>\n\n</defs>\n</svg>\n'
    }, Yl = function(n) {
        return n;
    }, Zl = F2(function(n, r) {
        return F2(function(t, e) {
            var u = A3(Yl, r, t, e);
            if (u.c.$) return b(u.a, u.b, ft(u.c.a));
            var a = u.a, i = u.b;
            return A3(Yl, n(u.c.a), a, i);
        });
    }), Ql = F3(function(n, r, t) {
        return A2(n, t, r);
    }), Xl = F3(function(n, r, t) {
        return F2(function(e, u) {
            var a = A3(Yl, t, e, u);
            return b(a.a, a.b, a.c.$ ? ft(r(a.c.a)) : bt(n(a.c.a)));
        });
    }), nb = F2(function(n, r) {
        return A3(Xl, n, be, r);
    }), rb = F2(function(n, r) {
        return A2(Zl, A2(Ql, nb, n), r);
    }), tb = F3(function(n, r, t) {
        return A2(n, t, r);
    }), eb = F2(function(n, r) {
        return A2(rb, r, A2(nb, tb(Xu), n));
    }), ub = Fr, ab = A2(qe, A2(F5(function(n, r, t, e, u) {
        var a = A2(ze, "^", t) ? t : "^" + t, i = A3(ub, 1, A2(Uu, Ua, n(a)), u.q);
        if (i.b && !i.b.b) {
            var o = i.a, c = he(o.aA), f = u.aG + c;
            return b(e, v(u, {
                q: A2(_e, c, u.q),
                aG: f
            }), bt(r(o)));
        }
        return b(e, u, ft($([
            "expected input matching Regexp /" + a + "/"
        ])));
    }), Ra, function(n) {
        return n.aA;
    }), be), ib = Xl(be), ob = F2(function(n, r) {
        return A2(ib, Xu($([
            n
        ])), r);
    }), cb = A2(ob, "optional whitespace", ab("\\s*")), fb = A2(eb, cb, ab("<!DOCTYPE(?:\"(?:\\\\.|[^\"])*\"|'(?:\\\\.|[^'])*'|[^>])*>")), sb = function(n) {
        var r = F3(function(r, t, e) {
            for(;;){
                var u = A3(Yl, n, t, e);
                if (u.c.$) return b(t, e, Ft(r));
                var a = u.a, o = u.b, c = u.c.a;
                if (i(e, o)) return b(a, o, Ft(r));
                r = A2(et, c, r), t = a, e = o;
            }
        });
        return F2(function(n, t) {
            var e = A3(r, g, n, t);
            return b(e.a, e.b, bt(e.c));
        });
    }, db = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lb = F2(function(n, r) {
        return A2(rb, r, A2(nb, Xu, n));
    }), bb = F2(function(n, r) {
        return b(n, r, ft(g));
    }), pb = F2(function(n, r) {
        return F2(function(t, e) {
            var u = A3(Yl, n, t, e);
            if (u.c.$) {
                var a = u.c.a, i = A3(Yl, r, t, e);
                return i.c.$ ? b(t, e, ft(h(a, i.c.a))) : i;
            }
            return u;
        });
    }), vb = function(n) {
        return A3(Me, pb, bb, n);
    }, mb = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hb = be, gb = A2(ob, "expected any character", (Gi = Xu(!0), hb(F2(function(n, r) {
        var t = "could not satisfy predicate", e = Pt(r.q);
        if (e.$) return b(n, r, ft($([
            t
        ])));
        var u = e.a, a = u.a, i = u.b;
        return Gi(a) ? b(n, v(r, {
            q: i,
            aG: r.aG + 1
        }), bt(a)) : b(n, r, ft($([
            t
        ])));
    })))), _b = function(n) {
        return F2(function(r, t) {
            return b(r, t, bt(n));
        });
    }, wb = function(n) {
        return A2(Zl, n, _b(0));
    }, $b = F2(function(n, r) {
        return F3(function(t, e, u) {
            for(;;){
                var a = A3(Yl, r, e, u);
                if (!a.c.$) return b(s = a.a, d = a.b, bt(Ft(t)));
                var i = a.a, o = a.b, c = a.c.a, f = A3(Yl, n, e, u);
                if (f.c.$) return b(i, o, ft(c));
                var s = f.a, d = f.b;
                t = A2(et, f.c.a, t), e = s, u = d;
            }
        })(g);
    }), xb = function(n) {
        return F2(function(r, t) {
            if (A2(ze, n, t.q)) {
                var e = he(n), u = t.aG + e;
                return b(r, v(t, {
                    q: A2(_e, e, t.q),
                    aG: u
                }), bt(n));
            }
            return b(r, t, ft($([
                'expected "' + n + '"'
            ])));
        });
    }, Cb = wb(function() {
        return A2(nb, A2(pa, mb, Lc), A2(eb, A2(eb, cb, xb("\x3c!--")), A2($b, gb, xb("--\x3e"))));
    }), yb = F3(function(n, r, t) {
        return {
            eG: r,
            x: t,
            fp: n
        };
    }), Ib = F2(function(n, r) {
        return A2(pb, r, _b(n));
    }), Nb = A2(rb, A2(Ib, "", A2(lb, A2(eb, xb('="'), ab('[^"]*')), xb('"'))), A2(nb, Wd, ab("[^=>/]+"))), Eb = F2(function(n, r) {
        return A2(rb, n, A2(nb, Ql(Xu), r));
    }), zb = F2(function(n, r) {
        return A2(rb, sb(A2(Eb, r, n)), A2(nb, et, r));
    }), Kb = F2(function(n, r) {
        return A2(pb, A2(zb, n, r), _b(g));
    }), kb = A3(tb, rb, A2(rb, ab("[^/>\\s]+"), A2(nb, F3(function(n, r, t) {
        return A3(yb, r, t, g);
    }), xb("<"))), A2(lb, A2(eb, cb, A2(Kb, cb, Nb)), cb)), Ab = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hb = wb(function() {
        return A2(nb, Ab, A2(eb, cb, ab("[^<]+")));
    }), Sb = function(n) {
        var r = A2(nb, function(r) {
            return v(n, {
                x: r
            });
        }, A2(lb, A2(lb, A2(eb, A2(eb, cb, xb(">")), sb(Fb())), cb), xb("</" + n.fp + ">")));
        return wb(function() {
            return vb($([
                A2(eb, A2(eb, cb, xb("/>")), _b(n)),
                r
            ]));
        });
    };
    function Mb() {
        return wb(function() {
            return A2(nb, db, A2(Zl, Sb, A2(rb, kb, A2(nb, tb(Xu), cb))));
        });
    }
    function Fb() {
        return wb(function() {
            return vb($([
                Hb,
                Cb,
                Mb()
            ]));
        });
    }
    var Pb = Mb();
    Mb = function() {
        return Pb;
    };
    var Db = Fb();
    Fb = function() {
        return Db;
    };
    var Lb, Bb, Rb, Ub, Vb, Tb, jb, Ob = F3(function(n, r, t) {
        return {
            dp: n,
            q: r,
            aG: t
        };
    }), Gb = F3(function(n, r, t) {
        var e = A3(Yl, n, r, function(n) {
            return A3(Ob, n, n, 0);
        }(t));
        return e.c.$ ? ft(b(e.a, e.b, e.c.a)) : bt(b(e.a, e.b, e.c.a));
    }), qb = A2(nb, Lc, A2(eb, A2(eb, cb, xb("<?xml")), A2($b, gb, xb("?>")))), Wb = function(n) {
        var r = A3(Gb, A2(eb, A2(Ib, "", qb), A2(eb, A2(Ib, "", fb), sb(Db))), g, n);
        return r.$ ? ft(A2($t, " or ", r.a.c)) : bt(r.a.c);
    }, Jb = Uu(yl), Yb = function(n) {
        return n.$ ? mt : vt(n.a);
    }, Zb = _l($([
        A2(gl, $([
            df("header")
        ]), $([
            function(n) {
                var r = n.da;
                return Jb(A2(si, ql(n), Yb(Wb(function(n) {
                    return (n ? Jl : Wl).a;
                }(r)))));
            }(hl)
        ]))
    ])), Qb = {
        $: 40
    }, Xb = {
        aT: mt,
        m: mt,
        ak: mt,
        a3: g,
        a9: g,
        bg: mt,
        ar: g,
        bp: mt,
        by: mt,
        fp: mt,
        bA: mt,
        bC: mt,
        bJ: mt,
        bK: mt
    }, np = {
        bS: g,
        a3: g,
        O: g,
        a9: g,
        bj: g,
        bm: g,
        bp: mt,
        bu: !1,
        Q: mt,
        az: 2
    }, rp = {
        dh: mt,
        aW: 0,
        a3: g,
        a9: g,
        ba: mt,
        bn: mt,
        bp: mt,
        bK: mt,
        fU: mt
    }, tp = {
        a3: g,
        a9: g,
        bp: mt,
        dN: mt,
        cq: mt,
        cW: 0,
        bK: mt,
        c4: 0
    }, ep = F2(function(n, r) {
        return n ? "margin-h-" + Jd(r) : "margin-v-" + Jd(r);
    }), up = F2(function(n, r) {
        if (r.$) return g;
        var t = r.a;
        return i(t, 0) ? g : $([
            l(A2(ep, n, t), !0)
        ]);
    }), ap = function(n) {
        var r = n.c4, t = n.cW, e = n.cq, u = n.dN, a = n.bK, i = n.bp, o = n.a3;
        return A2(ff, n.a9, $([
            lf($([
                l("divider", !0),
                l("divider--vertical", 1 === t),
                l("divider--horizontal", !t),
                l("divider--border-s", !r),
                l("divider--border-m", 1 === r),
                l("divider--label", Hl(u))
            ])),
            lf(A2(up, t, e)),
            lf(o),
            A2($f, hf, i),
            A2($f, Af, a),
            A2(Nf, Hl(u), Bl("presentation"))
        ]));
    }, ip = Bn("hr"), op = A2(qe, si(ko), Jb), cp = Bn("span"), fp = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), sp = _l($([
        (Lb = A2(fp, $([
            l("margin-t-xl", !0)
        ]), tp), Hl(Lb.dN) ? function(n) {
            var r = n.dN;
            return A2(xo, ap(n), $([
                A2(cp, $([
                    df("divider__label")
                ]), $([
                    op(r)
                ]))
            ]));
        }(Lb) : function(n) {
            return A2(ip, ap(n), g);
        }(Lb))
    ])), dp = function(n) {
        return {
            $: 12,
            a: n
        };
    }, lp = {
        a3: g,
        a9: g,
        bk: mt,
        bp: mt,
        au: !1,
        ej: !1,
        fI: 1,
        aJ: mt,
        bK: mt,
        et: mt,
        bL: mt
    }, bp = {
        dN: "mail",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 3H3C1.34 3 0 4.34 0 6v12c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3M3 5h18c.55 0 1 .45 1 1v.07l-10 5.77L2 6.07V6c0-.55.45-1 1-1m18 14H3c-.55 0-1-.45-1-1V8.38l9.5 5.48a.99.99 0 0 0 1 .01L22 8.38V18c0 .55-.45 1-1 1"/></svg>'
    }, pp = F2(function(n, r) {
        return {
            bS: mt,
            a3: g,
            du: r,
            bh: n,
            dN: mt
        };
    }), vp = F2(function(n, r) {
        return r.$ ? mt : n(r.a);
    }), mp = function(n) {
        return n + "-error";
    }, hp = F3(function(n, r, t) {
        return {
            bp: mp(n),
            dJ: !1,
            fm: !1,
            dK: !1,
            ek: t,
            c9: r
        };
    }), gp = F2(function(n, r) {
        return v(r, {
            dJ: n
        });
    }), _p = F2(function(n, r) {
        return v(r, {
            fm: n
        });
    }), wp = F2(function(n, r) {
        return v(r, {
            dK: n
        });
    }), $p = F4(function(n, r, t, e) {
        return A2(wp, r.dK, A2(gp, n.dJ, A2(_p, n.fm, A3(hp, r.bp, t, e))));
    }), xp = F3(function(n, r, t) {
        return n ? A2(si, function(n) {
            return n(r);
        }, t) : mt;
    }), Cp = F5(function(n, r, t, e, u) {
        return 2 === u || r ? A3(xp, r, t, e) : u ? function(n) {
            return 1 === n;
        }(u) ? A3(xp, n.dJ, t, e) : mt : A3(xp, n.fm && !n.dJ, t, e);
    }), yp = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.ey, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), Ip = F2(function(n, r) {
        return v(r, {
            bk: vt(n)
        });
    }), Np = F2(function(n, r) {
        return v(r, {
            bp: vt(n)
        });
    }), Ep = function(n) {
        return n.ej;
    }, zp = sf("htmlFor"), Kp = function(n) {
        return n ? "" : "form-label--s";
    }, kp = Bn("label"), Ap = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hp = function(n) {
        switch(n){
            case 0:
                return "tooltip--bottom";
            case 1:
                return "tooltip--bottom-left";
            case 2:
                return "tooltip--bottom-right";
            case 3:
                return "tooltip--left";
            case 4:
                return "tooltip--right";
            case 5:
                return "tooltip--top";
            case 6:
                return "tooltip--top-left";
            default:
                return "tooltip--top-right";
        }
    }, Sp = F2(function(n, r) {
        var t = n.fI, e = n.a3, u = n.aG;
        return h($([
            l("tooltip", !0),
            l("tooltip--open", r),
            l("tooltip--s", !t),
            l(Hp(u), !0)
        ]), e);
    }), Mp = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return "tooltip-wrapper--bottom";
            case 3:
                return "tooltip-wrapper--left";
            case 4:
                return "tooltip-wrapper--right";
            default:
                return "tooltip-wrapper--top";
        }
    }, Fp = function(n) {
        var r = n.aG;
        return $([
            l("tooltip-wrapper", !0),
            l(Mp(r), !0)
        ]);
    }, Pp = function(n) {
        return A2(qe, si(n), Jb);
    }, Dp = function(n) {
        return A2(Cf, "mouseout", de(n));
    }, Lp = function(n) {
        return A2(Cf, "mouseover", de(n));
    }, Bp = function(n) {
        return {
            b_: mt,
            b0: mt,
            a3: g,
            b4: mt,
            a9: g,
            dE: n,
            fI: 1
        };
    }, Rp = cf("aria-label"), Up = function(n) {
        switch(n){
            case 2:
                return "icon--size-l";
            case 1:
                return "icon--size-m";
            case 0:
                return "icon--size-s";
            default:
                return "icon--size-xl";
        }
    }, Vp = function(n) {
        return n.dN;
    }, Tp = function(n) {
        return n.a;
    }, jp = function(n) {
        var r, t, e, u, a, i, o = n.dE, c = n.b0, f = n.b_;
        return A2(cp, A2(ff, n.a9, $([
            lf((t = n, u = t.a3, a = t.b4, i = t.fI, A2(oi, A2(qe, te, A2(qe, $e, ga)), h($([
                l("icon", !0),
                l(Up(i), !0),
                l((e = a, A2(Uu, "", A2(si, function(n) {
                    return "c-" + ul(n);
                }, e))), !0)
            ]), u)))),
            $l(Sl(f) && Sl(c)),
            A2($f, Rp, f),
            A2($f, xl, c),
            A2(Nf, Hl(f) || Hl(c), Bl("img")),
            A2(cf, "data-name", Vp(o))
        ])), $([
            Jb(Yb((r = Tp(o), A2(Yi, function(n) {
                for(;;){
                    if (!n.b) return ft("No svg found");
                    if (n.a.$) n = t = n.b;
                    else {
                        var r = n.a.a, t = n.b;
                        if ("svg" === r.fp) return bt(A2(Rl, A2(Fe, Dl, r.eG), A2(Fe, Ll, r.x)));
                        n = t;
                    }
                }
            }, Wb(r)))))
        ]));
    }, Op = F2(function(n, r) {
        return v(r, {
            fI: n
        });
    }), Gp = A2(qe, Bp, A2(qe, Op(0), jp)), qp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wp = F2(function(n, r) {
        return A2(Uu, be, A2(si, n, r));
    }), Jp = {
        aU: mt,
        a3: g,
        O: g,
        a9: g,
        bb: !1,
        bj: mt,
        bm: mt,
        bs: !1,
        aC: mt,
        fI: 1,
        bK: mt
    }, Yp = {
        Z: mt,
        a3: g,
        a4: mt,
        a6: mt,
        a9: g,
        dE: mt,
        bw: !1,
        fU: mt,
        c5: 0
    }, Zp = cf("aria-describedby"), Qp = function(n) {
        return n + "-content";
    }, Xp = function(n) {
        switch(n){
            case 0:
                return "modal--s";
            case 1:
                return "modal--m";
            default:
                return "modal--l";
        }
    }, nv = function(n) {
        var r = n.aC;
        return n.bb || i(r, mt) ? mt : r;
    }, rv = Bn("footer"), tv = function(n) {
        return xo($([
            lf($([
                l("modal__footer__buttons", !0),
                l("modal__footer__buttons--vertical-orientation", 1 === n)
            ]))
        ]));
    }, ev = function(n) {
        var r = n.a1, t = n.a0, e = n.bw, u = n.a6, a = n.a3;
        return A2(rv, A2(ff, n.a9, $([
            lf($([
                l("modal__footer", !0),
                l("modal__footer--sticky", e),
                l("modal__footer--custom", Hl(u))
            ])),
            lf(a)
        ])), A2(Uu, $([
            A2(tv, r, t)
        ]), u));
    }, uv = F3(function(n, r, t) {
        return n ? r : t;
    }), av = function(n) {
        return n.$ ? A3(uv, Hl(n.a), "badge--ribbon badge--with-icon", "badge--ribbon") : A3(uv, Hl(n.a), "badge--with-icon", "");
    }, iv = function(n) {
        switch(n){
            case 2:
                return "badge--action";
            case 5:
                return "badge--alert";
            case 1:
                return "badge--brand";
            case 3:
                return "badge--error";
            case 0:
                return "";
            case 4:
                return "badge--success";
            default:
                return "badge--informative";
        }
    }, ov = function(n) {
        var r = n.a;
        return A2(Uu, ko(""), A2(si, A2(qe, Bp, jp), r));
    }, cv = function(n) {
        return n ? "m" : "s";
    }, fv = function(n) {
        var r = n.da, t = n.W, e = n.et, u = n.fI, a = n.bK, i = n.bf, o = n.bp, c = n.a3;
        return A2(cp, A2(ff, n.a9, $([
            lf($([
                l("badge", !0),
                l(iv(r), !0),
                l("badge--strong", 1 === i),
                l(av(t), !0),
                l("badge--size-" + cv(u), !0)
            ])),
            lf(c),
            A2($f, hf, o),
            A2($f, Af, a)
        ])), $([
            ov(t),
            ko(e)
        ]));
    }, sv = function(n) {
        return A2(xo, $([
            df("modal__header__badge")
        ]), $([
            fv(n)
        ]));
    }, dv = {
        $: 0
    }, lv = dv, bv = {
        dN: "cross",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.718 4.282a.96.96 0 0 0-1.358 0L12 10.642l-6.36-6.36A.96.96 0 1 0 4.282 5.64l6.36 6.36-6.36 6.36a.96.96 0 1 0 1.358 1.358l6.36-6.36 6.36 6.36a.96.96 0 1 0 1.358-1.358L13.358 12l6.36-6.36a.96.96 0 0 0 0-1.358"/></svg>'
    }, pv = {
        $: 3
    }, vv = function(n) {
        return {
            bU: mt,
            bV: mt,
            bW: mt,
            bX: mt,
            bY: mt,
            bZ: mt,
            b_: mt,
            b$: mt,
            a3: g,
            a9: g,
            b8: !1,
            ca: mt,
            ch: mt,
            dE: pv,
            bp: mt,
            I: !1,
            cp: "Loading...",
            cC: mt,
            cH: mt,
            cI: mt,
            cR: mt,
            cS: mt,
            cT: mt,
            fI: 2,
            c2: mt,
            bK: mt,
            et: "",
            W: dv,
            da: n,
            aR: 2
        };
    }, mv = vv(5), hv = cf("aria-controls"), gv = cf("aria-current"), _v = A2(qe, wl, cf("aria-disabled")), wv = F3(function(n, r, t) {
        return n ? r : t;
    }), $v = function(n) {
        return A2(cf, "aria-expanded", A3(wv, n, "true", "false"));
    }, xv = cf("aria-haspopup"), Cv = F3(function(n, r, t) {
        var e = l(n, r);
        return e.a ? 3 === e.b.$ ? t : mt : t;
    }), yv = F2(function(n, r) {
        return A2(On, n, Ha(r));
    }), Iv = yv("disabled"), Nv = Gn("form"), Ev = F2(function(n, r) {
        var t = l(n, r);
        return t.b ? vt(!0) : t.a.$ ? mt : vt(t.a.a);
    }), zv = function(n) {
        switch(n.$){
            case 0:
                return "button--append-icon";
            case 1:
                return "button--prepend-icon";
            case 2:
                return "button--icon-only";
            default:
                return "";
        }
    }, Kv = function(n) {
        switch(n){
            case 0:
                return "button--xl";
            case 1:
                return "button--l";
            case 2:
                return "button--m";
            default:
                return "button--s";
        }
    }, kv = function(n) {
        switch(n){
            case 0:
                return "button--primary";
            case 1:
                return "button--secondary";
            case 2:
                return "button--tertiary";
            case 3:
                return "button--brand";
            case 5:
                return "button--ghost";
            default:
                return "button--danger";
        }
    }, Av = function(n) {
        switch(n){
            case 2:
                return "";
            case 0:
                return "button--min-width";
            default:
                return "button--full-width";
        }
    }, Hv = function(n) {
        return !n.$;
    }, Sv = function(n) {
        return 5 === n;
    }, Mv = function(n) {
        return 2 === n.$;
    }, Fv = function(n) {
        return A2(Cf, "blur", de(n));
    }, Pv = function(n) {
        return A2(Cf, "focus", de(n));
    }, Dv = A2(cf, "aria-live", "polite"), Lv = F3(function(n, r, t) {
        var e = b(n, r, t);
        n: for(;;){
            r: for(;;){
                t: for(;;){
                    e: for(;;)switch(e.a){
                        case 0:
                            if (e.b) {
                                if (e.c) return Op(2);
                                break n;
                            }
                            if (e.c) return Op(2);
                            break n;
                        case 1:
                            if (e.b) {
                                if (e.c) return Op(2);
                                break r;
                            }
                            if (e.c) return Op(2);
                            break r;
                        case 2:
                            if (e.b) {
                                if (e.c) return Op(2);
                                break t;
                            }
                            if (e.c) return Op(0);
                            break t;
                        default:
                            if (e.b) {
                                if (e.c) return Op(1);
                                break e;
                            }
                            if (e.c) return Op(0);
                            break e;
                    }
                    return Op(0);
                }
                return Op(0);
            }
            return Op(1);
        }
        return Op(1);
    }), Bv = F4(function(n, r, t, e) {
        return Jb(A2(si, A2(qe, Bp, A2(qe, A3(Lv, n, r, t), jp)), function(n) {
            switch(n.$){
                case 0:
                case 1:
                case 2:
                    return vt(n.a);
                default:
                    return mt;
            }
        }(e)));
    }), Rv = F3(function(n, r, t) {
        return n ? t : r;
    }), Uv = function(n) {
        return A2(Rv, n, yl);
    }, Vv = function(n) {
        return 3 === n.W.$ ? Ef : zf;
    }, Tv = function(n) {
        return Uv(!n);
    }, jv = function(n) {
        return A2(Gn, "tabIndex", wt(n));
    }, Ov = function(n) {
        return n ? 0 : -1;
    }, Gv = A2(qe, Ov, jv), qv = F2(function(n, r) {
        var t = l(n, r);
        return t.a.$ ? 1 === t.b ? $([
            bf("")
        ]) : g : $([
            bf(t.a.a)
        ]);
    }), Wv = function(n) {
        switch(n){
            case 0:
                return "_blank";
            case 1:
                return "_self";
            case 2:
                return "_parent";
            case 3:
                return "_top";
            default:
                return "framename";
        }
    }, Jv = A2(qe, Wv, kf), Yv = F2(function(n, r) {
        switch(r.$){
            case 1:
                return $([
                    Hf("submit")
                ]);
            case 2:
                return $([
                    Hf("reset")
                ]);
            case 0:
                return $([
                    Hf("button")
                ]);
            default:
                var t = r.b, e = r.c;
                return h($([
                    vf(r.a),
                    A2($f, Jv, t)
                ]), A2(qv, n, e));
        }
    }), Zv = F2(function(n, r) {
        var t = l(n, r);
        n: for(; t.a;)switch(t.b.$){
            case 1:
            case 2:
                return dv;
            default:
                break n;
        }
        return r;
    }), Qv = function(n) {
        var r, t, e, u = n;
        return A3(Vv, n, A2(ff, u.a9, A2(su, A2(Yv, u.ca, A2(Zv, u.I, u.W)), $([
            lf(h($([
                l("button", !0),
                l("button--loading", u.I),
                l(zv(u.dE), !0),
                l(kv(u.da), !0),
                l(Av(u.aR), !0),
                l(Kv(u.fI), !0)
            ]), u.a3)),
            Iv(u.b8),
            A2($f, yf, A3(Cv, u.I, u.W, u.cH)),
            A2($f, Lp, u.cT),
            A2($f, Dp, u.cS),
            A2($f, Pv, u.cI),
            A2($f, Fv, u.cC),
            A2($f, A2(qe, de, Cf("mousedown")), A3(Cv, u.I, u.W, u.cR)),
            A2($f, hf, u.bp),
            A2($f, Af, u.bK),
            A2($f, xl, u.b$),
            A2($f, Zp, u.bW),
            A2($f, Rp, u.b_),
            A2($f, _v, A2(Ev, u.bX, u.I)),
            A2($f, hv, u.bU),
            A2($f, gv, u.bV),
            A2($f, $v, u.bY),
            A2($f, xv, u.bZ),
            A2($f, Gv, u.c2),
            A2($f, Nv, u.ch)
        ]))), $([
            A2(Uv, u.I, (t = u.cp, e = t, A2(cp, $([
                df("sr-only"),
                Bl("status"),
                Dv
            ]), $([
                ko(e)
            ])))),
            A2(Uv, (r = u.dE, 1 === r.$ || Mv(u.dE)), A4(Bv, u.fI, Sv(u.da), Mv(u.dE), u.dE)),
            A2(Tv, Mv(u.dE), ko(u.et)),
            A2(Uv, Hv(u.dE), A4(Bv, u.fI, Sv(u.da), Mv(u.dE), u.dE))
        ]));
    }, Xv = function(n) {
        return v(n, {
            fI: 3
        });
    }, nm = F2(function(n, r) {
        return v(r, {
            b_: vt(n)
        });
    }), rm = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), tm = function(n) {
        return {
            $: 2,
            a: n
        };
    }, em = F2(function(n, r) {
        return v(r, {
            dE: tm(n)
        });
    }), um = F2(function(n, r) {
        return v(r, {
            cH: vt(n)
        });
    }), am = function(n) {
        return n;
    }, im = F2(function(n, r) {
        return v(r, {
            W: n
        });
    }), om = function(n) {
        return Qv(A2(em, bv, A2(um, n.cw, A2(im, lv, A2(nm, n.b_, A2(rm, $([
            l("modal__header__close", !0)
        ]), A2(am, Xv, mv)))))));
    }, cm = jp, fm = Bn("h2"), sm = Bn("h3"), dm = Bn("h4"), lm = Bn("h5"), bm = Bn("h6"), pm = function(n) {
        switch(n){
            case 0:
                return fm;
            case 1:
                return sm;
            case 2:
                return dm;
            case 3:
                return lm;
            default:
                return bm;
        }
    }, vm = F3(function(n, r, t) {
        return A3(pm, r, $([
            df("modal__header__title"),
            hf(n)
        ]), $([
            ko(t)
        ]));
    }), mm = F2(function(n, r) {
        var t = r.c5, e = r.dE, u = r.Z, a = r.fU, i = r.bw, o = r.a6, c = r.a4, f = r.a3;
        return A2(gl, A2(ff, r.a9, $([
            lf($([
                l("modal__header", !0),
                l("modal__header--sticky", i)
            ]))
        ])), $([
            A2(xo, $([
                lf($([
                    l("modal__header__wrapper", !0),
                    l("modal__header__wrapper--custom", Hl(o))
                ])),
                lf(f)
            ]), A2(Uu, $([
                Jb(A2(si, sv, u)),
                Jb(A2(si, cm, e)),
                Jb(A2(si, A2(vm, n, t), a))
            ]), o)),
            Jb(A2(si, om, c))
        ]));
    }), hm = function(n) {
        return n + "-sr-description";
    }, gm = F2(function(n, r) {
        return A2(xo, $([
            df("sr-only"),
            hf(hm(n))
        ]), $([
            ko(r)
        ]));
    }), _m = vv(2), wm = F2(function(n, r) {
        return v(r, {
            et: n
        });
    }), $m = function(n) {
        var r = n.b_, t = n.cw;
        return A2(xo, $([
            df("modal__close--reflow")
        ]), $([
            Qv(A2(wm, r, A2(em, bv, A2(um, t, A2(im, lv, A2(am, Xv, _m))))))
        ]));
    }, xm = Bn("section"), Cm = function(n) {
        return n + "-header-title";
    }, ym = F2(function(n, r) {
        return n.$ ? r : v(r, {
            a4: n
        });
    }), Im = F2(function(n, r) {
        var t = n.u, e = n.bp, u = r.bs, a = r.bK, i = r.aU, o = r.aC, c = r.fI, f = r.bj, s = r.O, d = r.bm, b = r.a3;
        return A2(Uv, t, A2(xo, A2(ff, r.a9, $([
            lf($([
                l("modal-backdrop", !0),
                l("modal-backdrop--show", t)
            ])),
            lf(b)
        ])), $([
            Jb(A2(si, gm(e), i)),
            A2(xo, $([
                df("modal-close"),
                A2($f, A2(qe, function(n) {
                    return n.cw;
                }, yf), nv(r))
            ]), g),
            A2(xm, $([
                lf($([
                    l("modal", !0),
                    l(Xp(c), !0),
                    l("modal--center", u)
                ])),
                hf(e),
                Bl("dialog"),
                A2($f, Af, a),
                xl(Cm(e)),
                Zp(A2(Uu, Qp(e), A2(si, Xu(hm(e)), i))),
                A2(cf, "aria-modal", "true")
            ]), $([
                A2(xo, g, $([
                    Jb(A2(si, $m, o)),
                    Jb(A2(si, mm(Cm(e)), A2(si, ym(o), d))),
                    A2(xo, $([
                        df("modal__content"),
                        hf(Qp(e))
                    ]), s),
                    Jb(A2(si, ev, f))
                ]))
            ]))
        ])));
    }), Nm = F3(function(n, r, t) {
        return v(t, {
            aC: vt({
                b_: r,
                cw: n
            })
        });
    }), Em = F2(function(n, r) {
        return v(r, {
            O: n
        });
    }), zm = F2(function(n, r) {
        return v(r, {
            bm: vt(n)
        });
    }), Km = F2(function(n, r) {
        return v(r, {
            dE: vt(n)
        });
    }), km = F2(function(n, r) {
        return v(r, {
            fU: vt(n)
        });
    }), Am = F3(function(n, r, t) {
        var e = t.b2, u = t.aZ, a = t.dE;
        return A2(Im, r, A2(Em, $([
            t.O
        ]), A2(zm, A3(Wp, Km, A2(si, Bp, a), A3(Wp, km, u, Yp)), A3(Nm, n(qp(!1)), e, Jp))));
    }), Hm = function(n) {
        return A2(cp, $([
            df("tooltip__title")
        ]), $([
            ko(n)
        ]));
    }, Sm = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mm = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Fm = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), Pm = F2(function(n, r) {
        return v(r, {
            cC: vt(n)
        });
    }), Dm = F2(function(n, r) {
        return v(r, {
            cI: vt(n)
        });
    }), Lm = F2(function(n, r) {
        return v(r, {
            cR: vt(n)
        });
    }), Bm = F2(function(n, r) {
        return v(r, {
            bU: vt(n)
        });
    }), Rm = F2(function(n, r) {
        return v(r, {
            bW: vt(n)
        });
    }), Um = F2(function(n, r) {
        return v(r, {
            bZ: vt(n)
        });
    }), Vm = F4(function(n, r, t, e) {
        return A2(qe, n && !r ? Rm(e) : be, r && 1 === t ? A2(qe, Bm(e), Um("dialog")) : be);
    }), Tm = F3(function(n, r, t) {
        var e, u = r.fI, a = r.bN, i = r.bM, o = r.bv, c = r.bp, f = r.a7;
        return Hl(f) ? A2(cp, (o && 1 === u ? et(yf(n(qp(!0)))) : be)($([
            A2(Cf, "focusout", de(n(Sm(!1)))),
            A2(Cf, "focusin", de(n(Sm(!0)))),
            (e = n(Mm(!0)), A2(Cf, "mousedown", de(e)))
        ])), $([
            Jb(f)
        ])) : Qv(A2(rm, $([
            l("tooltip-trigger", !0)
        ]), A2(em, i, A2(Pm, n(Sm(!1)), A2(Dm, n(Sm(!0)), A2(Lm, n(Mm(!0)), (o && 1 === u ? um(n(qp(!0))) : be)(A2(am, Xv, A5(Vm, t, o, u, c, A4(Fm, be, nm, a, mv))))))))));
    }), jm = function(n) {
        return n + "-wrapper";
    }, Om = F3(function(n, r, t) {
        var e = r.aw, u = r.R, a = t.bv, o = t.bK, c = t.bp, f = t.dE, s = t.fU, d = t.fI, l = t.O;
        return A2(cp, A2(ff, t.a9, $([
            lf(Fp(t)),
            hf(jm(c)),
            Af(jm(c)),
            Lp(n(Ap(!0))),
            Dp(n(Ap(!1)))
        ])), $([
            A3(Tm, n, t, e),
            a ? d ? A3(Am, n, u, t) : yl : A2(cp, $([
                lf(A2(Sp, t, e)),
                Bl("tooltip"),
                A2($f, Af, o),
                hf(c)
            ]), $([
                A3(uv, 1 === d, A2(Pp, Hm, s), ko("")),
                A2(cp, $([
                    df("tooltip__content")
                ]), A2(oi, function(n) {
                    return !i(n, yl);
                }, $([
                    A3(uv, !!d, Jb(A2(si, Gp, f)), yl),
                    l
                ])))
            ]))
        ]));
    }), Gm = Bn("small"), qm = function(n) {
        return A2(Gm, $([
            df("form-label__sub")
        ]), $([
            ko(n)
        ]));
    }, Wm = si(A2(du, gt, "-wrapper")), Jm = function(n) {
        var r = n.au, t = n.bL, e = n.aJ, u = n.et, a = n.fI, i = n.bK, o = n.bp, c = n.a3, f = n.bk;
        return A2(xo, A2(ff, n.a9, $([
            df("form-label-wrapper"),
            lf($([
                l("sr-only", r)
            ])),
            lf(c),
            A2($f, Af, Wm(o))
        ])), $([
            A2(kp, $([
                lf($([
                    l("form-label", !0),
                    l(Kp(a), !0)
                ])),
                A2($f, zp, f),
                A2($f, hf, o),
                A2($f, Af, i)
            ]), $([
                A2(cp, $([
                    df("form-label__content")
                ]), $([
                    op(u),
                    A2(cp, $([
                        df("asterisk"),
                        $l(!0)
                    ]), $([
                        ko("*")
                    ]))
                ])),
                Jb(A2(si, qm, e))
            ])),
            Jb(A2(si, function(n) {
                return A3(Om, n.er, n.dT, n.ao);
            }, t))
        ]));
    }, Ym = F2(function(n, r) {
        var t;
        return n && (t = r).$ ? vt(t.a) : mt;
    }), Zm = F2(function(n, r) {
        var t = n.dJ, e = n.fm, u = n.dK;
        switch(n.ek){
            case 0:
                return A2(Ym, u || e, r);
            case 1:
                return A2(Ym, u || t, r);
            default:
                return A2(Ym, u, r);
        }
    }), Qm = function(n) {
        return Hl(A2(vp, function(n) {
            return A2(Zm, n, n.c9);
        }, n));
    }, Xm = {
        dN: "exclamation-circle-filled",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m-1.5 5.88a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 1 1-3 0zM12 19.63a1.76 1.76 0 0 1-1.75-1.75A1.76 1.76 0 0 1 12 16.13a1.76 1.76 0 0 1 1.75 1.75A1.76 1.76 0 0 1 12 19.63"/></svg>'
    }, nh = F2(function(n, r) {
        return A2(xo, $([
            df("form-item__error-message"),
            hf(n),
            Bl("alert")
        ]), $([
            jp(A2(Op, 0, Bp(Xm))),
            ko(r)
        ]));
    }), rh = function(n) {
        var r = n.c9;
        return Jb(A2(si, nh(n.bp), A2(Zm, n, r)));
    }, th = function(n) {
        var r = n.dR, t = n.bp;
        return A2(xo, $([
            df("form-item__hint"),
            A2($f, hf, t)
        ]), $([
            ko(r)
        ]));
    }, eh = function(n) {
        return n + "-hint";
    }, uh = F2(function(n, r) {
        return v(r, {
            bp: vt(eh(n))
        });
    }), ah = F3(function(n, r, t) {
        return Qm(r) ? Jb(A2(si, rh, r)) : Jb(A2(si, A2(qe, uh(n), th), t));
    }), ih = F2(function(n, r) {
        var t, e, u = r.a3, a = r.bS, i = r.bh, o = r.du, c = r.dN;
        return A2(xo, $([
            lf(h($([
                l("form-item", !0),
                l("form-item--with-label-asterisk", (e = A2(Uu, !1, A2(si, Ep, c)), i.aH && e))
            ]), u))
        ]), $([
            Jb(A2(si, A2(qe, (t = i, A2(qe, Np(t.bp + "-label"), Ip(t.bp))), Jm), c)),
            A2(xo, $([
                df("form-item__wrapper")
            ]), $([
                o,
                A3(ah, i.bp, n, i.as)
            ])),
            Jb(a)
        ]));
    }), oh = function(n) {
        switch(n.$){
            case 0:
                return "icon";
            case 1:
                return "text";
            default:
                return "button";
        }
    }, ch = function(n) {
        return n ? "append" : "prepend";
    }, fh = function(n) {
        var r = n.W;
        return df(A2($t, "-", $([
            "form-field--with",
            ch(n.r),
            oh(r)
        ])));
    }, sh = function(n) {
        return n ? 1 : 0;
    }, dh = F2(function(n, r) {
        var t = r.r, e = r.W;
        switch(e.$){
            case 0:
                var u = e.a;
                return A2(xo, $([
                    lf($([
                        l("form-field__addon", !0),
                        l("form-field__addon--" + ch(t), !0)
                    ]))
                ]), $([
                    jp(A2(Op, sh(n), Bp(u)))
                ]));
            case 1:
                var a = e.a;
                return A2(cp, $([
                    lf($([
                        l("form-field__addon", !0),
                        l("form-field__addon--" + ch(t), !0)
                    ]))
                ]), $([
                    ko(a)
                ]));
            default:
                var i = e.a;
                return A2(xo, $([
                    lf($([
                        l("form-field__addon", !0),
                        l("form-field__addon--" + ch(t), !0)
                    ]))
                ]), $([
                    Qv(i)
                ]));
        }
    }), lh = {
        $: 2
    }, bh = {
        $: 1
    }, ph = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vh = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mh = F2(function(n, r) {
        return A2(Uu, wf, A2(si, Zp, A2(Hs, n, r)));
    }), hh = A2(qe, wl, cf("aria-invalid")), gh = F2(function(n, r) {
        return Qm(n) ? vt(mp(r)) : mt;
    }), _h = Bn("input"), wh = sf("max"), $h = sf("min"), xh = sf("name"), Ch = q, yh = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Ih = function(n) {
        return A8(Ch, F7(function(r, t, e, u, a, i, o) {
            return n({
                di: a,
                $7: e,
                dH: o,
                dM: t,
                fn: r,
                dS: i,
                fH: u
            });
        }), A2(We, "keyCode", ka), A2(We, "key", Wu), A2(We, "ctrlKey", Ge), A2(We, "shiftKey", Ge), yh($([
            A2(We, "altKey", Ge),
            de(!1)
        ])), yh($([
            A2(We, "metaKey", Ge),
            de(!1)
        ])), A2(We, "target", A2(We, "innerHTML", Wu)));
    }, Nh = F2(function(n, r) {
        return A2(Cf, n, Ih(r));
    }), Eh = function(n) {
        return l(n, !0);
    }, zh = F2(function(n, r) {
        return A2(xf, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r));
    }), Kh = F2(function(n, r) {
        return A3(Me, We, r, n);
    }), kh = A2(Kh, $([
        "target",
        "value"
    ]), Wu), Ah = function(n) {
        return A2(zh, "input", A2(fe, Eh, A2(fe, n, kh)));
    }, Hh = sf("placeholder"), Sh = yv("required"), Mh = function(n) {
        return A2(sf, "step", n);
    }, Fh = function(n) {
        switch(n){
            case 0:
                return Hf("email");
            case 1:
                return Hf("number");
            case 2:
                return Hf("password");
            case 3:
                return Hf("text");
            default:
                return Hf("search");
        }
    }, Ph = sf("value"), Dh = F4(function(n, r, t, e) {
        var u, a = t, i = e;
        return A2(Nd, n, A2(_h, A2(ff, i.a9, $([
            hf(i.bp),
            lf($([
                l("form-field__text", !0),
                l((u = i.fI, u ? "" : "form-field__text--s"), !0)
            ])),
            Iv(i.b8),
            Ph(a.ey),
            Fh(i.W),
            A2($f, Af, i.bK),
            xh(i.fp),
            Sh(i.aH),
            A2($f, Hh, i.aF),
            A2($f, $h, i.cu),
            A2($f, wh, i.cs),
            A2($f, Mh, i.c$),
            A2($f, cf("autocomplete"), i.ak),
            hh(Qm(r)),
            A2(mh, A2(gh, r, i.bp), A2(si, Xu(eh(i.bp)), i.as)),
            Ah(A2(qe, i.aQ, ph)),
            Pv(bh),
            Fv(lh),
            A2(Nh, "keydown", vh)
        ])), g));
    }), Lh = F4(function(n, r, t, e) {
        var u = e.fI, a = e.M, i = e.N;
        return A2(xo, $([
            df("form-field__wrapper")
        ]), $([
            Jb(A2(si, dh(u), i)),
            A4(Dh, n, r, t, e),
            Jb(A2(si, dh(u), a))
        ]));
    }), Bh = F4(function(n, r, t, e) {
        var u, a, i = e.M, o = e.N, c = e.b8;
        return A2(xo, $([
            lf($([
                l("form-field", !0),
                l("form-field--error", Qm(r)),
                l("form-field--disabled", c)
            ])),
            A2($f, fh, o),
            A2($f, fh, i)
        ]), $([
            (u = e, a = l(u.N, u.M), A4(1 !== a.a.$ || 1 !== a.b.$ ? Lh : Dh, n, r, t, e))
        ]));
    }), Rh = F2(function(n, r) {
        return v(r, {
            bS: n
        });
    }), Uh = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), Vh = F2(function(n, r) {
        return v(r, {
            dN: n
        });
    }), Th = F2(function(n, r) {
        return v(r, {
            fI: n
        });
    }), jh = F3(function(n, r, t) {
        var e = t, u = A2(yp, r, t), a = A2(si, Th(e.fI ? 1 : 0), e.dN);
        return A2(ih, u, A2(Rh, e.bS, A2(Vh, a, A2(Uh, e.a3, A2(pp, e, A4(Bh, n, u, r, t))))));
    }), Oh = F2(function(n, r) {
        return {
            bS: mt,
            M: mt,
            N: mt,
            ak: mt,
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            as: mt,
            bp: "id-" + r,
            dK: !1,
            dN: mt,
            cs: mt,
            cu: mt,
            fp: r,
            aF: mt,
            aH: !1,
            fI: 1,
            c$: mt,
            bK: mt,
            W: n,
            aP: mt,
            aQ: be
        };
    }), Gh = Oh(3), qh = A2(qe, pl, A2(qe, _l, vt)), Wh = function(n) {
        return n ? qh : Xu(mt);
    }, Jh = F2(function(n, r) {
        return v(r, {
            bS: vt(n)
        });
    }), Yh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zh = F2(function(n, r) {
        return v(r, {
            N: vt({
                r: 0,
                W: Yh(n)
            })
        });
    }), Qh = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), Xh = F2(function(n, r) {
        return v(r, {
            aF: vt(n)
        });
    }), ng = F2(function(n, r) {
        return v(r, {
            et: vt(n)
        });
    }), rg = {
        $: 0
    }, tg = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : rg;
    }, eg = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), ug = function(n) {
        return A2(Wh, Hl(fi(n.dx.fy)), A3(jh, dp, n.dx.fx, A3(eg, fo, n.dK, A2(Jh, il(Kd(ko("Ti invitiamo a controllare che l'indirizzo sia corretto"))), A2(Zh, bp, A2(Xh, "Es. giuliarossi@email.it", A2(Qh, A2(ng, "Indirizzo email", lp), Gh("presenterEmail"))))))));
    }, ag = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ig = function(n) {
        return {
            $: 0,
            a: n
        };
    }, og = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cg = function(n) {
        var r = n.ey, t = n.fU, e = n.et;
        return {
            dh: A2(si, og, n.dh),
            Z: mt,
            b8: !1,
            aH: !1,
            fI: 0,
            et: e,
            fU: t,
            ey: r
        };
    }, fg = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.V, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), sg = function(n) {
        return n.aH;
    }, dg = function(n) {
        return n.aH;
    }, lg = function(n) {
        return n + "-label";
    }, bg = {
        $: 2
    }, pg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vg = {
        $: 1
    }, mg = yv("checked"), hg = A2(Kh, $([
        "target",
        "checked"
    ]), Ge), gg = function(n) {
        return A2(Cf, "change", A2(fe, n, hg));
    }, _g = F3(function(n, r, t) {
        return A2($t, r, A2(xt, n, t));
    }), wg = A2(qe, lu, A2(_g, " ", "-")), $g = F2(function(n, r) {
        return A2($t, "-", $([
            n,
            wg(r),
            "option"
        ]));
    }), xg = F4(function(n, r, t, e) {
        var u = e.aH, a = e.b8, o = e.dN, c = e.ey;
        return A2(kp, $([
            lf($([
                l("form-control", !0),
                l("form-control-option--error", Qm(n)),
                l("form-control--disabled", a || t.b8)
            ]))
        ]), $([
            A2(_h, A2(ff, t.a9, $([
                Hf("radio"),
                lf($([
                    l("form-control__radio", !0)
                ])),
                mg(i(r, vt(c))),
                Iv(a || t.b8),
                hf(A2($g, t.bp, o)),
                xh(t.fp),
                Sh(u),
                gg(Xu(pg(c))),
                Pv(vg),
                Fv(bg)
            ])), g),
            A2(cp, $([
                df("form-control__active-indicator")
            ]), g),
            A2(cp, $([
                df("form-control__text")
            ]), $([
                ko(o)
            ]))
        ]));
    }), Cg = F5(function(n, r, t, e, u) {
        return A2(Nd, n, A2(xo, $([
            lf($([
                l("form-control-group", !0),
                l("form-control-group--column", 1 === r.ay)
            ])),
            hf(r.bp),
            A2($f, Af, r.bK),
            Bl("radiogroup"),
            _v(r.b8),
            xl(lg(r.bp)),
            hh(Qm(e)),
            A2(mh, A2(gh, e, r.bp), A2(si, Xu(eh(r.bp)), r.as))
        ]), A2(Fe, A3(xg, e, t, r), u)));
    }), yg = F5(function(n, r, t, e, u) {
        return {
            dv: r,
            dA: e,
            dN: t,
            fp: n,
            dc: u
        };
    }), Ig = yg, Ng = function(n) {
        switch(n){
            case 2:
                return "";
            case 1:
                return "form-card-group--column";
            default:
                return "form-card-group--row";
        }
    }, Eg = F3(function(n, r, t) {
        var e = r.fU, u = r.et;
        return A2($t, "-", $([
            n.dv,
            wg(A2(xe, 25, A2(Uu, wt(t), A2(Hs, e, u)))),
            "option"
        ]));
    }), zg = F2(function(n, r) {
        return n && r;
    }), Kg = F3(function(n, r, t) {
        return n && r && !Hl(t);
    }), kg = F3(function(n, r, t) {
        return A2(cp, $([
            df("form-card__" + n)
        ]), $([
            ko(t),
            A2(Uv, r, A2(cp, $([
                df("form-control__label-asterisk"),
                $l(!0)
            ]), $([
                ko("*")
            ])))
        ]));
    }), Ag = sf("alt"), Hg = function(n) {
        return A2(Gn, "height", wt(n));
    }, Sg = Bn("img"), Mg = function(n) {
        return A2(sf, "src", rr(n));
    }, Fg = function(n) {
        return A2(Gn, "width", wt(n));
    }, Pg = function(n) {
        var r, t;
        return n.$ ? (t = n.a, A2(cp, $([
            df("form-card__addon")
        ]), $([
            A2(Sg, $([
                Mg(t),
                Fg(72),
                Hg(72),
                Ag(""),
                $l(!0)
            ]), g)
        ]))) : (r = n.a, A2(cp, $([
            df("form-card__addon form-card__addon--with-icon"),
            Af(Vp(r))
        ]), $([
            jp(A2(Op, 1, Bp(r)))
        ])));
    }, Dg = function(n) {
        return n ? "checkbox" : "radio";
    }, Lg = F6(function(n, r, t, e, u, a) {
        var i, o = e.dA, c = e.fp, f = A3(Eg, e, a, u);
        return A2(kp, $([
            lf($([
                l("form-card", !0),
                l("form-card--with-badge", Hl(a.Z)),
                l("form-card--error", r),
                l("form-card--checked", a.at),
                l("form-card--disabled", a.b8 || o),
                l((i = a.fI, 1 === i ? "form-card--l" : ""), !0)
            ]))
        ]), $([
            A2(Pp, fv, a.Z),
            Jb(A2(si, Pg, a.dh)),
            A2(cp, $([
                df("form-card__content-wrapper")
            ]), $([
                Jb(A2(si, A2(kg, "title", A2(zg, e.dc, a.aH)), a.fU)),
                Jb(A2(si, A2(kg, "text", A3(Kg, e.dc, a.aH, a.fU)), a.et))
            ])),
            A2(cp, $([
                df("form-card__input")
            ]), $([
                A2(_h, A2(ff, t, $([
                    Hf(Dg(n)),
                    df("form-control__" + Dg(n)),
                    mg(a.at),
                    Iv(a.b8 || o),
                    hf(f),
                    Sh(a.aH),
                    Af(f),
                    xh(c),
                    gg(a.cG),
                    Pv(a.cI),
                    Fv(a.cC)
                ])), g),
                A2(cp, $([
                    df("form-control__active-indicator")
                ]), g)
            ]))
        ]));
    }), Bg = Lg(0), Rg = F3(function(n, r, t) {
        var e = n.a9, u = n.bK, a = n.as, i = n.b8, o = n.bp, c = n.ay, f = n.fp;
        return A2(xo, $([
            lf($([
                l("form-card-group", !0),
                l(Ng(c), !0)
            ])),
            hf(o),
            A2($f, Af, u),
            Bl("radiogroup"),
            _v(i),
            xl(lg(o)),
            hh(Hl(r)),
            A2(mh, r, A2(si, Xu(eh(o)), a))
        ]), A2(Kt, A3(Bg, Hl(r), e, A5(Ig, f, o, mt, i, !1)), t));
    }), Ug = F3(function(n, r, t) {
        var e = t.aH, u = t.fI, a = t.ey, o = t.fU, c = t.et;
        return {
            dh: t.dh,
            Z: t.Z,
            b8: t.b8,
            at: i(vt(a), r),
            cC: n(bg),
            cG: Xu(n(pg(a))),
            cI: n(vg),
            aH: e,
            fI: u,
            et: c,
            fU: o,
            ey: a
        };
    }), Vg = F5(function(n, r, t, e, u) {
        if (u.$) {
            var a = u.a;
            return A3(Rg, r, A2(gh, t, r.bp), A2(Fe, A2(Ug, n, e), a));
        }
        return A5(Cg, n, r, e, t, u.a);
    }), Tg = F3(function(n, r, t) {
        var e, u = r.V, a = t, i = A2(ha, (e = a.aE).$ ? dg : sg, e.a), o = A2(fg, r, t);
        return A2(ih, o, A2(Rh, a.bS, A2(Uh, a.a3, A2(Vh, a.dN, A2(pp, {
            as: a.as,
            bp: a.bp,
            aH: i
        }, A5(Vg, n, a, o, u, a.aE))))));
    }), jg = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), Og = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gg = F2(function(n, r) {
        return v(r, {
            aE: Og(n)
        });
    }), qg = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), Wg = function(n) {
        return qh(A3(Tg, ag, n.dx.fy, A3(qg, lo, n.dK, A2(Gg, $([
            cg({
                dh: mt,
                et: mt,
                fU: vt("Email personale"),
                ey: 0
            }),
            cg({
                dh: mt,
                et: mt,
                fU: vt("Email PEC"),
                ey: 1
            })
        ]), A2(jg, A2(ng, "Scegli il tipo di email", lp), {
            bS: mt,
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            as: mt,
            bp: "id-presenterEmailType",
            dK: !1,
            dN: mt,
            ay: 2,
            fp: "presenterEmailType",
            aE: ig(g),
            bK: mt,
            aP: mt
        })))));
    }, Jg = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Yg = {
        dN: "smartphone",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16 2c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1zm0-2H8C6.34 0 5 1.34 5 3v18c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3"/><path d="M12 18.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"/></svg>'
    }, Zg = F2(function(n, r) {
        return v(r, {
            aJ: vt(n)
        });
    }), Qg = function(n) {
        return qh(A3(jh, Jg, n.dx.fA, A2(Zh, Yg, A2(Xh, "Es. 333 33333333", A2(Qh, A2(Zg, "Facoltativo, usato come contatto secondario", A2(ng, "Numero di telefono", lp)), Gh("presenterPhone"))))));
    }, Xg = F2(function(n, r) {
        return n.$ ? r : A2(et, n.a, r);
    }), n_ = A2(Me, Xg, g), r_ = function(n) {
        return v(n, {
            aW: 1
        });
    }, t_ = F2(function(n, r) {
        return v(r, {
            O: n
        });
    }), e_ = F2(function(n, r) {
        return v(r, {
            ba: vt(n)
        });
    }), u_ = F2(function(n, r) {
        return v(r, {
            bj: n
        });
    }), a_ = F2(function(n, r) {
        return v(r, {
            Q: vt(n)
        });
    }), i_ = F2(function(n, r) {
        return v(r, {
            fU: vt(n)
        });
    }), o_ = function(n) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            Wg(n),
            ug(n),
            Qg(n)
        ])), A2(a_, r_(A2(e_, "Inserisci i tuoi recapiti: li useremo solo per risponderti entro i termini previsti dalla normativa.", A2(i_, "Dove possiamo contattarti?", rp))), np)));
    }, c_ = function(n) {
        return {
            $: 15,
            a: n
        };
    }, f_ = function(n) {
        return {
            bS: mt,
            ak: mt,
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            ck: mt,
            as: mt,
            bp: "id-" + n,
            dK: !1,
            dN: mt,
            fp: n,
            aF: mt,
            aH: !1,
            fI: 1,
            bK: mt,
            aP: mt,
            aQ: be
        };
    }, s_ = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.ey, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), d_ = {
        $: 2
    }, l_ = {
        $: 1
    }, b_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, p_ = Bn("textarea"), v_ = A2(qe, wt, A2(qe, A2(du, gt, "px"), gt("--pyx-textarea-min-height: "))), m_ = F3(function(n, r, t) {
        var e, u = r, a = t;
        return A2(xo, $([
            lf($([
                l("form-field", !0),
                l("form-field--error", Qm(n)),
                l("form-field--disabled", a.b8)
            ]))
        ]), $([
            A2(p_, A2(ff, a.a9, $([
                hf(a.bp),
                lf($([
                    l("form-field__textarea", !0),
                    l((e = a.fI, e ? "" : "form-field__textarea--s"), !0)
                ])),
                Iv(a.b8),
                Sh(a.aH),
                xh(a.fp),
                Ph(u.ey),
                A2($f, cf("autocomplete"), a.ak),
                A2($f, Af, a.bK),
                A2($f, Hh, a.aF),
                hh(Qm(n)),
                A2(mh, A2(gh, n, a.bp), A2(si, Xu(eh(a.bp)), a.as)),
                A2($f, cf("style"), A2(si, v_, a.ck)),
                Ah(A2(qe, a.aQ, b_)),
                Pv(l_),
                Fv(d_)
            ])), g)
        ]));
    }), h_ = F3(function(n, r, t) {
        var e = t, u = A2(s_, r, t), a = A2(si, Th(e.fI ? 1 : 0), e.dN);
        return A2(ih, u, A2(Rh, e.bS, A2(Uh, e.a3, A2(Vh, a, A2(pp, e, A2(Nd, n, A3(m_, u, r, t)))))));
    }), g_ = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), __ = F2(function(n, r) {
        return v(r, {
            aF: vt(n)
        });
    }), w_ = function(n) {
        return A2(Wh, n.dx.eO, A3(h_, c_, n.dx.eN, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (facoltativo)", lp), f_("dataAccessComments")))));
    }, $_ = function(n) {
        return {
            $: 14,
            a: n
        };
    }, x_ = function(n) {
        return {
            b_: mt,
            a3: g,
            a9: g,
            b8: !1,
            bl: !1,
            bp: n,
            dN: mt,
            bK: mt
        };
    }, C_ = F2(function(n, r) {
        return Jm(A2(Ip, n, r));
    }), y_ = F3(function(n, r, t) {
        var e = t.bK, u = t.bp, a = t.dN, i = t.bl, o = t.b8, c = t.a9, f = t.a3, s = t.b_;
        return A2(xo, $([
            lf($([
                l("toggle", !0),
                l("toggle--disabled", o),
                l("toggle--full-width", i)
            ])),
            lf(f),
            A2($f, Af, e)
        ]), $([
            Jb(A2(si, C_(u), a)),
            A2(_h, A2(ff, c, $([
                Hf("checkbox"),
                df("toggle__input"),
                Iv(o),
                mg(r),
                gg(n),
                hf(u),
                Bl("switch"),
                A2($f, Rp, s)
            ])), g)
        ]));
    }), I_ = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), N_ = function(n) {
        return qh(A3(y_, $_, n.dx.eO, A2(I_, A2(ng, "Chiedo conferma che sia in corso un trattamento di dati personali che mi riguardano e, in caso di riscontro positivo, di ottenere accesso e copia dei relativi dati.", lp), x_("dataAccessSwitch"))));
    }, E_ = {
        dN: "document-signed",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.12 7.12 13.88.88C13.32.32 12.55 0 11.76 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12M14 3.83 17.17 7H14zM19 21c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24z"/><path d="M16 18h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m0-3h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1"/></svg>'
    }, z_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, K_ = A5(zd, 2, Md, 1, 0, z_), k_ = F2(function(n, r) {
        return {
            $: 38,
            a: n,
            b: r
        };
    }), A_ = {
        dN: "question-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="M12 18.62a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m1-4.25h-2v-.1c0-1.3.73-2.47 1.95-3.14.77-.42 1.16-1.25 1.02-2.12-.14-.8-.8-1.46-1.59-1.61-.61-.11-1.2.04-1.66.43-.27.23-.48.52-.59.85-.15.4-.48.69-.9.69h-.15a.93.93 0 0 1-.89-1.21c.22-.71.65-1.36 1.24-1.85 1.23-1.03 3-1.25 4.53-.45.63.33 1.16.84 1.5 1.46 1.16 2.09.37 4.53-1.55 5.57-.57.31-.91.83-.91 1.38z"/></svg>'
    }, H_ = F2(function(n, r) {
        return {
            aZ: mt,
            a3: g,
            b2: "Close",
            O: yl,
            a7: mt,
            a9: g,
            dE: mt,
            bp: n,
            bv: r,
            aG: 4,
            fI: 1,
            bK: mt,
            fU: mt,
            bM: A_,
            bN: mt
        };
    }), S_ = H_, M_ = Bn("br"), F_ = Bn("li"), P_ = Bn("ul"), D_ = F2(function(n, r) {
        return v(r, {
            O: n
        });
    }), L_ = F2(function(n, r) {
        return v(r, {
            aG: n
        });
    }), B_ = F3(function(n, r, t) {
        return A3(Om, k_(t), A2(Lf, r, t), A2(D_, function(n) {
            switch(n){
                case "Accesso ai dati":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di ottenere la conferma dell'esistenza o meno di un trattamento di dati personali che lo riguardano e, in tal caso, di accedere ai dati e alle seguenti informazioni:"),
                        A2(P_, $([
                            df("margin-t-0 margin-b-0 padding-l-s")
                        ]), $([
                            A2(F_, g, $([
                                ko("finalit\xe0 del trattamento")
                            ])),
                            A2(F_, g, $([
                                ko("categorie di dati personali trattati")
                            ])),
                            A2(F_, g, $([
                                ko("destinatari o categorie di destinatari")
                            ])),
                            A2(F_, g, $([
                                ko("periodo di conservazione o criteri utilizzati")
                            ])),
                            A2(F_, g, $([
                                ko("origine dei dati")
                            ])),
                            A2(F_, g, $([
                                ko("esistenza di processi decisionali automatizzati")
                            ]))
                        ])),
                        ko("Ha inoltre diritto di ricevere una copia dei dati personali oggetto di trattamento, nei limiti previsti dalla normativa.")
                    ]));
                case "Rettifica":
                    return ko("L'interessato ha il diritto di ottenere la rettifica dei dati personali inesatti che lo riguardano e, tenuto conto delle finalit\xe0 del trattamento, l'integrazione dei dati personali incompleti, anche fornendo una dichiarazione integrativa.");
                case "Cancellazione":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di ottenere la cancellazione dei dati personali che lo riguardano senza ingiustificato ritardo nei casi previsti dall'art. 17 GDPR, tra cui:"),
                        A2(P_, $([
                            df("margin-t-0 margin-b-0 padding-l-s")
                        ]), $([
                            A2(F_, g, $([
                                ko("i dati non sono pi\xf9 necessari rispetto alle finalit\xe0")
                            ])),
                            A2(F_, g, $([
                                ko("revoca del consenso (ove applicabile)")
                            ])),
                            A2(F_, g, $([
                                ko("opposizione al trattamento")
                            ])),
                            A2(F_, g, $([
                                ko("trattamento illecito")
                            ]))
                        ])),
                        ko("Resta salva la possibilit\xe0 di conservazione nei casi previsti dalla normativa (es. obblighi legali o difesa di un diritto).")
                    ]));
                case "Limitazione del trattamento":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di ottenere la limitazione del trattamento nei seguenti casi:"),
                        A2(P_, $([
                            df("margin-t-0 margin-b-0 padding-l-s")
                        ]), $([
                            A2(F_, g, $([
                                ko("contestazione dell'esattezza dei dati (per il tempo necessario alla verifica)")
                            ])),
                            A2(F_, g, $([
                                ko("trattamento illecito, con opposizione alla cancellazione")
                            ])),
                            A2(F_, g, $([
                                ko("necessit\xe0 dei dati per l'accertamento, esercizio o difesa di un diritto")
                            ])),
                            A2(F_, g, $([
                                ko("opposizione al trattamento, in attesa della verifica sulla prevalenza dei motivi legittimi")
                            ]))
                        ])),
                        ko("In tali casi, i dati sono trattati, salvo che per la conservazione, solo con il consenso dell'interessato o per specifiche finalit\xe0 previste dalla normativa.")
                    ]));
                case "Opposizione":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di opporsi in qualsiasi momento, per motivi connessi alla sua situazione particolare, al trattamento dei dati personali che lo riguardano basato sul legittimo interesse del titolare."),
                        A2(M_, g, g),
                        ko("Il titolare si astiene dal trattare ulteriormente i dati personali salvo che dimostri motivi legittimi prevalenti per procedere al trattamento o per l'accertamento, esercizio o difesa di un diritto.")
                    ]));
                case "Portabilit\xe0 dei dati":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di ricevere i dati personali che lo riguardano in un formato strutturato, di uso comune e leggibile da dispositivo automatico e di trasmetterli a un altro titolare del trattamento, ove tecnicamente fattibile."),
                        A2(M_, g, g),
                        ko("Tale diritto si applica ai dati trattati con mezzi automatizzati e sulla base del consenso o di un contratto.")
                    ]));
                case "Revoca del consenso":
                    return A2(xo, g, $([
                        ko("L'interessato ha il diritto di revocare in qualsiasi momento il consenso ai trattamenti che si basano su tale base giuridica."),
                        A2(M_, g, g),
                        ko("La revoca non pregiudica i trattamenti gi\xe0 effettuati prima della revoca.")
                    ]));
                default:
                    return ko("");
            }
        }(t), A2(L_, 4, A2(S_, "tooltip", n))));
    }), R_ = F4(function(n, r, t, e) {
        return pl(_l($([
            A2(xo, $([
                df("display-flex flex-direction-row align-items-center")
            ]), $([
                A2(xo, $([
                    df("margin-r-m")
                ]), $([
                    il(A2(dl, 0, A2(ll, 0, K_(ko(t))))),
                    il(A2(sl, 19, A2(ll, 0, Kd(ko(e)))))
                ])),
                A2(xo, g, $([
                    A3(B_, n, r, t)
                ]))
            ]))
        ])));
    }), U_ = function(n) {
        switch(n){
            case 1:
                return Eo;
            case 3:
                return Co;
            case 2:
                return Io;
            case 4:
                return yo;
            default:
                return No;
        }
    }, V_ = F2(function(n, r) {
        return {
            an: mt,
            a3: g,
            O: g,
            a9: g,
            dE: U_(n),
            bp: mt,
            S: mt,
            c1: r,
            bK: mt,
            fU: mt,
            da: n
        };
    }), T_ = function(n) {
        return A2(V_, 6, n);
    }, j_ = function(n) {
        switch(n){
            case 0:
                return "message--background-surface-strong";
            case 1:
                return "message--background-surface-on-surface-strong";
            default:
                return "message--background-tint";
        }
    }, O_ = function(n) {
        switch(n){
            case 1:
                return "message--brand";
            case 3:
                return "message--success";
            case 2:
                return "message--alert";
            case 4:
                return "message--error";
            case 5:
                return "message--ghost";
            case 6:
                return "message--informative";
            default:
                return "";
        }
    }, G_ = function(n) {
        return 4 === n ? "alert" : "status";
    }, q_ = function(n) {
        return A2(xo, $([
            df("message__button")
        ]), $([
            Qv(n)
        ]));
    }, W_ = function(n) {
        var r = n.b_, t = n.S;
        return A2(zf, $([
            df("message__close"),
            Hf("button"),
            yf(t),
            Rp(r)
        ]), $([
            jp(Bp(bv))
        ]));
    }, J_ = function(n) {
        return A2(xo, $([
            df("message__title")
        ]), $([
            ko(n)
        ]));
    }, Y_ = function(n) {
        var r = n.da, t = n.c1, e = n.S, u = n.fU, a = n.O, o = n.bK, c = n.bp, f = n.dE, s = n.a3, d = n.an;
        return A2(xo, A2(ff, n.a9, $([
            lf($([
                l("message", !0),
                l(j_(t), !0),
                l(O_(r), !0),
                l("message--dismissable", Hl(e)),
                l("message--with-button", Hl(d)),
                l("message--with-button-bottom", i(A2(si, $a, d), vt(1)))
            ])),
            lf(s),
            A2($f, hf, c),
            A2($f, Af, o),
            Bl(G_(r))
        ])), $([
            A2(xo, $([
                df("message__icon")
            ]), $([
                jp(Bp(f))
            ])),
            A2(xo, $([
                df("message__wrapper")
            ]), $([
                A2(xo, $([
                    df("message__content-wrapper")
                ]), $([
                    Jb(A2(si, J_, u)),
                    A2(xo, $([
                        df("message__text")
                    ]), a)
                ])),
                A2(Pp, q_, A2(si, te, d))
            ])),
            Jb(A2(si, W_, e))
        ]));
    }, Z_ = F2(function(n, r) {
        return v(r, {
            O: n
        });
    }), Q_ = F2(function(n, r) {
        return v(r, {
            bm: n
        });
    }), X_ = F2(function(n, r) {
        return v(r, {
            dE: n
        });
    }), nw = F2(function(n, r) {
        return v(r, {
            fU: vt(n)
        });
    }), rw = F2(function(n, r) {
        return A2(u_, $([
            _l($([
                Y_(A2(X_, E_, A2(Z_, $([
                    il(Kd(ko('I file saranno inviati in formato .pdf all\'indirizzo email dichiarato nella sezione "Dove possiamo contattarti?"')))
                ]), A2(nw, "In che modo inviamo i file", T_(2)))))
            ])),
            sp
        ]), A2(t_, n_($([
            N_(r),
            w_(r)
        ])), A2(Q_, A4(R_, n, r, "Accesso ai dati", "(art. 15 del Regolamento (UE) 2016/679)"), A2(a_, r_(A2(e_, "Di seguito trovi i diritti di cui puoi fare richiesta, come da artt. 15-22 del Regolamento (UE) 2016/679", A2(i_, "Di cosa hai bisogno?", rp))), np))));
    }), tw = function(n) {
        return {
            $: 17,
            a: n
        };
    }, ew = function(n) {
        return A2(Wh, n.dx.eQ, A3(h_, tw, n.dx.eP, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (Facoltativo)", lp), f_("dataChangeComments")))));
    }, uw = function(n) {
        return {
            $: 16,
            a: n
        };
    }, aw = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), iw = function(n) {
        return qh(A3(y_, uw, n.dx.eQ, A2(I_, A2(ng, "Chiedo la rettifica dei dati", lp), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataChangeSwitch")))));
    }, ow = F2(function(n, r) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            iw(r),
            ew(r)
        ])), A2(Q_, A4(R_, n, r, "Rettifica", "(art. 16 del Regolamento (UE) 2016/679)"), np)));
    }), cw = function(n) {
        return {
            $: 35,
            a: n
        };
    }, fw = function(n) {
        return Fe(function(r) {
            var t;
            return {
                b8: !1,
                dN: (t = {
                    dN: ko(n(r)),
                    ey: r
                }).dN,
                aH: !1,
                ey: t.ey
            };
        });
    }, sw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dw = function(n) {
        return {
            bS: mt,
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            as: mt,
            bp: "id-" + n,
            dK: !1,
            dN: mt,
            ay: 2,
            fp: n,
            aE: sw(g),
            ej: !1,
            bK: mt,
            aP: mt
        };
    }, lw = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.F, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), bw = function(n) {
        switch(n){
            case 2:
            case 0:
                return "";
            default:
                return "form-control-group--column";
        }
    }, pw = function(n) {
        return n + "-label";
    }, vw = {
        $: 2
    }, mw = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hw = {
        $: 1
    }, gw = F4(function(n, r, t, e) {
        return {
            bW: mt,
            b8: !1,
            bp: mt,
            dN: mt,
            cC: t,
            cG: n,
            cI: r,
            aH: !1,
            bK: mt,
            ey: e
        };
    }), _w = F2(function(n, r) {
        return v(r, {
            b8: n
        });
    }), ww = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), $w = F2(function(n, r) {
        return v(r, {
            aH: n
        });
    }), xw = F2(function(n, r) {
        var t = r;
        return A2($w, t.aH, A2(_w, t.b8, A2(ww, t.dN, A4(gw, F2(function(r, t) {
            return n(A2(mw, r, t));
        }), n(hw), n(vw), t.ey))));
    }), Cw = F2(function(n, r) {
        return A2(ha, function(r) {
            return i(r, n);
        }, r);
    }), yw = F4(function(n, r, t, e) {
        var u, a = e.bp, i = e.bK, o = e.cG, c = e.cI, f = e.cC, s = e.aH, d = e.bW, b = e.dN, p = e.ey, v = e.b8;
        return A2(kp, $([
            lf($([
                l("form-control", !0),
                l("form-control-option--error", t)
            ]))
        ]), $([
            A2(_h, A2(ff, n.a9, $([
                Hf("checkbox"),
                lf($([
                    l("form-control__checkbox", !0),
                    l("form-control--disabled", v || n.b8)
                ])),
                mg(r),
                Iv(v || n.b8),
                xh(n.fp),
                Sh(s),
                gg(function(n) {
                    return A2(o, p, n);
                }),
                Pv(c),
                Fv(f),
                A2($f, Zp, d),
                hh(t),
                A2($f, Af, i),
                A2($f, hf, a)
            ])), g),
            A2(cp, $([
                df("form-control__active-indicator")
            ]), g),
            A2(cp, $([
                df("form-control__text")
            ]), $([
                A2(Uu, ko(""), b),
                (u = s && n.ej, A2(Uv, u, A2(cp, $([
                    df("form-control__label-asterisk"),
                    $l(!0)
                ]), $([
                    ko("*")
                ]))))
            ]))
        ]));
    }), Iw = F5(function(n, r, t, e, u) {
        var a = u;
        return A4(yw, r, A2(Cw, a.ey, t), e, A2(xw, n, a));
    }), Nw = F5(function(n, r, t, e, u) {
        var a = A4(Iw, n, r, e, Hl(t));
        return A2(xo, $([
            lf($([
                l("form-control-group", !0),
                l(bw(r.ay), !0)
            ])),
            hf(r.bp),
            A2($f, Af, r.bK),
            A2(Nf, It(u) > 1, Bl("group")),
            _v(r.b8),
            A2(mh, t, A2(si, Xu(eh(r.bp)), r.as)),
            xl(pw(r.bp))
        ]), A2(Fe, a, u));
    }), Ew = function(n) {
        switch(n){
            case 2:
                return "";
            case 1:
                return "form-card-group--column";
            default:
                return "form-card-group--row";
        }
    }, zw = Lg(1), Kw = F3(function(n, r, t) {
        var e = n.ej, u = n.a9, a = n.bK, i = n.as, o = n.b8, c = n.bp, f = n.ay, s = n.fp;
        return A2(xo, $([
            lf($([
                l("form-card-group", !0),
                l(Ew(f), !0)
            ])),
            hf(c),
            A2($f, Af, a),
            Bl("group"),
            xl(pw(c)),
            _v(o),
            A2(mh, r, A2(si, Xu(eh(c)), i))
        ]), A2(Kt, A3(zw, Hl(r), u, A5(Ig, s, c, mt, o, e)), t));
    }), kw = F3(function(n, r, t) {
        var e = t.aH, u = t.fI, a = t.ey, i = t.fU, o = t.et;
        return {
            dh: t.dh,
            Z: t.Z,
            b8: t.b8,
            at: A2(Cw, a, r),
            cC: n(vw),
            cG: A2(qe, mw(a), n),
            cI: n(hw),
            aH: e,
            fI: u,
            et: o,
            fU: i,
            ey: a
        };
    }), Aw = F5(function(n, r, t, e, u) {
        if (u.$) {
            var a = u.a;
            return A3(Kw, r, t, A2(Fe, A2(kw, n, e), a));
        }
        return A5(Nw, n, r, t, e, u.a);
    }), Hw = F3(function(n, r, t) {
        var e = r.F, u = t, a = A2(lw, r, t);
        return A2(ih, a, A2(Rh, u.bS, A2(Uh, u.a3, A2(Vh, u.dN, A2(pp, {
            as: u.as,
            bp: u.bp,
            aH: !1
        }, A5(Aw, n, u, A2(gh, a, u.bp), e, u.aE))))));
    }), Sw = function(n) {
        return {
            bp: mt,
            dR: n
        };
    }, Mw = F2(function(n, r) {
        return v(r, {
            as: vt(A2(uh, r.bp, Sw(n)))
        });
    }), Fw = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), Pw = F2(function(n, r) {
        return v(r, {
            ay: n
        });
    }), Dw = F2(function(n, r) {
        return v(r, {
            aE: sw(n)
        });
    }), Lw = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), Bw = function(n) {
        return A2(Wh, n.dx.eL, A3(Hw, cw, n.dx.eJ, A2(Mw, "*Il trattamento di dati particolari pu\xf2 essere necessario per la gestione del sinistro. La revoca del consenso potrebbe impedire o limitare la gestione della pratica.", A3(Lw, to(!0), n.dK, A2(Pw, 1, A2(Dw, A2(fw, Sa, $([
            0,
            1,
            2,
            3,
            4
        ])), A2(Fw, A2(Zg, "Seleziona almeno una categoria", A2(ng, "Per quali trattamenti vuoi revocare il consenso?", lp)), dw("consentRevocationCategories"))))))));
    }, Rw = function(n) {
        return {
            $: 36,
            a: n
        };
    }, Uw = function(n) {
        return A2(Wh, n.dx.eL, A3(h_, Rw, n.dx.eK, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (facoltativo)", lp), f_("consentRevocationComments")))));
    }, Vw = function(n) {
        return {
            $: 34,
            a: n
        };
    }, Tw = function(n) {
        return qh(A3(y_, Vw, n.dx.eL, A2(I_, A2(ng, "Chiedo di revocare il consenso al trattamento dei dati personali", lp), x_("consentRevocationSwitch"))));
    }, jw = F2(function(n, r) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            Tw(r),
            Bw(r),
            Uw(r)
        ])), A2(Q_, A4(R_, n, r, "Revoca del consenso", "(art. 7 del Regolamento (UE) 2016/679)"), np)));
    }), Ow = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Gw = function(n) {
        return A2(Wh, n.dx.eS, A3(h_, Ow, n.dx.eR, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (Facoltativo)", lp), f_("dataDeletionComments")))));
    }, qw = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Ww = function(n) {
        return qh(A3(y_, qw, n.dx.eS, A2(I_, A2(ng, "Chiedo la cancellazione dei dati", lp), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataDeletionSwitch")))));
    }, Jw = F2(function(n, r) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            Ww(r),
            Gw(r)
        ])), A2(Q_, A4(R_, n, r, "Cancellazione", "(art. 17 del Regolamento (UE) 2016/679)"), np)));
    }), Yw = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Zw = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), Qw = function(n) {
        return A2(Wh, n.dx.eU, A3(h_, Yw, n.dx.eT, A3(Zw, eo(!0), n.dK, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi i motivi della richiesta", lp), f_("dataOppositionComments"))))));
    }, Xw = function(n) {
        return {
            $: 24,
            a: n
        };
    }, n$ = function(n) {
        return qh(A3(y_, Xw, n.dx.eU, A2(I_, A2(ng, "Chiedo di oppormi al trattamento dei dati", lp), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataOppositionSwitch")))));
    }, r$ = F2(function(n, r) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            n$(r),
            Qw(r)
        ])), A2(Q_, A4(R_, n, r, "Opposizione", "(art. 21, paragrafo 1 del Regolamento (UE) 2016/679)"), np)));
    }), t$ = function(n) {
        return {
            $: 27,
            a: n
        };
    }, e$ = function(n) {
        return A2(Wh, n.dx.eY, A3(Hw, t$, n.dx.eV, A3(Lw, uo(!0), n.dK, A2(Pw, 1, A2(Dw, A2(fw, Xa, $([
            0,
            1,
            2,
            3
        ])), A2(Fw, A2(Zg, "Seleziona almeno una categoria", A2(ng, "Indica le categorie di dati da portare", lp)), dw("dataPortabilityCategories")))))));
    }, u$ = function(n) {
        return {
            $: 28,
            a: n
        };
    }, a$ = function(n) {
        return A2(Wh, n.dx.eY, A3(h_, u$, n.dx.eW, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (facoltativo)", lp), f_("dataPortabilityComments")))));
    }, i$ = function(n) {
        return {
            $: 29,
            a: n
        };
    }, o$ = function(n) {
        return A2(Wh, n.dx.eY, A3(y_, i$, n.dx.eX, A2(I_, A2(ng, "Confermo che la mia richiesta riguarda dati trattati su base di consenso o contratto", lp), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataPortabilityContractSwitch")))));
    }, c$ = function(n) {
        return {
            $: 26,
            a: n
        };
    }, f$ = function(n) {
        return qh(A3(y_, c$, n.dx.eY, A2(I_, A2(Zg, "Puoi ricevere in formato digitale riutilizzabile (CSV) i dati che ci hai fornito e che trattiamo su base contrattuale o di consenso e con strumenti automatizzati.  Se invece vuoi sapere quali dati trattiamo su di te, scegli il diritto di accesso.", A2(ng, "Voglio ricevere i dati in un formato strutturato, di uso comune e leggibile da dispositivo automatico", lp)), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataPortabilitySwitch")))));
    }, s$ = function(n) {
        return {
            $: 32,
            a: n
        };
    }, d$ = function(n) {
        return A2(Wh, n.dx.eY && n.dx.e0, A3(jh, s$, n.dx.eZ, A3(eg, ao(!0), n.dK, A2(Zh, bp, A2(Xh, "Es. giuliarossi@email.it", A2(Qh, A2(ng, "Indirizzo email", lp), Gh("dataPortabilityThirdPartyEmail")))))));
    }, l$ = function(n) {
        return {
            $: 31,
            a: n
        };
    }, b$ = function(n) {
        return A2(Wh, n.dx.eY && n.dx.e0, A3(jh, l$, n.dx.e_, A3(eg, io(!0), n.dK, A2(Xh, "Es. Giulia Rossi", A2(Qh, A2(ng, "Nome e cognome", lp), Gh("dataPortabilityThirdPartyFullName"))))));
    }, p$ = function(n) {
        return {
            $: 33,
            a: n
        };
    }, v$ = function(n) {
        return A2(Wh, n.dx.eY && n.dx.e0, A3(jh, p$, n.dx.e$, A2(Zh, Yg, A2(Xh, "Es. 333 33333333", A2(Qh, A2(ng, "Numero di telefono (facoltativo)", lp), Gh("dataPortabilityThirdPartyPhone"))))));
    }, m$ = function(n) {
        return {
            $: 30,
            a: n
        };
    }, h$ = function(n) {
        return A2(Wh, n.dx.eY, A3(y_, m$, n.dx.e0, A2(I_, A2(Zg, "La trasmissione diretta sar\xe0 effettuata ove tecnicamente fattibile e sicura", A2(ng, "Voglio trasmettere i dati a un altro titolare del trattamento", lp)), x_("dataPortabilityThirdPartySwitch"))));
    }, g$ = F2(function(n, r) {
        return A2(u_, $([
            _l($([
                Y_(A2(X_, E_, A2(Z_, $([
                    il(Kd(ko('I file saranno inviati in formato .csv all\'indirizzo email dichiarato nella sezione "Dove possiamo contattarti?"')))
                ]), A2(nw, "In che modo inviamo i file", T_(2)))))
            ])),
            sp
        ]), A2(t_, n_($([
            f$(r),
            e$(r),
            a$(r),
            o$(r),
            h$(r),
            b$(r),
            d$(r),
            v$(r)
        ])), A2(Q_, A4(R_, n, r, "Portabilit\xe0 dei dati", "(art. 20 del Regolamento (UE) 2016/679)"), np)));
    }), _$ = function(n) {
        return {
            $: 22,
            a: n
        };
    }, w$ = function(n) {
        return A2(Wh, n.dx.e4, A3(Hw, _$, n.dx.e1, A3(Lw, oo(!0), n.dK, A2(Pw, 1, A2(Dw, A2(fw, ei, $([
            0,
            1,
            2,
            3
        ])), A2(Fw, A2(Zg, "Seleziona almeno una categoria di dati", A2(ng, "A quali dati fa riferimento la richiesta?", lp)), dw("dataTreatmentCategories")))))));
    }, $$ = function(n) {
        return {
            $: 23,
            a: n
        };
    }, x$ = function(n) {
        return A2(Wh, n.dx.e4, A3(h_, $$, n.dx.e2, A2(__, "Scrivi i dettagli della richiesta", A2(g_, A2(ng, "Descrivi meglio la richiesta (Facoltativo)", lp), f_("dataTreatmentLimitsComments")))));
    }, C$ = function(n) {
        return {
            $: 20,
            a: n
        };
    }, y$ = function(n) {
        return qh(A3(y_, C$, n.dx.e4, A2(I_, A2(Zg, "I dati non verranno cancellati, ma il loro utilizzo potr\xe0 essere limitato", A2(ng, "Chiedo la limitazione del trattamento", lp)), A2(aw, $([
            l("right-aligned", !0)
        ]), x_("dataTreatmentLimitsSwitch")))));
    }, I$ = function(n) {
        return {
            $: 21,
            a: n
        };
    }, N$ = function(n) {
        return A2(Wh, n.dx.e4, A3(Hw, I$, n.dx.e3, A3(Lw, co(!0), n.dK, A2(Pw, 1, A2(Dw, A2(fw, ui, $([
            0,
            1,
            2,
            3
        ])), A2(Fw, A2(Zg, "Seleziona almeno una motivazione", A2(ng, "Indica i motivi per cui chiedi la limitazione", lp)), dw("dataTreatmentReasons")))))));
    }, E$ = F2(function(n, r) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            y$(r),
            N$(r),
            w$(r),
            x$(r)
        ])), A2(Q_, A4(R_, n, r, "Limitazione del trattamento", "(art. 18 del Regolamento (UE) 2016/679)"), np)));
    }), z$ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, K$ = function(n) {
        return {
            bS: mt,
            ak: 1,
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            as: mt,
            bp: n,
            dK: !1,
            dN: mt,
            ax: {
                e5: "Day",
                fo: "Month",
                f_: "Year"
            },
            aB: mt,
            fp: n,
            aF: {
                e5: "",
                fo: "",
                f_: ""
            },
            aH: !1,
            fI: 1,
            bK: mt,
            aP: mt,
            aQ: be,
            da: 0
        };
    }, k$ = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.aP, a = r.dK, i = r.bp, o = A2(vp, be, A2(si, A4(Cp, t, a, ci(n), u), e));
        return A3(qs, A2($p, t, {
            bp: i,
            dK: a
        }), o, e);
    }), A$ = {
        $: 10
    }, H$ = {
        $: 11
    }, S$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M$ = function(n) {
        var r = F2(function(n, r) {
            return A3(wv, !i(n, r), vt(n), mt);
        });
        return A2(ce, A2(qe, si(Xu(de(n))), Uu(S$("no change"))), yh($([
            A3(se, r, A2(Kh, $([
                "target",
                "dataset",
                "groupId"
            ]), Wu), A2(Kh, $([
                "relatedTarget",
                "dataset",
                "groupId"
            ]), Wu)),
            A2(ce, A2(qe, vt, de), A2(Kh, $([
                "target",
                "dataset",
                "groupId"
            ]), Wu))
        ])));
    }, F$ = function(n) {
        return !n;
    }, P$ = function(n) {
        return n + "-label";
    }, D$ = {
        $: 6
    }, L$ = {
        $: 3
    }, B$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, R$ = gt("day-"), U$ = F2(function(n, r) {
        switch(r){
            case 0:
                return "off";
            case 1:
                return "on";
            default:
                return "bday-" + n;
        }
    }), V$ = function(n) {
        return n ? "" : "form-field-group__item--s";
    }, T$ = F3(function(n, r, t) {
        var e = r.y, u = t.aB, a = t.ax, i = t.aQ, o = t.aF, c = t.aH, f = t.ak, s = t.bp, d = t.b8, b = t.fI, p = t.a9;
        return A2(xo, $([
            lf($([
                l("form-field-group__item", !0),
                l("form-field-group__item--error", Qm(n)),
                l(V$(b), !0)
            ]))
        ]), $([
            A2(kp, $([
                df("form-field-group__item__label"),
                zp(R$(s))
            ]), $([
                ko(a.e5)
            ])),
            A2(_h, A2(ff, p, $([
                hf(R$(s)),
                df("form-field-group__item__date"),
                Iv(d),
                Sh(c),
                Ph(e.e5),
                xh(R$(s)),
                Hh(o.e5),
                A2(cf, "inputMode", "numeric"),
                A2(cf, "data-group-id", s),
                A2($f, function(n) {
                    return A2(cf, "maxlength", wt(n.e5));
                }, u),
                A2(cf, "autocomplete", A2(U$, "day", f)),
                Ah(A2(qe, i, B$)),
                Pv(L$),
                Fv(D$)
            ])), g)
        ]));
    }), j$ = {
        $: 7
    }, O$ = {
        $: 4
    }, G$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, q$ = gt("month-"), W$ = F3(function(n, r, t) {
        var e = r.y, u = t.aH, a = t.aB, i = t.ax, o = t.aQ, c = t.aF, f = t.ak, s = t.bp, d = t.b8, b = t.fI, p = t.a9;
        return A2(xo, $([
            lf($([
                l("form-field-group__item", !0),
                l("form-field-group__item--error", Qm(n)),
                l(V$(b), !0)
            ]))
        ]), $([
            A2(kp, $([
                df("form-field-group__item__label"),
                zp(q$(s))
            ]), $([
                ko(i.fo)
            ])),
            A2(_h, A2(ff, p, $([
                hf(q$(s)),
                df("form-field-group__item__date"),
                Iv(d),
                Sh(u),
                Ph(e.fo),
                xh(q$(s)),
                Hh(c.fo),
                A2(cf, "inputMode", "numeric"),
                A2(cf, "data-group-id", s),
                A2($f, function(n) {
                    return A2(cf, "maxlength", wt(n.fo));
                }, a),
                A2(cf, "autocomplete", A2(U$, "month", f)),
                Ah(A2(qe, o, G$)),
                Pv(O$),
                Fv(j$)
            ])), g)
        ]));
    }), J$ = {
        $: 8
    }, Y$ = {
        $: 5
    }, Z$ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Q$ = gt("year-"), X$ = F3(function(n, r, t) {
        var e = r.y, u = t.aH, a = t.aB, i = t.ax, o = t.aQ, c = t.aF, f = t.ak, s = t.bp, d = t.b8, b = t.fI, p = t.a9;
        return A2(xo, $([
            lf($([
                l("form-field-group__item", !0),
                l("form-field-group__item--error", Qm(n)),
                l(V$(b), !0)
            ]))
        ]), $([
            A2(kp, $([
                df("form-field-group__item__label"),
                zp(Q$(s))
            ]), $([
                ko(i.f_)
            ])),
            A2(_h, A2(ff, p, $([
                hf(Q$(s)),
                df("form-field-group__item__date"),
                Iv(d),
                Sh(u),
                Ph(e.f_),
                xh(Q$(s)),
                Hh(c.f_),
                A2(cf, "inputMode", "numeric"),
                A2(cf, "data-group-id", s),
                A2($f, function(n) {
                    return A2(cf, "maxlength", wt(n.f_));
                }, a),
                A2(cf, "autocomplete", A2(U$, "year", f)),
                Ah(A2(qe, o, Z$)),
                Pv(Y$),
                Fv(J$)
            ])), g)
        ]));
    }), nx = F3(function(n, r, t) {
        var e = t.da, u = t.as, a = t.bp, i = t.b8, o = t.bK;
        return A2(xo, $([
            df("form-field-group"),
            hf(a),
            A2($f, Af, o),
            Bl("group"),
            xl(P$(a)),
            _v(i),
            A2(mh, A2(gh, n, a), A2(si, Xu(eh(a)), u)),
            A2(Cf, "focusout", M$(A$)),
            A2(Cf, "focusin", M$(H$))
        ]), $([
            A2(Uv, F$(e), A3(T$, n, r, t)),
            A3(W$, n, r, t),
            A3(X$, n, r, t)
        ]));
    }), rx = F3(function(n, r, t) {
        return Qm(r) ? Jb(A2(si, rh, r)) : Jb(A2(si, A2(qe, uh(n), th), t));
    }), tx = function(n) {
        return A2(Gm, $([
            df("form-label__sub")
        ]), $([
            ko(n)
        ]));
    }, ex = F2(function(n, r) {
        return 1 === r.$ ? ko("") : function(n) {
            var r = A2(Uu, "", n.et), t = n.aJ, e = function(n) {
                return n.bp;
            }(n), u = A2(si, function(n) {
                return n + "-wrapper";
            }, e);
            return $e(r) ? ko("") : A2(xo, $([
                df("form-label-wrapper"),
                A2($f, Af, u)
            ]), $([
                A2(cp, $([
                    lf($([
                        l("form-label", !0)
                    ])),
                    A2($f, hf, e)
                ]), $([
                    A2(cp, $([
                        df("form-label__content")
                    ]), $([
                        ko(r)
                    ])),
                    Jb(A2(si, tx, t))
                ]))
            ]));
        }(A2(Np, n + "-label", r.a));
    }), ux = F3(function(n, r, t) {
        var e = n;
        return A2(xo, $([
            lf(A2(et, l("form-item", !0), e.a3))
        ]), $([
            A2(ex, e.bp, e.dN),
            A2(xo, $([
                df("form-item__wrapper")
            ]), $([
                t,
                A3(rx, e.bp, r, e.as)
            ])),
            Jb(e.bS)
        ]));
    }), ax = F3(function(n, r, t) {
        var e = A2(k$, r, t);
        return A3(ux, t, e, A2(Nd, n, A3(nx, e, r, t)));
    }), ix = F2(function(n, r) {
        return v(r, {
            ak: n
        });
    }), ox = F2(function(n, r) {
        return v(r, {
            ax: n
        });
    }), cx = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), fx = F2(function(n, r) {
        return v(r, {
            aB: vt(n)
        });
    }), sx = F2(function(n, r) {
        return v(r, {
            aF: n
        });
    }), dx = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), lx = function(n) {
        return qh(A3(ax, z$, n.dx.fv, A3(dx, Qi, n.dK, A2(fx, {
            e5: 2,
            fo: 2,
            f_: 4
        }, A2(ix, 2, A2(sx, {
            e5: "01",
            fo: "01",
            f_: "1950"
        }, A2(ox, {
            e5: "Giorno",
            fo: "Mese",
            f_: "Anno"
        }, A2(cx, A2(ng, "Data di nascita", lp), K$("presenterBirthDate")))))))));
    }, bx = function(n) {
        return {
            $: 9,
            a: n
        };
    }, px = function(n) {
        return qh(A3(jh, bx, n.dx.fw, A3(eg, Xi, n.dK, A2(Xh, "Es. Milano", A2(Qh, A2(ng, "Luogo di nascita", lp), Gh("presenterBirthPlace"))))));
    }, vx = function(n) {
        return {
            $: 8,
            a: n
        };
    }, mx = function(n) {
        return qh(A3(jh, vx, n.dx.fz, A3(eg, bo, n.dK, A2(Xh, "Es. Giulia Rossi", A2(Qh, A2(ng, "Nome e cognome", lp), Gh("presenterFullName"))))));
    }, hx = function(n) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            mx(n),
            px(n),
            lx(n)
        ])), A2(a_, r_(A2(e_, "Ci servono per gestire la tua richiesta e risponderti entro un mese, come previsto dalla normativa.", A2(i_, "Inserisci i tuoi dati", rp))), np)));
    }, gx = sf("acceptCharset"), _x = function(n) {
        return A2(sf, "action", nr(n));
    }, wx = sf("enctype"), $x = Bn("form"), xx = sf("method"), Cx = yv("noValidate"), yx = function(n) {
        return l(n, !0);
    }, Ix = F2(function(n, r) {
        return A2(xf, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r));
    }), Nx = function(n) {
        return A2(Ix, "submit", A2(fe, yx, de(n)));
    }, Ex = Bn("fieldset"), zx = function(n) {
        return v(n, {
            H: 2
        });
    }, Kx = Jt(1), kx = Bn("legend"), Ax = function(n) {
        return {
            b_: mt,
            b0: mt,
            a3: g,
            a9: g,
            bf: 0,
            dE: n,
            fI: 1,
            da: 0
        };
    }, Hx = function(n) {
        return n ? "icon--strong" : "";
    }, Sx = function(n) {
        switch(n){
            case 0:
                return "icon--boxed";
            case 1:
                return "icon--boxed icon--brand";
            case 2:
                return "icon--boxed icon--success";
            case 3:
                return "icon--boxed icon--alert";
            case 4:
                return "icon--boxed icon--error";
            default:
                return "icon--boxed icon--informative";
        }
    }, Mx = F3(function(n, r, t) {
        return h($([
            l(Sx(n), !0),
            l(Hx(r), !0)
        ]), t);
    }), Fx = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), Px = F2(function(n, r) {
        return v(r, {
            a9: n
        });
    }), Dx = F2(function(n, r) {
        return v(r, {
            b_: vt(n)
        });
    }), Lx = F2(function(n, r) {
        return n.$ ? r : A2(Dx, n.a, r);
    }), Bx = F2(function(n, r) {
        return v(r, {
            b0: vt(n)
        });
    }), Rx = F2(function(n, r) {
        return n.$ ? r : A2(Bx, n.a, r);
    }), Ux = function(n) {
        return jp(function(n) {
            return A2(Rx, n.b0, A2(Lx, n.b_, A2(Px, n.a9, A2(Fx, A3(Mx, n.da, n.bf, n.a3), A2(Op, n.fI, Bp(n.dE))))));
        }(n));
    }, Vx = F2(function(n, r) {
        return v(r, {
            da: n
        });
    }), Tx = function(n) {
        if (n.$) {
            var r = n.a;
            return A2(cp, $([
                df("form-legend__addon")
            ]), $([
                A2(Sg, $([
                    Mg(r),
                    Fg(80)
                ]), g)
            ]));
        }
        var t = n.a;
        return A2(xo, $([
            df("form-legend__addon")
        ]), $([
            Ux(A2(Vx, 1, Ax(t)))
        ]));
    }, jx = function(n) {
        return A2(cp, $([
            df("form-legend__text")
        ]), $([
            ko(n)
        ]));
    }, Ox = Bn("h1"), Gx = function(n) {
        if (n.$) return cp;
        switch(n.a){
            case 0:
                return Ox;
            case 1:
                return fm;
            case 2:
                return sm;
            case 3:
                return dm;
            case 4:
                return lm;
            default:
                return bm;
        }
    }, qx = F2(function(n, r) {
        return A3(Gx, n, $([
            df("form-legend__title")
        ]), $([
            ko(r)
        ]));
    }), Wx = function(n) {
        var r = n;
        return A2(kx, A2(ff, r.a9, $([
            lf(h($([
                l("form-legend", !0),
                l("form-legend--align-left", Kx(r.aW))
            ]), r.a3)),
            A2($f, hf, r.bp),
            A2($f, Af, r.bK)
        ])), $([
            Jb(A2(si, Tx, r.dh)),
            Jb(A2(si, qx(r.bn), r.fU)),
            Jb(A2(si, jx, r.ba))
        ]));
    }, Jx = function(n) {
        return v(n, {
            H: 0
        });
    }, Yx = function(n) {
        return $([
            _l($([
                A2(jd, $([
                    Jx
                ]), n)
            ]))
        ]);
    }, Zx = function(n) {
        return v(n, {
            fI: 2
        });
    }, Qx = function(n) {
        return v(n, {
            fI: 1
        });
    }, Xx = function(n) {
        switch(n){
            case 0:
                return vl;
            case 1:
                return Qx;
            default:
                return Zx;
        }
    }, nC = F2(function(n, r) {
        return $([
            A2(fl, $([
                Xx(n)
            ]), $([
                A2(Hd, g, $([
                    Wx(r)
                ]))
            ]))
        ]);
    }), rC = function(n) {
        return A2(qe, si(nC(n)), Uu(g));
    }, tC = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), eC = function(n) {
        var r = n.bp, t = n.az, e = n.bu, u = n.bS, a = n.Q, i = n.bj, o = n.O, c = n.bm;
        return A2(Ex, A2(ff, n.a9, $([
            lf(n.a3),
            A2($f, hf, r),
            A2($f, Af, r)
        ])), $([
            Jb(A2(si, A2(qe, tC($([
                l("sr-only", !0)
            ])), Wx), a)),
            A2(jd, $([
                zx
            ]), h(u, h(e ? g : A2(rC, t, a), h(c, h(Yx(o), i)))))
        ]));
    }, uC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aC = F2(function(n, r) {
        return {
            bS: mt,
            ak: mt,
            a3: g,
            a9: g,
            aa: mt,
            as: mt,
            bp: "id-" + n,
            t: !1,
            bv: r,
            dK: !1,
            dN: mt,
            fp: n,
            aF: mt,
            aH: !1,
            fI: 1,
            bK: mt,
            aP: mt
        };
    }), iC = {
        $: 3
    }, oC = {
        $: 4
    }, cC = {
        $: 7
    }, fC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sC = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dC = {
        $: 1
    }, lC = cf("aria-activedescendant"), bC = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.V, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), pC = function(n) {
        return n + "-dropdown";
    }, vC = function(n) {
        return n ? "" : "form-dropdown-wrapper--s";
    }, mC = F2(function(n, r) {
        return l(n(function(n) {
            return {
                $: 5,
                a: n
            };
        }(r)), function(n) {
            return Us(n) || Vs(n) || Ts(n) || js(n) || Gs(n);
        }(r));
    }), hC = yv("hidden"), gC = F2(function(n) {
        return !n.bv;
    }), _C = A2(ce, function(n) {
        switch(n){
            case "mouse":
                return de(0);
            case "pen":
                return de(1);
            case "touch":
                return de(2);
            default:
                return S$("");
        }
    }, Wu), wC = (Bb = A2(We, "pointerType", _C), yh($([
        A2(fe, vt, Bb),
        de(mt)
    ]))), $C = function(n) {
        return A2(Cf, "click", A2(fe, n, wC));
    }, xC = F2(function(n, r) {
        return A2(xf, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), CC = F2(function(n, r) {
        return A2(xC, n, Ih(r));
    }), yC = F2(function(n, r) {
        return A2(CC, n, function(n) {
            var t = r(n), e = t.b;
            return {
                dR: t.a,
                d$: e,
                c0: e
            };
        });
    }), IC = F2(function(n, r) {
        return A2(Ix, n, Ih(r));
    }), NC = F2(function(n, r) {
        var t = n.c0;
        return A2(xC, "mousedown", A2(ce, function(n) {
            return n ? S$("not a primary-button mousedown") : de({
                dR: r,
                d$: !0,
                c0: t
            });
        }, yh($([
            A2(We, "button", ka),
            de(0)
        ]))));
    }), EC = F2(function(n, r) {
        return A2(Ix, n, A2(fe, function(n) {
            return l(n, !0);
        }, de(r)));
    }), zC = {
        dN: "chevron-down",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 17a.98.98 0 0 1-.681-.28L5.28 10.642a.964.964 0 0 1 0-1.36.953.953 0 0 1 1.353 0L12 14.675l5.366-5.393a.95.95 0 0 1 1.353 0 .964.964 0 0 1 0 1.36l-6.038 6.069A.95.95 0 0 1 12 17"/></svg>'
    }, KC = function(n) {
        return n ? 1 : 0;
    }, kC = function(n) {
        return A2(xo, $([
            df("form-field__addon form-field__addon--append")
        ]), $([
            jp(A2(Op, KC(n), Bp(zC)))
        ]));
    }, AC = Bn("option"), HC = yv("selected"), SC = F2(function(n, r) {
        var t = n.aF, e = r.aE, u = r.V;
        return A2(et, A2(AC, $([
            hC(!0),
            Iv(!0),
            HC(i(u, mt))
        ]), $([
            Jb(A2(si, ko, t))
        ])), A2(Fe, function(n) {
            var r = n.dN, t = n.ey;
            return A2(AC, $([
                Ph(t),
                HC(i(vt(t), u))
            ]), $([
                ko(r)
            ]));
        }, e));
    }), MC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FC = A2(qe, wt, cf("aria-posinset")), PC = A2(qe, wl, cf("aria-selected")), DC = A2(qe, wt, cf("aria-setsize")), LC = {
        dN: "check",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.725 18a.9.9 0 0 1-.646-.283l-4.813-5.174a1.023 1.023 0 0 1 0-1.376.863.863 0 0 1 1.283 0l4.176 4.48 8.726-9.361a.863.863 0 0 1 1.283 0c.355.38.355.995 0 1.376L10.37 17.717a.9.9 0 0 1-.646.283"/></svg>'
    }, BC = F2(function(n, r) {
        return v(r, {
            b4: vt(n)
        });
    }), RC = F2(function(n, r) {
        var t = r.aE, e = r.j, u = r.V, a = function(n) {
            return A2(Uu, !1, A2(si, A2(qe, Js, Jt(n)), e));
        };
        return A2(Kt, F2(function(r, e) {
            var o = e.dN, c = e.ey, f = e.bp;
            return A2(Nd, n, A2(xo, $([
                lf($([
                    l("form-dropdown__item", !0),
                    l("form-dropdown__item--focus", a(c)),
                    l("form-dropdown__item--active", i(u, vt(c)))
                ])),
                hf(f),
                Bl("option"),
                PC(i(u, vt(c))),
                FC(r + 1),
                DC(It(t)),
                A2(NC, {
                    c0: !1
                }, MC(e)),
                jv(-1)
            ]), $([
                ko(o),
                A2(Uv, i(u, vt(c)), jp(A2(BC, 6, A2(Op, 2, Bp(LC)))))
            ])));
        }), t);
    }), UC = Bn("select"), VC = F2(function(n, r) {
        return A2(zh, n, de(l(r, !0)));
    }), TC = F3(function(n, r, t) {
        var e, u = r, a = t, o = A2(gC, t, r), c = A2(bC, r, t), f = A2(si, Th(a.fI ? 1 : 0), a.dN), s = u.u ? A2(si, A2(qe, Ls, function(n) {
            return n.bp;
        }), u.j) : mt;
        return A2(ih, c, A2(Uh, a.a3, A2(Vh, f, A2(Rh, a.bS, A2(pp, {
            as: A2(si, uh(a.bp), a.as),
            bp: a.bp,
            aH: a.aH
        }, A2(xo, $([
            lf($([
                l("form-field", !0),
                l("form-field--with-custom-dropdown", o),
                l("form-field--with-opened-dropdown", o && u.u),
                l("form-field--error", Qm(c)),
                l("form-field--disabled", a.t)
            ]))
        ]), $([
            A2(xo, $([
                lf($([
                    l("form-field__wrapper", !0),
                    l("form-field__wrapper--with-select", !0),
                    l("form-field__wrapper--with-select-s", !a.fI)
                ])),
                jv(-1),
                A2(Nf, o && !a.t, A2(VC, "mousedown", n(cC))),
                A2(Nf, o && !a.t, $C(A2(qe, fC, n))),
                A2(EC, "focusout", n(iC)),
                A2(Nf, o && !a.t, A2(IC, "keydown", mC(n)))
            ]), $([
                A2(UC, A2(ff, a.a9, $([
                    lf($([
                        l("form-field__select", !0),
                        l("form-field__select--full-width", !0),
                        l("form-field__select--with-no-pointer-events", o),
                        l("form-field__select--filled", !i(u.V, mt)),
                        l("form-field__select--native", !0),
                        l((e = a.fI, e ? "" : "form-field__select--s"), !0)
                    ])),
                    xh(a.fp),
                    hf(a.bp),
                    Iv(a.t),
                    Sh(a.aH),
                    A2($f, Af, a.bK),
                    A2($f, cf("autocomplete"), a.ak),
                    A2(Nf, !a.t, Ah(A2(qe, sC, n))),
                    A2(Nf, !a.t, Pv(n(oC))),
                    A2(Nf, o && !a.t, A2(VC, "click", n(dC))),
                    A2(Nf, o, Bl("combobox")),
                    A2(Nf, o, hv(pC(a.bp))),
                    A2(Nf, o, xv("listbox")),
                    A2(Nf, o, $v(u.u)),
                    A2(Nf, o, A2($f, lC, s)),
                    A2(Nf, o && !a.t, A2(yC, "keydown", mC(n))),
                    hh(Qm(c)),
                    A2(mh, A2(gh, c, a.bp), A2(si, Xu(eh(a.bp)), a.as))
                ])), A2(SC, t, r)),
                kC(a.fI),
                A2(xo, $([
                    lf($([
                        l("form-dropdown-wrapper", !0),
                        l(vC(a.fI), !0)
                    ])),
                    A2(Nf, o && u.u, A2(NC, {
                        c0: !0
                    }, n(cC))),
                    A2(Nf, !o, A2(cf, "aria-hidden", "true"))
                ]), $([
                    A2(xo, $([
                        lf($([
                            l("form-dropdown", !0),
                            l("form-dropdown--with-animation", !0),
                            l("form-dropdown--s", !a.fI)
                        ])),
                        hf(pC(a.bp)),
                        Bl("listbox"),
                        xl(a.bp),
                        jv(-1),
                        hC(!u.u)
                    ]), A2(RC, n, r))
                ]))
            ]))
        ])))))));
    }), jC = F2(function(n, r) {
        return v(r, {
            dN: vt(n)
        });
    }), OC = F2(function(n, r) {
        return v(r, {
            aF: vt(n)
        });
    }), GC = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), qC = F2(function(n, r) {
        return qh(A3(TC, uC, r.dx.fD, A3(GC, mo, r.dK, A2(OC, "Seleziona un'opzione", A2(jC, A2(ng, "Indica la persona selezionando una delle opzioni", lp), A2(aC, "requester", n))))));
    }), WC = F2(function(n, r) {
        return A2(t_, n_($([
            A2(qC, n, r)
        ])), A2(a_, r_(A2(i_, "Chi sta effettuando la richiesta?", rp)), np));
    }), JC = function(n) {
        return {
            $: 3,
            a: n
        };
    }, YC = function(n) {
        return i(bi(n.dx.fD), vt("REPRESENTATIVE"));
    }, ZC = function(n) {
        return qh(A3(ax, JC, n.dx.fM, A3(dx, ho(YC(n)), n.dK, A2(fx, {
            e5: 2,
            fo: 2,
            f_: 4
        }, A2(ix, 2, A2(sx, {
            e5: "01",
            fo: "01",
            f_: "1950"
        }, A2(ox, {
            e5: "Giorno",
            fo: "Mese",
            f_: "Anno"
        }, A2(cx, A2(ng, "Data di nascita", lp), K$("subjectBirthDate")))))))));
    }, QC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XC = function(n) {
        return qh(A3(jh, QC, n.dx.fN, A3(eg, go(YC(n)), n.dK, A2(Xh, "Es. Milano", A2(Qh, A2(ng, "Luogo di nascita", lp), Gh("subjectBirthPlace"))))));
    }, ny = {
        bQ: mt,
        a3: g,
        a9: g,
        b8: !1,
        aa: mt,
        ce: mt,
        cf: mt,
        as: mt,
        dK: !1,
        dN: mt,
        cx: mt,
        fp: mt,
        aF: mt,
        cX: {
            b3: mt,
            cb: mt,
            bv: false,
            de: !1,
            df: mt
        },
        bD: g,
        aH: !1,
        cZ: mt,
        bK: mt,
        aP: mt
    }, ry = {
        m: mt,
        dh: vt({
            $: 0
        }),
        a3: g,
        a9: g,
        bK: mt,
        et: mt,
        fU: mt
    }, ty = F2(function(n, r) {
        var t = n.bp, e = n.bi, u = r.aa, a = r.aP, i = r.dK, o = A2(vp, be, A2(si, A4(Cp, e, i, A2(Fe, function(n) {
            return n.p;
        }, n.G), a), u));
        return A3(qs, A2($p, e, {
            bp: t,
            dK: i
        }), o, u);
    }), ey = F2(function(n, r) {
        return v(r, {
            b3: n
        });
    }), uy = F2(function(n, r) {
        return v(r, {
            cb: n
        });
    }), ay = F2(function(n, r) {
        return v(r, {
            de: n
        });
    }), iy = F2(function(n, r) {
        return v(r, {
            df: n
        });
    }), oy = {
        $: 0
    }, cy = {
        $: 3
    }, fy = {
        $: 4
    }, sy = function(n) {
        return {
            $: 2,
            a: n
        };
    }, dy = {
        $: 1
    }, ly = sf("accept"), by = rt, py = A2(Kh, $([
        "target",
        "files"
    ]), function(n) {
        return {
            $: 3,
            b: n
        };
    }(by)), vy = A2(qe, Fe(ps), $t(", ")), my = function(n) {
        return It(n);
    }, hy = function(n) {
        return "You are uploading " + wt(my(n)) + " files: " + vy(n);
    }, gy = function(n) {
        return "File " + n + " selected";
    }, _y = F2(function(n, r) {
        var t = n.cx, e = r.G, u = A2(Uu, gy, n.cZ), a = A2(Uu, hy, t), i = A2(Fe, function(n) {
            return n.p;
        }, e);
        return my(i) > 0 ? A3(uv, my(i) > 1, a(i), u(vy(i))) : "";
    }), wy = F2(function(n, r) {
        return "You have uploaded " + wt(r) + " files out of " + wt(n);
    }), $y = function(n) {
        return "File " + n + " uploaded";
    }, xy = function(n) {
        return It(A2(oi, function(n) {
            return i(n.c8, 1);
        }, n));
    }, Cy = yv("multiple"), yy = function(n) {
        return A2(Cf, "dragleave", de(n));
    }, Iy = jp(Bp({
        dN: "plus-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="M16 11h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1"/></svg>'
    })), Ny = function(n) {
        return il(A2(dl, 0, Kd(ko(n))));
    }, Ey = F3(function(n, r, t) {
        var e, u, a, i, o, c, f, s, d = n.bp, b = n.bd, p = t.bK, v = t.aF, m = t.aH, _ = t.b8, w = t.bQ, x = t.fp;
        return A2(Nd, n.er, A2(xo, g, $([
            A2(xo, A2(ff, t.a9, $([
                hf("wrapper-" + d),
                A2($f, Af, p),
                lf($([
                    l("multiupload", !0),
                    l("multiupload--dragover", b),
                    l("multiupload--error", Qm(r)),
                    l("multiupload--disabled", _)
                ]))
            ])), $([
                A2(_h, $([
                    hf(d),
                    A2($f, ly, w),
                    Iv(_),
                    df("multiupload__input"),
                    Cy(!0),
                    A2(Cf, "change", A2(fe, sy, py)),
                    Fv(oy),
                    Pv(dy),
                    Hf("file"),
                    Ph(""),
                    (s = cy, A2(Cf, "dragenter", de(s))),
                    yy(fy),
                    A2($f, xh, x),
                    Sh(m)
                ]), g),
                A2(xo, $([
                    df("multiupload__content")
                ]), $([
                    Iy,
                    A2(Pp, Ny, v)
                ]))
            ])),
            A2(xo, $([
                df("sr-only"),
                Dv
            ]), $([
                ko(h(A2(_y, t, n), (e = t, u = e.bD, a = e.ce, i = A2(Uu, $y, e.cf), o = A2(Uu, wy, a), c = A2(Fe, function(n) {
                    return n.p.p;
                }, u), f = It(c), xy(u) > 0 ? A3(uv, xy(u) > 1, A2(o, f, xy(u)), i(vy(c))) : "")))
            ]))
        ])));
    }), zy = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ky = F2(function(n, r) {
        return {
            bh: n,
            ap: r
        };
    }), ky = F3(function(n, r, t) {
        return {
            fp: n,
            fI: r,
            ex: t
        };
    }), Ay = function(n) {
        var r;
        return A2(Ky, n, A3(ky, (r = n).p.fp, r.p.fI, r.p.ex));
    }, Hy = function(n) {
        return A2(Uu, "", function(n) {
            n: for(;;){
                if (n.b) {
                    if (n.b.b) {
                        n = n.b;
                        continue n;
                    }
                    return vt(n.a);
                }
                return mt;
            }
        }(A2(xt, ".", n)));
    }, Sy = {
        dN: "paperclip",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 24c-3.86 0-7-3.14-7-7V5c0-2.76 2.24-5 5-5s5 2.24 5 5v12c0 1.65-1.35 3-3 3s-3-1.35-3-3V6c0-.55.45-1 1-1s1 .45 1 1v11c0 .55.45 1 1 1s1-.45 1-1V5c0-1.65-1.35-3-3-3S7 3.35 7 5v12c0 2.76 2.24 5 5 5s5-2.24 5-5V6c0-.55.45-1 1-1s1 .45 1 1v11c0 3.86-3.14 7-7 7"/></svg>'
    }, My = function(n) {
        return A3(uv, A2(Cw, n, $([
            "jpg",
            "jpeg",
            "png",
            "gif",
            "bmp",
            "webp"
        ])), bt(1), ft(Sy));
    }, Fy = function(n) {
        return A2(oi, function(n) {
            return !!My(Hy(n.ap.fp)).$;
        }, n);
    }, Py = function(n) {
        return A2(oi, function(n) {
            return po(My(Hy(n.ap.fp)));
        }, n);
    }, Dy = k, Ly = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), By = F2(function(n, r) {
        return 0 > n ? mt : Bs(A2(Ly, n, r));
    }), Ry = E, Uy = F2(function(n, r) {
        var t = $([
            "B",
            "KB",
            "MB",
            "GB",
            "TB"
        ]);
        return s(r, 1024) > -1 && 0 > s(n, It(t) - 1) ? A2(Uy, n + 1, r / 1024) : A2(Dy, wt(Ry(r)), A2(Uu, "", A2(By, n, t)));
    }), Vy = {
        dN: "document",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.12 7.12 13.88.88C13.32.32 12.55 0 11.76 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12M14 3.83 17.17 7H14zM19 21c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24z"/></svg>'
    }, Ty = {
        dN: "document-pdf",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.12 7.12 13.88.88C13.31.31 12.56 0 11.76 0H6C4.35 0 3 1.35 3 3v9.5a1 1 0 0 0 2 0V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24v3.26c0 .55.45 1 1 1s1-.45 1-1V9.24c0-.8-.31-1.55-.88-2.12M14 3.83 17.17 7H14zm5.18 20.168h-1.908V15.49h5.484v1.8h-3.588v1.8h3.156v1.728H19.18zm-8.824-1.788h1.104c1.307 0 2.375-.756 2.375-2.46s-1.068-2.472-2.376-2.472h-1.104zm1.175 1.788H8.46V15.49h3.085c2.556 0 4.272 1.632 4.272 4.26s-1.716 4.248-4.285 4.248m-8.524-4.692h1.104c.72 0 1.212-.42 1.212-1.08 0-.684-.492-1.092-1.212-1.092H3.008zm1.296 1.632H2.996v3.06H1.1V15.49h3.204c1.728 0 2.916 1.14 2.916 2.724 0 1.608-1.188 2.724-2.916 2.724"/></svg>'
    }, jy = function(n) {
        return A3(uv, A2(Cw, n, $([
            "pdf"
        ])), bt(l(1, Ty)), ft(Sy));
    }, Oy = {
        dN: "video",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18 16.004v.663A3.333 3.333 0 0 1 14.667 20H5.333A3.333 3.333 0 0 1 2 16.667V7.333A3.333 3.333 0 0 1 5.333 4h9.334A3.333 3.333 0 0 1 18 7.333v.663l3.058-1.744a1.9 1.9 0 0 1 2.044.101c.291.206.518.482.67.793.151.31.228.652.228.994v7.72c0 .341-.077.684-.228.994a2.1 2.1 0 0 1-.67.793 1.9 1.9 0 0 1-2.044.101zM4.39 6.391c.25-.25.59-.391.943-.391h9.334A1.333 1.333 0 0 1 16 7.333v9.334A1.334 1.334 0 0 1 14.667 18H5.333A1.334 1.334 0 0 1 4 16.667V7.333c0-.353.14-.692.39-.942M18 13.7l3.977 2.27a.3.3 0 0 0 .023-.112V8.141a.3.3 0 0 0-.023-.111L18 10.299z" clip-rule="evenodd"/></svg>'
    }, Gy = F2(function(n, r) {
        return 1 === n.$ ? r : n;
    }), qy = function(n) {
        var r = Hy(n);
        return A2(Gy, function(n) {
            return A3(uv, A2(Cw, n, $([
                "mp4",
                "avi",
                "mkv",
                "mov"
            ])), bt(l(2, Oy)), ft(Sy));
        }(r), A2(Gy, function(n) {
            return A3(uv, A2(Cw, n, $([
                "txt",
                "doc",
                "docx",
                "odt",
                "ppt",
                "pptx",
                "rtf",
                "csv"
            ])), bt(l(0, Vy)), ft(Sy));
        }(r), jy(r)));
    }, Wy = F2(function(n, r) {
        return Qv(A2(rm, $([
            l("multiupload__preview__file__close-button", !0)
        ]), A2(um, r(n), A2(am, Xv, A2(em, bv, mv)))));
    }), Jy = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), Yy = F2(function(n, r) {
        return A2(Uu, r, A2(si, function(n) {
            return n(r);
        }, A2(si, function(n) {
            return im(A3(Jy, n, mt, 1));
        }, n)));
    }), Zy = {
        dN: "download",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18.094 23H5.906c-1.788 0-3.322-1.15-3.86-2.74-.203-.62.294-1.26.965-1.26.426 0 .833.24.965.63.274.8 1.036 1.37 1.93 1.37h12.188c.894 0 1.656-.57 1.93-1.37.132-.39.549-.63.965-.63.67 0 1.168.64.965 1.26-.538 1.59-2.072 2.74-3.86 2.74m-2.031-12a1.023 1.023 0 0 0-1.432 0l-1.615 1.59V2c0-.55-.457-1-1.016-1a1.01 1.01 0 0 0-1.016 1v10.59L9.37 11a1.023 1.023 0 0 0-1.432 0 .985.985 0 0 0 0 1.41l3.342 3.29c.203.2.457.3.721.3s.518-.1.721-.29l3.342-3.3a.985.985 0 0 0 0-1.41"/></svg>'
    }, Qy = F2(function(n, r) {
        return Qv(A2(Yy, r, A2(nm, A2(Uu, "open pdf in a new tab", n), A2(am, Xv, A2(em, Zy, mv)))));
    }), Xy = F2(function(n, r) {
        var t, e, u = n.cb, a = r.ap, i = r.bh, o = a.fI, c = a.fp, f = i.dW, s = i.bp;
        return $([
            (t = qy(a.fp), e = t.$ ? t.a : t.a.b, jp(A2(Fx, $([
                l("multiupload__preview__file__icon", !0)
            ]), A2(Op, 1, Bp(e))))),
            A2(xo, $([
                df("pyx-typo-body-m-book c-content")
            ]), $([
                ko(c),
                A2(xo, $([
                    df("pyx-typo-body-s-book c-content-weak")
                ]), $([
                    ko(A2(Uy, 0, o))
                ]))
            ])),
            A2(xo, $([
                df("multiupload__preview__file__actions")
            ]), $([
                A2(Uv, Hl(Yb(jy(Hy(c)))), A2(Qy, u, a.ex)),
                A2(Pp, Wy(s), f)
            ]))
        ]);
    }), nI = jp(A2(Op, 0, Bp(Xm))), rI = F2(function(n, r) {
        return A2(xo, $([
            df("form-item__error-message"),
            Bl("alert"),
            hf(n + "-error-message")
        ]), $([
            nI,
            ko(r)
        ]));
    }), tI = A2(xo, $([
        df("multiupload__preview__file__loader")
    ]), g), eI = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), uI = F2(function(n, r) {
        return A2(Uu, r, A2(si, function(n) {
            return n(r);
        }, A2(si, function(n) {
            return nm(n);
        }, n)));
    }), aI = {
        dN: "magnifying-glass-plus",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.782 5.65c.569 0 1.033.464 1.033 1.033v2.066h2.067c.568 0 1.033.465 1.033 1.033 0 .569-.465 1.033-1.033 1.033h-2.067v2.067c0 .568-.464 1.033-1.033 1.033a1.036 1.036 0 0 1-1.033-1.033v-2.067H6.683a1.036 1.036 0 0 1-1.034-1.033c0-.568.465-1.033 1.034-1.033h2.066V6.683c0-.569.465-1.034 1.033-1.034"/><path fill-rule="evenodd" d="M9.782 1a8.793 8.793 0 0 1 8.782 8.782 8.76 8.76 0 0 1-1.89 5.435l6.024 6.024a1.03 1.03 0 1 1-1.457 1.457l-6.024-6.024a8.76 8.76 0 0 1-5.435 1.89A8.793 8.793 0 0 1 1 9.782 8.793 8.793 0 0 1 9.782 1m0 2.066c-3.699 0-6.715 3.017-6.716 6.716 0 3.7 3.017 6.716 6.716 6.716s6.716-3.017 6.716-6.716-3.017-6.716-6.716-6.716" clip-rule="evenodd"/></svg>'
    }, iI = vv(0), oI = function(n) {
        return v(n, {
            fI: 1
        });
    }, cI = function(n) {
        return v(n, {
            fI: 2
        });
    }, fI = F4(function(n, r, t, e) {
        return A2(xo, $([
            df("multiupload__preview__file__open-in-playground"),
            A2(cf, "data-style", "vibrant")
        ]), $([
            A2(Nd, n, Qv(A2(am, A3(uv, t, cI, oI), A2(um, A2(eI, !0, vt(e)), A2(uI, r, A2(em, aI, iI))))))
        ]));
    }), sI = F4(function(n, r, t, e) {
        var u = t.de, a = t.df, i = e.ap, o = e.bh, c = i.ex, f = i.fI, s = i.fp, d = o.dW, l = o.c8, b = o.bp;
        return $([
            A2(xo, $([
                df("multiupload__preview__file__image-container")
            ]), $([
                A2(Sg, $([
                    df("multiupload__preview__file__image"),
                    A2($f, Mg, c),
                    Ag(i.fp)
                ]), g),
                A2(Uv, u, A4(fI, n, a, r, i))
            ])),
            A2(xo, $([
                df("multiupload__preview__file__info")
            ]), $([
                A2(xo, $([
                    df("pyx-typo-body-m-book c-content")
                ]), $([
                    ko(s),
                    A2(xo, $([
                        df("pyx-typo-body-s-book c-content-weak")
                    ]), $([
                        ko(A2(Uy, 0, f))
                    ]))
                ])),
                A2(Pp, Wy(b), d)
            ])),
            A2(Uv, !l, tI)
        ]);
    }), dI = F4(function(n, r, t, e) {
        var u = e.fp;
        return A2(Im, t, A2(Em, $([
            A2(Sg, $([
                Mg(A2(Uu, "", e.ex)),
                Ag(u)
            ]), g)
        ]), A2(zm, A2(km, u, Yp), A3(Nm, n(A2(eI, !1, mt)), A2(Uu, "close", r), Jp))));
    }), lI = F6(function(n, r, t, e, u, a) {
        var i, o = t.bq, c = t.R, f = e.b3, s = a.bh, d = s.dr, b = s.bK, p = s.a3, v = s.c8, m = s.bp;
        return $([
            A2(F_, A2(ff, s.a9, $([
                lf(A2(et, l("multiupload__preview", !0), p)),
                hf(m),
                A2($f, Af, b)
            ])), $([
                A2(xo, $([
                    lf($([
                        l("multiupload__preview__file", !0),
                        l("multiupload__preview__file--error", Hl(d))
                    ]))
                ]), h((i = u, i ? A4(sI, n, r, e, a) : A2(Xy, e, a)), $([
                    A2(Uv, !v, tI)
                ])))
            ])),
            A2(Pp, rI(m), d),
            A2(Pp, A3(dI, n, f, c), o)
        ]);
    }), bI = F4(function(n, r, t, e) {
        var u = t.bv;
        return $([
            A2(P_, $([
                df("multiupload__preview__list multiupload__preview__list--docs")
            ]), A2(Bu, A5(lI, n, u, r, t, 0), Fy(e))),
            A2(P_, $([
                df("multiupload__preview__list multiupload__preview__list--image")
            ]), A2(Bu, A5(lI, n, u, r, t, 1), Py(e)))
        ]);
    }), pI = F3(function(n, r, t) {
        var e = n.aq;
        return A4(bI, A2(qe, zy, n.er), e, t, A2(Fe, Ay, r));
    }), vI = F2(function(n, r) {
        var t, e = n.bp, u = r.a3, a = r.bD, i = r.aH, o = r.dN, c = r.as, f = A2(ey, (t = r.cX).b3, A2(ay, t.de, A2(iy, t.df, A2(uy, t.cb, function(n) {
            return {
                b3: mt,
                cb: mt,
                bv: n,
                de: !0,
                df: mt
            };
        }(t.bv))))), s = A2(ty, n, r);
        return A2(ih, s, A2(Uh, u, A2(Vh, o, A2(pp, {
            as: c,
            bp: e,
            aH: i
        }, A2(xo, g, A2(et, A3(Ey, n, s, r), A3(pI, n, a, f)))))));
    }), mI = function(n) {
        return n ? "list--item-inline" : "list--item-block";
    }, hI = function(n) {
        switch(n){
            case 0:
                return "list--s";
            case 1:
                return "list--m";
            default:
                return "list--l";
        }
    }, gI = {
        $: 1
    }, _I = F3(function(n, r, t) {
        var e = n ? "list--item-width-full-width" : "list--item-width-content", u = 1 === t, a = i(r, gI);
        return A3(uv, a && u, e, "");
    }), wI = function(n) {
        switch(n.$){
            case 0:
                return "list--inline";
            case 1:
                return "list--block";
            case 2:
                return "list--columns";
            default:
                return "list--columns-horizontal";
        }
    }, $I = Bn("dd"), xI = Bn("dt"), CI = function(n) {
        var r = n.cH, t = n.dN, e = n.dE;
        return A2(xo, $([
            df("list__item__action")
        ]), $([
            Qv(A2(rm, $([
                l("button--shift-left", !0)
            ]), A2(um, r, A2(wm, t, A2(am, Xv, A2(em, e, mv))))))
        ]));
    }, yI = cf("decoding"), II = F3(function(n, r, t) {
        return n.$ ? Sl(r) && Sl(t) ? Ag("") : wf : Ag(n.a);
    }), NI = function(n) {
        return A2($t, " ", A2(Fe, te, A2(oi, $a, A2(oi, A2(qe, te, A2(qe, $e, ga)), A2(et, l("illustration", !0), n)))));
    }, EI = A2(qe, si(function(n) {
        return A2(cf, "style", function(n) {
            return i(Ol(n), mt) ? "--pyx-illustration-size: " + n : "--pyx-illustration-size: " + n + "px";
        }(n));
    }), A2(qe, si(pl), Uu(g))), zI = cf("loading"), KI = function(n) {
        return n.dN;
    }, kI = function(n) {
        return "https://cdn.prima.design/pyxis-illustrations/" + n.dN + ".svg";
    }, AI = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(xo, $([
                    lf($([
                        l("list__item__addon", !0),
                        l("list__item__addon--bullet", !n),
                        l("list__item__addon--number", 1 === n)
                    ]))
                ]), $([
                    A2(xo, $([
                        df("list__item__addon-wrapper")
                    ]), g)
                ]));
            case 1:
                var t = r.a;
                return A2(xo, $([
                    lf($([
                        l("list__item__addon", !0),
                        l("list__item__addon--icon", !0)
                    ]))
                ]), $([
                    A2(xo, $([
                        df("list__item__addon-wrapper")
                    ]), $([
                        jp(t)
                    ]))
                ]));
            default:
                var e = r.a;
                return A2(xo, $([
                    lf($([
                        l("list__item__addon", !0),
                        l("list__item__addon--icon", !0)
                    ]))
                ]), $([
                    A2(xo, $([
                        df("list__item__addon-wrapper")
                    ]), $([
                        (u = e, a = u.I, i = u.b6, o = u.dF, c = u.a3, f = u.b0, s = u.b_, d = u.bW, b = u.bT, A2(Sg, A2(ff, u.a9, A2(su, EI(u.fI), $([
                            A3(II, b, s, f),
                            df(NI(c)),
                            A2($f, Zp, d),
                            A2($f, Rp, s),
                            A2($f, xl, f),
                            $l(Sl(s) && Sl(f)),
                            A2(cf, "data-name", KI(o)),
                            yI(i),
                            zI(a),
                            Mg(kI(o))
                        ]))), g))
                    ]))
                ]));
        }
        var u, a, i, o, c, f, s, d, b;
    }), HI = F2(function(n, r) {
        return A3(Rv, Hl(n), r, A2(xo, g, $([
            r
        ])));
    }), SI = F2(function(n, r) {
        return A3(Rv, Hl(n), ko(r), A2(cp, g, $([
            ko(r)
        ])));
    }), MI = F4(function(n, r, t, e) {
        var u = e.bK, a = e.a3, i = e.m, o = e.dh, c = e.fU, f = e.et;
        return A2(xo, A2(ff, e.a9, $([
            lf(h($([
                l("list__item", !0),
                l("list__item__wrapper", !0),
                l("list__item--with-action", Hl(i)),
                l("list__item--with-addon", Hl(o)),
                l("list__item--emphasis-text", 1 === r)
            ]), a)),
            A2($f, Af, u)
        ])), $([
            A2(xI, $([
                df("list__item__title")
            ]), $([
                Jb(A2(si, AI(n), o)),
                A2(Pp, SI(o), c)
            ])),
            A2($I, $([
                lf($([
                    l("list__item__text", !0),
                    l("list__item__text--orientation-block", Hl(o) && !t)
                ]))
            ]), $([
                A2(Pp, HI(i), f),
                A2(Pp, CI, i)
            ]))
        ]));
    }), FI = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), PI = F2(function(n, r) {
        return v(r, {
            c3: n
        });
    }), DI = F2(function(n, r) {
        return il(A2(PI, function(n) {
            switch(n){
                case 0:
                    return "strong";
                case 1:
                    return Md;
                case 2:
                    return "h3";
                case 3:
                    return "h4";
                case 4:
                    return "h5";
                default:
                    return "h6";
            }
        }(n), A2(FI, $([
            l("list__item__title", !0)
        ]), K_(ko(r)))));
    }), LI = F4(function(n, r, t, e) {
        var u = e.bK, a = e.a3, i = e.m, o = e.dh, c = e.fU, f = e.et;
        return A2(F_, A2(ff, e.a9, $([
            lf(h($([
                l("list__item", !0),
                l("list__item--with-addon", Hl(o)),
                l("list__item--with-action", Hl(i)),
                l("list__item--emphasis-text", 1 === t)
            ]), a)),
            A2($f, Af, u)
        ])), $([
            Jb(A2(si, AI(n), o)),
            A2(xo, $([
                df("list__item__wrapper")
            ]), $([
                A2(Pp, DI(r), c),
                Jb(A2(si, A2(qe, pl, cp($([
                    df("list__item__text")
                ]))), f))
            ])),
            A2(Pp, CI, i)
        ]));
    }), BI = F5(function(n, r, t, e, u) {
        return 2 === n ? A4(MI, n, t, e, u) : A4(LI, n, r, t, u);
    }), RI = Bn("dl"), UI = Bn("ol"), VI = function(n) {
        switch(n){
            case 0:
                return P_;
            case 1:
                return UI;
            default:
                return RI;
        }
    }, TI = F2(function(n, r) {
        switch(n.$){
            case 0:
            case 1:
                return lf(g);
            case 2:
                var t = n.a;
                return A2(cf, "style", A2($t, ";", $([
                    "--pyx-list-item-counter: " + wt(r),
                    "--pyx-list-max-columns: " + wt(t)
                ])));
            default:
                return t = n.a, A2(cf, "style", A2($t, ";", $([
                    "--pyx-list-item-counter: " + wt(r),
                    "--pyx-list-max-columns: " + wt(t)
                ])));
        }
    }), jI = function(n) {
        var r = n.c5, t = n.bf, e = n.fI, u = n.co, a = n.bK, i = n.a3, o = n.bp, c = n.cn, f = n.cm, s = n.cW, d = n.b9, b = n.dP;
        return A3(VI, b, A2(ff, n.a9, $([
            lf($([
                l("list", !0),
                l(A3(_I, c, s, f), !0),
                l(hI(e), !0),
                l(mI(f), !0),
                l("list--with-divider", d),
                l(wI(s), !0)
            ])),
            A2(TI, s, It(u)),
            lf(i),
            A2($f, hf, o),
            A2($f, Af, a)
        ])), A2(Fe, A4(BI, b, r, t, f), u));
    }, OI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, GI = F2(function(n, r) {
        return {
            a3: g,
            a9: g,
            dr: mt,
            p: r,
            bp: n,
            dW: mt,
            bK: mt,
            c8: 1
        };
    }), qI = F2(function(n, r) {
        return v(r, {
            dW: vt(n)
        });
    }), WI = F2(function(n, r) {
        return v(r, {
            c8: n ? 1 : 0
        });
    }), JI = function(n) {
        return A2(Fe, function(n) {
            return A2(qI, OI, A2(WI, 1, A2(GI, n.a, n.b)));
        }, at(n.dx.fO));
    }, YI = {
        a3: g,
        a9: g,
        b9: !1,
        bf: 0,
        bp: mt,
        cm: 0,
        cn: 1,
        co: g,
        dP: 0,
        cW: gI,
        fI: 1,
        bK: mt,
        c5: 1
    }, ZI = F2(function(n, r) {
        return v(r, {
            bQ: vt(n)
        });
    }), QI = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), XI = F2(function(n, r) {
        return v(r, {
            as: vt(n)
        });
    }), nN = F2(function(n, r) {
        return v(r, {
            et: vt(n)
        });
    }), rN = F2(function(n, r) {
        return v(r, {
            co: n
        });
    }), tN = F2(function(n, r) {
        return v(r, {
            aF: vt(n)
        });
    }), eN = F2(function(n, r) {
        return v(r, {
            bD: n
        });
    }), uN = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), aN = function(n) {
        return vt(_l($([
            il(A2(ll, 0, Kd(ko("Per poter gestire la richiesta, abbiamo bisogno di:")))),
            jI(A2(rN, $([
                A2(nN, ko("Documento di identit\xe0 della persona interessata (fronte e retro)"), ry),
                A2(nN, ko("Tuo documento di identit\xe0 (fronte e retro)"), ry),
                A2(nN, ko("Delega o documento che attesti la rappresentanza (es. mandato/procura)"), ry)
            ]), A2(QI, $([
                l("gap-0", !0),
                l("margin-b-m", !0)
            ]), YI))),
            A2(vI, n.eo, A3(uN, A2(_o, i(bi(n.dx.fD), vt("REPRESENTATIVE")), n.dx.fO), n.dK, A2(eN, JI(n), A2(XI, Sw("Formati accettati: JPG, PNG o PDF, massimo 10MB"), A2(ZI, "image/png, image/jpeg, application/pdf", A2(tN, "Clicca o trascina qui i file", ny))))))
        ])));
    }, iN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oN = function(n) {
        return qh(A3(jh, iN, n.dx.fP, A3(eg, wo(YC(n)), n.dK, A2(Zh, bp, A2(Xh, "Es. giuliarossi@email.it", A2(Qh, A2(ng, "Indirizzo email", lp), Gh("subjectEmailAddress")))))));
    }, cN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fN = function(n) {
        return qh(A3(jh, cN, n.dx.fQ, A3(eg, $o(YC(n)), n.dK, A2(Xh, "Es. Giulia Rossi", A2(Qh, A2(ng, "Nome e cognome", lp), Gh("subjectFullName"))))));
    }, sN = function(n) {
        return {
            $: 5,
            a: n
        };
    }, dN = function(n) {
        return qh(A3(jh, sN, n.dx.fR, A2(Zh, Yg, A2(Xh, "Es. 333 33333333", A2(Qh, A2(Zg, "Facoltativo, usato come contatto secondario", A2(ng, "Numero di telefono", lp)), Gh("subjectPhoneNumber"))))));
    }, lN = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), bN = function(n) {
        return A2(u_, $([
            sp
        ]), A2(t_, n_($([
            fN(n),
            XC(n),
            ZC(n),
            oN(n),
            dN(n),
            aN(n)
        ])), A2(a_, r_(A2(e_, "Ci servono per identificare la persona nei nostri sistemi", A2(i_, "Inserisci dati della persona per cui stai effettuando la richiesta", rp))), A2(lN, $([
            l("display-none", !YC(n))
        ]), np))));
    }, pN = A2(V_, 5, 0), vN = qh(Y_(A2(X_, No, A2(Z_, $([
        ko("Richieste non pertinenti non verranno prese in considerazione")
    ]), pN)))), mN = function(n) {
        return {
            $: 37,
            a: n
        };
    }, hN = F2(function(n, r) {
        var t = n.bi, e = r.aa, u = r.dK, a = r.bp, i = A2(vp, be, A2(si, A4(Cp, t, u, n.at, r.aP), e));
        return A3(qs, A2($p, t, {
            bp: a,
            dK: u
        }), i, e);
    }), gN = {
        $: 0
    }, _N = {
        $: 1
    }, wN = function(n) {
        return gh(n);
    }, $N = function(n) {
        return si(Xu(eh(n)));
    }, xN = F3(function(n, r, t) {
        return A2(Hs, A2(wN, n, t), A2($N, t, r));
    }), CN = F2(function(n, r) {
        return v(r, {
            bW: n
        });
    }), yN = F2(function(n, r) {
        return v(r, {
            bK: n
        });
    }), IN = F2(function(n, r) {
        return v(r, {
            bp: n
        });
    }), NN = F3(function(n, r, t) {
        var e = t.bK, u = t.bp, a = t.aH, i = t.b8, o = t.b1, c = t.fp;
        return A2(CN, A3(xN, r, t.as, u), A2(IN, vt(u), A2(yN, e, A2($w, a, A2(_w, i, A2(ww, o, A4(gw, F2(function(r, t) {
            return n(function(n) {
                return {
                    $: 2,
                    a: n
                };
            }(t));
        }), n(_N), n(gN), c)))))));
    }), EN = F5(function(n, r, t, e, u) {
        return A4(yw, t, e, Hl(u), A3(NN, n, u, t));
    }), zN = F3(function(n, r, t) {
        var e = r.at, u = t, a = A2(hN, r, t);
        return A2(ih, a, A2(Rh, u.bS, A2(Uh, u.a3, A2(Vh, u.cd, A2(pp, {
            as: u.as,
            bp: u.bp,
            aH: u.aH
        }, A5(EN, n, r, t, e, a))))));
    }), KN = F2(function(n, r) {
        return v(r, {
            b1: n
        });
    }), kN = F2(function(n, r) {
        return v(r, {
            bJ: vt(n)
        });
    }), AN = F3(function(n, r, t) {
        return v(t, {
            aa: vt(1),
            dK: r,
            aP: vt(A2(qe, n, tg))
        });
    }), HN = function(n) {
        var r;
        return qh(A3(zN, mN, n.dx.fB, A3(AN, vo, n.dK, A2(KN, A2(cp, g, $([
            ko("Dichiaro di aver letto e compreso l'"),
            Mf(A2(kN, "_blank", A2(Ff, "http://www.prima.it/privacy", A2(Pf, ko("Informativa Privacy"), af)))),
            ko(" e di essere consapevole che il presente modulo \xe8 dedicato esclusivamente all'esercizio dei diritti in materia di protezione dei dati personali.")
        ])), (r = "privacyDeclaration", {
            bS: mt,
            b1: ko(""),
            a3: g,
            a9: g,
            b8: !1,
            aa: mt,
            cd: mt,
            as: mt,
            bp: "id-" + r,
            dK: !1,
            fp: r,
            aH: !1,
            ej: !1,
            bK: mt,
            aP: mt
        })))));
    }, SN = function(n) {
        return v(n, {
            fI: 0
        });
    }, MN = F2(function(n, r) {
        return v(r, {
            I: n
        });
    }), FN = F2(function(n, r) {
        return v(r, {
            cp: n
        });
    }), PN = function(n) {
        return qh(Qv(A2(um, Qb, v(A2(am, SN, A2(FN, "Invio in corso...", A2(MN, i(n.ea, za), A2(wm, "Invia richiesta", A2(rm, $([
            l("margin-v-m", !0)
        ]), iI))))), {
            aR: 1
        }))));
    }, DN = function(n) {
        return A2(t_, n_($([
            HN(n),
            vN,
            PN(n)
        ])), np);
    }, LN = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), BN = F2(function(n, r) {
        return v(r, {
            ar: A2(Fe, A2(du, Wd, !0), n)
        });
    }), RN = F2(function(n, r) {
        return v(r, {
            bC: vt(n)
        });
    }), UN = F2(function(n, r) {
        var t, e, u, a, i, o, c, f, s, d, b, p, v, m;
        return e = (t = A2(RN, Qb, A2(BN, $([
            A2(WC, n.bv, r),
            bN(r),
            hx(r),
            o_(r),
            A2(rw, n.bv, r),
            A2(ow, n.bv, r),
            A2(Jw, n.bv, r),
            A2(E$, n.bv, r),
            A2(r$, n.bv, r),
            A2(jw, n.bv, r),
            A2(g$, n.bv, r),
            DN(r)
        ]), A2(LN, $([
            l("gap-2xl", !0)
        ]), Xb)))).bJ, u = t.bA, a = t.fp, i = t.by, o = t.bg, c = t.ak, f = t.m, s = t.aT, d = t.bK, b = t.bp, p = t.a3, v = t.ar, m = t.bC, A2($x, A2(ff, t.a9, $([
            df("form"),
            lf(p),
            A2($f, hf, b),
            A2($f, gx, s),
            A2($f, _x, f),
            A2($f, cf("autocomplete"), c),
            A2($f, wx, o),
            A2($f, xx, i),
            A2($f, xh, a),
            A2($f, Cx, u),
            A2($f, Jv, e),
            A2($f, Af, d),
            A2($f, Nx, m)
        ])), A2(Fe, A2(qe, te, eC), A2(oi, $a, v)));
    }), VN = F2(function(n, r) {
        return A2(jd, g, $([
            Zb,
            ml($([
                bl,
                A2(UN, n, r)
            ]))
        ]));
    }), TN = {
        $: 43
    }, jN = {
        dN: "adjustments-horizontal",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.879 3.879A3 3 0 0 1 16.829 5H20a1 1 0 1 1 0 2h-3.172a2.999 2.999 0 0 1-5.656 0H4a1 1 0 0 1 0-2h7.172c.147-.418.387-.802.707-1.121M15 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0M5.879 9.879A3 3 0 0 1 10.829 11H20a1 1 0 1 1 0 2h-9.172a2.999 2.999 0 0 1-5.656 0H4a1 1 0 1 1 0-2h1.172a3 3 0 0 1 .707-1.121m2.828 1.414a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414M17 15a3 3 0 0 0-2.828 2H4a1 1 0 1 0 0 2h10.172a2.999 2.999 0 0 0 5.656 0H20a1 1 0 1 0 0-2h-.172A3 3 0 0 0 17 15m1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0" clip-rule="evenodd"/></svg>'
    }, ON = {
        m: mt,
        bR: mt,
        aV: {
            dN: "chevron-right",
            a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.282 18.72a.95.95 0 0 1 0-1.354L14.68 12 9.282 6.634a.95.95 0 0 1 0-1.353.966.966 0 0 1 1.362 0l6.074 6.038a.95.95 0 0 1 0 1.353l-6.074 6.047a.966.966 0 0 1-1.362 0"/></svg>'
        },
        dh: mt,
        al: 0,
        a3: g,
        O: mt,
        a9: g,
        bj: mt,
        bm: mt,
        bp: mt,
        fI: 1,
        bK: mt
    }, GN = {
        dN: "cross-circle",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2m0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0"/><path d="m13.41 12 2.48-2.48a.996.996 0 1 0-1.41-1.41L12 10.59 9.52 8.11a.996.996 0 1 0-1.41 1.41L10.59 12l-2.48 2.48a.996.996 0 1 0 1.41 1.41L12 13.41l2.48 2.48a.996.996 0 1 0 1.41-1.41z"/></svg>'
    }, qN = {
        aY: g,
        O: mt,
        aK: mt,
        fU: mt
    }, WN = {
        dN: "magnifying-glass",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m22.698 21.24-6.024-6.023a8.76 8.76 0 0 0-.684-11.642A8.8 8.8 0 0 0 9.782 1 8.793 8.793 0 0 0 1 9.782a8.793 8.793 0 0 0 8.782 8.783 8.76 8.76 0 0 0 5.435-1.89l6.024 6.023a1.03 1.03 0 1 0 1.457-1.457M9.782 16.499c-3.699 0-6.716-3.017-6.716-6.716s3.017-6.716 6.716-6.716 6.716 3.017 6.716 6.716-3.017 6.716-6.716 6.716"/></svg>'
    }, JN = {
        dN: "paper-plane",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.509 11.17 4.47 2.134A1 1 0 0 0 3.983 2c-.596 0-1.124.553-.948 1.202l2.345 8.55a.86.86 0 0 1 0 .496l-2.345 8.55c-.176.649.342 1.202.948 1.202a.9.9 0 0 0 .488-.134L20.51 12.83a.947.947 0 0 0 0-1.66m-4.134-.124H7.218L5.537 4.939zm-9.157 1.908h9.157L5.537 19.061z"/></svg>'
    }, YN = "span", ZN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QN = F2(function(n, r) {
        return v(r, {
            dh: vt(ZN(n))
        });
    }), XN = F4(function(n, r, t, e) {
        return n ? vt(A2(QN, Bp(r), A2(nN, A2(xo, g, $([
            il(A2(PI, YN, A2(dl, 0, A2(sl, 4, Kd(ko(t)))))),
            il(A2(PI, YN, Kd(ko(e))))
        ])), ry))) : mt;
    }), nE = {
        dN: "reload",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22 0c-.55 0-1 .45-1 1v2.08c-4.71-4.23-11.97-4.09-16.49.44-4.68 4.68-4.68 12.29 0 16.97A11.96 11.96 0 0 0 13 24c3.08 0 6.15-1.17 8.49-3.51a.996.996 0 1 0-1.41-1.41c-3.9 3.9-10.25 3.9-14.15 0s-3.9-10.25 0-14.15 10.25-3.9 14.15 0c.02.03.06.04.1.07H17c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1"/></svg>'
    }, rE = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "card--neutral";
            case 2:
                return "card--brand";
            case 3:
                return "card--action";
            case 4:
                return "card--success";
            case 5:
                return "card--alert";
            case 6:
                return "card--error";
            case 7:
                return "card--surface-strong";
            default:
                return "card--surface-on-surface-strong";
        }
    }, tE = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "card--m";
            default:
                return "card--l";
        }
    }, eE = function(n) {
        var r = n;
        return It(A2(oi, be, $([
            Hl(r.bm),
            Hl(r.O),
            Hl(r.bj)
        ])));
    }, uE = function(n) {
        return 2 === n;
    }, aE = function(n) {
        return 1 === n;
    }, iE = F2(function(n, r) {
        return A2(Uu, !1, A2(si, A2(qe, function(n) {
            return n.r;
        }, n), r));
    }), oE = function(n) {
        n: for(; !n.$;)switch(n.a.$){
            case 0:
            case 3:
            case 5:
            case 1:
                return !0;
            default:
                break n;
        }
        return !1;
    }, cE = function(n) {
        n: for(; !n.$;)switch(n.a.$){
            case 5:
            case 1:
                return !0;
            default:
                break n;
        }
        return !1;
    }, fE = function(n) {
        return A2(xo, $([
            df("card__action")
        ]), $([
            jp(A2(Fx, $([
                l("card__header__action__icon", !0)
            ]), Bp(n)))
        ]));
    }, sE = F2(function(n, r) {
        return A2(xo, $([
            df("card__action-wrapper")
        ]), $([
            A2(Pp, function(n) {
                return A2(cp, g, $([
                    ko(n)
                ]));
            }, r),
            fE(n)
        ]));
    }), dE = F2(function(n, r) {
        var t = n.m;
        return A3(uv, cE(t), A2(sE, r, function(n) {
            n: for(; !n.$;)switch(n.a.$){
                case 5:
                    return n.a.c;
                case 1:
                    return n.a.a;
                default:
                    break n;
            }
            return mt;
        }(t)), fE(r));
    }), lE = function(n) {
        return A2(xo, $([
            df("card__addon")
        ]), $([
            function() {
                switch(n.$){
                    case 0:
                        return jp(n.a);
                    case 1:
                        return A2(Sg, $([
                            Mg(n.a),
                            Hg(48),
                            Fg(48)
                        ]), g);
                    default:
                        return n.a;
                }
            }()
        ]));
    }, bE = function(n) {
        return A2(xo, $([
            df("card__content")
        ]), $([
            n
        ]));
    }, pE = function(n) {
        return A2(xo, $([
            df("card__footer")
        ]), $([
            n
        ]));
    }, vE = function(n) {
        return !n;
    }, mE = F2(function(n, r) {
        return A2(Uv, n(r.r), lE(r.W));
    }), hE = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), gE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _E = F2(function(n, r) {
        return A3(Jy, n, vt(r), 0);
    }), wE = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $E = F2(function(n, r) {
        return v(r, {
            dE: wE(n)
        });
    }), xE = F4(function(n, r, t, e) {
        var u;
        return Qv(e(A2(Uu, u = A2($E, r, A2(am, Xv, A2(wm, n, mv))), A2(si, function(n) {
            return A2(nm, n, u);
        }, t))));
    }), CE = function(n) {
        return A2(cp, $([
            df("card__header__subtitle")
        ]), $([
            n
        ]));
    }, yE = function(n) {
        return A2(cp, $([
            df("card__header__title")
        ]), $([
            n
        ]));
    }, IE = function(n) {
        var r = l(n.fU, n.aK);
        if (1 === r.a.$) return 1 === r.b.$ ? yl : A2(xo, g, $([
            CE(t = r.b.a)
        ]));
        if (1 === r.b.$) return A2(xo, g, $([
            yE(r.a.a)
        ]));
        var t = r.b.a;
        return A2(xo, g, $([
            yE(r.a.a),
            CE(t)
        ]));
    }, NE = F5(function(n, r, t, e, u) {
        n: for(;;){
            var a = t;
            switch(u.$){
                case 0:
                    return A2(xo, g, $([
                        A2(zf, $([
                            yf(c = u.a),
                            df("card__header__action"),
                            A2($f, cf("aria-label"), e)
                        ]), $([
                            A2(cp, $([
                                df("card__header__action__focus"),
                                A2(Nf, !!n, A2(cf, "data-style", "default"))
                            ]), g),
                            Jb(a.fU)
                        ])),
                        Jb(a.aK)
                    ]));
                case 3:
                    var i = u.b;
                    return A2(xo, g, $([
                        A2(Ef, $([
                            vf(f = u.a),
                            df("card__header__action"),
                            Jv(i),
                            A2($f, cf("aria-label"), e)
                        ]), $([
                            A2(cp, $([
                                df("card__header__action__focus"),
                                A2(Nf, !!n, A2(cf, "data-style", "default"))
                            ]), g),
                            Jb(a.fU)
                        ])),
                        Jb(a.aK)
                    ]));
                case 2:
                    var o = u.a, c = u.b;
                    return A2(xo, $([
                        df("card__header__content__inline-action")
                    ]), $([
                        IE(t),
                        A4(xE, o, r, e, um(c))
                    ]));
                case 4:
                    o = u.a;
                    var f = u.b;
                    return i = u.c, A2(xo, $([
                        df("card__header__content__inline-action")
                    ]), $([
                        IE(t),
                        A4(xE, o, r, e, im(A2(_E, f, i)))
                    ]));
                case 5:
                    u = A2(hE, f = u.a, i = u.b);
                    continue n;
                default:
                    u = gE(c = u.b);
                    continue n;
            }
        }
    }), EE = F5(function(n, r, t, e, u) {
        var a, i = e;
        return $([
            A2(Uv, !no(i.aY), (a = i.aY, A2(xo, $([
                df("display-flex gap-2xs")
            ]), A2(Fe, fv, a)))),
            A2(Uu, IE(e), A2(si, A4(NE, n, r, e, u), t)),
            Jb(i.O)
        ]);
    }), zE = F2(function(n, r) {
        var t = n.dh, e = function(n) {
            return Jb(A2(si, mE(n), t));
        }, u = A5(EE, n.al, n.aV, n.m, r, n.bR);
        return A2(xo, $([
            df("card__header")
        ]), A2(iE, uE, t) ? $([
            A2(xo, $([
                df("card__header__content")
            ]), $([
                e(uE),
                A2(xo, g, u)
            ]))
        ]) : A2(et, e(vE), u));
    }), KE = function(n) {
        switch(n){
            case 0:
            case 7:
            default:
                return "default";
            case 1:
            case 3:
            case 5:
            case 2:
            case 4:
            case 6:
                return "vibrant";
        }
    }, kE = function(n) {
        var r = n;
        return A2(xo, A2(ff, r.a9, $([
            lf($([
                l("card", !0),
                l(tE(r.fI), !0),
                l("card--with-action", oE(r.m)),
                l("card--with-action-bottom", cE(r.m)),
                l("card--with-addon", Hl(r.dh)),
                l("card--with-addon--left", A2(iE, aE, r.dh)),
                l("card--with-addon--header", A2(iE, uE, r.dh)),
                l("card--with-single-row", 1 === eE(r)),
                l(rE(r.al), !0)
            ])),
            lf(r.a3),
            A2($f, hf, r.bp),
            A2($f, Af, r.bK),
            A2(cf, "data-style", KE(r.al))
        ])), $([
            A2(Uv, A2(iE, aE, r.dh), Jb(A2(si, A2(qe, function(n) {
                return n.W;
            }, lE), r.dh))),
            A2(xo, $([
                df("card__wrapper")
            ]), $([
                Jb(A2(si, zE(r), r.bm)),
                Jb(A2(si, bE, r.O)),
                Jb(A2(si, pE, r.bj))
            ])),
            A2(Uv, oE(r.m), A2(dE, r, r.aV))
        ]));
    }, AE = {
        dN: "trash-bin",
        a: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14 1h-4c-1.1 0-2 .9-2 2h8c0-1.1-.9-2-2-2m7 3H3c-.55 0-1 .45-1 1s.45 1 1 1h.54v12c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5V6H21c.55 0 1-.45 1-1s-.45-1-1-1m-2.46 14c0 1.65-1.35 3-3 3h-7c-1.65 0-3-1.35-3-3V6h13z"/><path d="M9 19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1m6 0c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1"/></svg>'
    }, HE = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), SE = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), ME = F2(function(n, r) {
        return v(r, {
            O: vt(n)
        });
    }), FE = F2(function(n, r) {
        return v(r, {
            bm: vt(n)
        });
    }), PE = F2(function(n, r) {
        return v(r, {
            fU: vt(n)
        });
    }), DE = F2(function(n, r) {
        return v(r, {
            fI: n
        });
    }), LE = F2(function(n) {
        return A2(jd, g, $([
            ml($([
                Ux(A2(HE, $([
                    l("margin-t-2xl", !0)
                ]), A2(DE, 2, A2(Vx, 2, Ax(Co)))))
            ])),
            ml($([
                il(A2(dl, 0, A2(ll, 0, Fd(ko("La tua richiesta \xe8 stata inoltrata, " + ni(n.dx.fz))))))
            ])),
            ml($([
                il(A2(PI, YN, A2(sl, 19, A2(ll, 1, A2(dl, 1, K_(ko("Ti forniremo riscontro entro un mese dal ricevimento della presente comunicazione, come previsto dalla normativa, all'indirizzo email "))))))),
                il(A2(PI, YN, A2(sl, 19, A2(ll, 1, A2(dl, 0, K_(ko(ni(n.dx.fx))))))))
            ])),
            ml($([
                Qv(A2(um, TN, A2(wm, "Torna alla homepage", _m)))
            ])),
            ml($([
                kE(A2(SE, $([
                    l("margin-b-2xl", !0)
                ]), A2(ME, jI(A2(rN, n_($([
                    A4(XN, n.dx.eO, WN, "Accesso ai dati", " (art. 15)"),
                    A4(XN, n.dx.eQ, jN, "Rettifica dei dati", " (art. 16)"),
                    A4(XN, n.dx.eS, AE, "Cancellazione dei dati", " (art. 17)"),
                    A4(XN, n.dx.e4, nE, "Limitazione del trattamento", " (art. 18)"),
                    A4(XN, n.dx.eU, GN, "Opposizione al trattamento", " (art. 21)"),
                    A4(XN, n.dx.eY, JN, "Portabilit\xe0 dei dati", " (art. 20)"),
                    A4(XN, n.dx.eL, yo, "Revoca del consenso", " (art. 7)")
                ])), YI)), A2(FE, A2(PE, A2(fm, $([
                    df("pyx-typo-title-m-bold margin-b-l")
                ]), $([
                    ko("Hai richiesto")
                ])), qN), ON))))
            ]))
        ]));
    }), BE = function(n) {
        return Rn(Qn(n));
    }, RE = A2(qe, wt, A2(qe, A2(du, gt, "px"), A2(qe, gt("--pyx-toaster-offset-bottom: "), cf("style")))), UE = A2(qe, wt, A2(qe, A2(du, gt, "px"), A2(qe, gt("--pyx-toaster-offset-top: "), cf("style")))), VE = function(n) {
        switch(n){
            case 0:
                return "toaster--top";
            case 2:
                return "toaster--bottom";
            default:
                return "toaster--top-right";
        }
    }, TE = Tn, jE = function(n) {
        return {
            $: 4,
            a: n
        };
    }, OE = function(n) {
        return {
            $: 5,
            a: n
        };
    }, GE = function(n) {
        return A2($t, "-", $([
            "toast",
            n
        ]));
    }, qE = F2(function(n, r) {
        var t = l(n, r);
        return !t.a.$ || 1 === t.b.$;
    }), WE = function(n) {
        return A2(Cf, "mouseleave", de(n));
    }, JE = function(n) {
        return A2($t, "--", $([
            "toast",
            n
        ]));
    }, YE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZE = A2(qe, Bp, A2(qe, Op(1), jp)), QE = F3(function(n, r, t) {
        return A2(zf, $([
            df("toast__close"),
            yf(n(YE(r))),
            Rp(t)
        ]), $([
            ZE(bv)
        ]));
    }), XE = function(n) {
        var r = n.a, t = n.b;
        return $([
            A2(xo, $([
                df("toast__action")
            ]), $([
                Qv(A2(um, t, A2(wm, r, A2(am, Xv, iI))))
            ]))
        ]);
    }, nz = F2(function(n, r) {
        if (r.$) {
            var t = r.a, e = r.b;
            return $([
                A2(xo, $([
                    df("toast__content")
                ]), $([
                    A2(fm, $([
                        hf(GE(n))
                    ]), $([
                        ko(e)
                    ])),
                    A2(xo, $([
                        df("toast__text")
                    ]), $([
                        t
                    ]))
                ]))
            ]);
        }
        var u = r.a;
        return $([
            A2(xo, $([
                df("toast__text"),
                hf(GE(n))
            ]), $([
                ko(u)
            ]))
        ]);
    }), rz = F3(function(n, r, t) {
        return A2(xo, $([
            df("toast__content-wrapper")
        ]), A2(su, A2(nz, n, r), A2(Uu, g, A2(si, XE, t))));
    }), tz = function(n) {
        return A2(xo, $([
            df("toast__icon")
        ]), $([
            ZE(n)
        ]));
    }, ez = Gn("color"), uz = Nl("line"), az = Gn("pathLength"), iz = Gn("preserveAspectRatio"), oz = Gn("stroke"), cz = Gn("stroke-linecap"), fz = Gn("stroke-width"), sz = Gn("x1"), dz = Gn("x2"), lz = Gn("y1"), bz = Gn("y2"), pz = A2(xo, $([
        df("toast__loader")
    ]), $([
        A2(Rl, $([
            kl("0 0 100 2"),
            iz("none"),
            Cl("toast__loader")
        ]), $([
            A2(uz, $([
                sz("0"),
                lz("0"),
                dz("100"),
                bz("0"),
                fz("12"),
                cz("round"),
                ez("transparent"),
                az("1"),
                Cl("toast__loader__background")
            ]), g),
            A2(uz, $([
                sz("0"),
                lz("0"),
                dz("100"),
                bz("0"),
                oz("purple"),
                fz("12"),
                cz("round"),
                ez("transparent"),
                az("100"),
                Cl("toast__loader__line")
            ]), g)
        ]))
    ])), vz = F2(function(n, r) {
        return A2(qE, n, r) ? "alertdialog" : "alert";
    }), mz = function(n) {
        switch(n){
            case 0:
                return "neutral";
            case 1:
                return "brand";
            case 2:
                return "alert";
            case 3:
                return "success";
            case 4:
                return "error";
            default:
                return "informative";
        }
    }, hz = function(n) {
        return A3(du, gt, "ms", wt(n));
    }, gz = F2(function(n, r) {
        var t, e = r.cB, u = r.da, a = r.et, i = r.bK, o = r.bw, c = r.bp, f = r.dE, s = r.be, d = r.b2, b = r.a3, p = r.m;
        return A2(xo, A2(ff, r.a9, $([
            lf($([
                l("toast", !0),
                l(JE(mz(u)), !0),
                l("toast--with-icon", Hl(f))
            ])),
            lf(b),
            Bl(A2(vz, p, a)),
            A2(Nf, A2(qE, p, a), xl(GE(c))),
            A2($f, A2(qe, de, Cf("transitionend")), e),
            A2($f, Af, i),
            A2(cf, "style", "--pyx-toast-duration: " + hz(s)),
            (t = n(jE(c)), A2(Cf, "mouseenter", de(t))),
            WE(n(OE(c)))
        ])), $([
            Jb(A2(si, tz, f)),
            A3(rz, c, a, p),
            A3(QE, n, c, d),
            A2(Uv, !o, pz)
        ]));
    }), _z = F2(function(n, r) {
        return v(r, {
            cB: vt(n)
        });
    }), wz = F2(function(n, r) {
        return v(r, {
            a3: n
        });
    }), $z = F3(function(n, r, t) {
        switch(t.$){
            case 0:
            default:
                return A2(gz, n, e = t.b);
            case 1:
                var e = t.a;
                return A2(gz, n, A2(_z, n(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(r)), A2(wz, $([
                    l("toast--fade-out", !0)
                ]), e)));
            case 2:
                return A2(gz, n, e = t.a);
        }
    }), xz = F2(function(n, r) {
        var t = r.a;
        return l(t, A4(TE, $z, n, t, r.b));
    }), Cz = F3(function(n, r, t) {
        var e = r.eu, u = t.bK, a = t.cz, i = t.cy, o = t.r, c = t.bp, f = t.b_;
        return A3(BE, "div", A2(ff, t.a9, $([
            lf($([
                l("toaster", !0),
                l(VE(o), !0),
                l("toaster--with-offset", Hl(a)),
                l("toaster--with-bottom-offset", Hl(i))
            ])),
            hf(c),
            Bl("region"),
            Rp(f),
            A2($f, RE, i),
            A2($f, UE, a),
            A2($f, Af, u)
        ])), A2(Fe, xz(n), at(e)));
    }), yz = F2(function(n, r) {
        return v(r, {
            cy: vt(n)
        });
    }), Iz = function(n) {
        return A3(Cz, Qu, n.eu, A2(yz, 100, {
            b_: "Notifications",
            a9: g,
            bp: "toasts",
            cy: mt,
            cz: mt,
            r: 2,
            bK: mt
        }));
    }, Nz = F2(function(n, r) {
        var t, e = 3 === (t = r.ea).$ ? A2(LE, r, t.a) : A2(VN, n, r);
        return A2(xo, $([
            df("gap-m")
        ]), $([
            Iz(r),
            e
        ]));
    }), Ez = (Ub = {
        fk: qu,
        fr: A2(qe, Vu, tt),
        fs: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        fS: function(n) {
            return n.af ? Zu : A2(Yu, Ju, function(n) {
                var r;
                return A2(Yu, Qu, !(r = A2(Fe, $a, at(n.eu.eu))).b || A2(_a, wa, r) ? Zu : A2(ma, 500, Xu({
                    $: 1,
                    a: 500
                })));
            }(n.ae));
        },
        fV: Id,
        fW: function(n) {
            var r;
            return {
                eH: $([
                    n.af ? ko("") : A2(Nd, Ju, A2(Nz, n.ao, n.ae))
                ]),
                fU: (r = n, r.af ? "Moduli Prima.it" : "Modulo di richiesta privacy - Moduli Prima.it")
            };
        }
    }, Vb = Ub.fr, Tb = Ub.fs, jb = function() {
        jb.a(Vb(zr()));
    }, Nr({
        cY: function(n) {
            return jb.a = n, kr.addEventListener("popstate", jb), 0 > kr.navigator.userAgent.indexOf("Trident") || kr.addEventListener("hashchange", jb), F2(function(r, t) {
                if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                    t.preventDefault();
                    var e = r.href, u = zr(), a = Ke(e).a;
                    n(Tb(a && u.d3 === a.d3 && u.dD === a.dD && u.d_.a === a.d_.a ? function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(a) : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e)));
                }
            });
        },
        fk: function(n) {
            return A3(Ub.fk, n, zr(), jb);
        },
        fW: Ub.fW,
        fV: Ub.fV,
        fS: Ub.fS
    }));
    Rb = {
        Main: {
            init: Ez(A2(ce, function(n) {
                return A2(ce, function(r) {
                    return de({
                        bv: r,
                        bG: n
                    });
                }, A2(We, "isMobile", Ge));
            }, A2(We, "rootUrl", Wu)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Rb) : n.Elm = Rb;
}($a0b4f895e1596b3b$exports);


const $dad545c909cfec2d$var$link = document.createElement('link');
$dad545c909cfec2d$var$link.rel = 'canonical';
$dad545c909cfec2d$var$link.href = window.location.origin + window.location.pathname;
document.head.appendChild($dad545c909cfec2d$var$link);
let $dad545c909cfec2d$var$configuration = {
    rootUrl: "",
    isMobile: false
};
(function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) $dad545c909cfec2d$var$configuration.isMobile = true;
})(navigator.userAgent || navigator.vendor || window.opera);
(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("app"),
    flags: $dad545c909cfec2d$var$configuration
});


//# sourceMappingURL=frontend.d3ff24bd.js.map
